(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = "amp-story-360 canvas{position:absolute;width:100%!important;height:100%!important}amp-story-360 amp-img{opacity:0!important}.i-amphtml-story-360-activate-button{position:absolute!important;bottom:12px!important;right:12px!important;background:rgba(0,0,0,0.8)!important;color:#fff!important;outline:none!important;border:none!important;padding:6px 6px 6px 10px!important;border-radius:18px!important;font-size:12px!important;font-family:Roboto,sans-serif!important;z-index:100000!important}.i-amphtml-story-360-activate-button,.i-amphtml-story-360-activate-button-icon{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important}.i-amphtml-story-360-activate-button-icon{box-sizing:border-box!important;margin-left:5px!important;font-size:6px!important;width:24px!important;height:24px!important;border:1px solid #fff!important;border-radius:100%!important;-ms-flex-pack:center!important;justify-content:center!important;font-weight:700!important;position:relative!important}.i-amphtml-story-360-activate-button-icon-svg{position:absolute!important;width:calc(100% + 2px)!important;height:calc(100% + 2px)!important;left:-1px!important;top:-1px!important}[active] .i-amphtml-story-360-activate-button-icon-svg{animation:rotate 1s 1s!important}@keyframes rotate{to{transform:rotate(360deg)}}.i-amphtml-story-360-discovery{pointer-events:none!important;position:absolute!important;bottom:0!important;left:0!important;width:100%!important;height:66%!important;perspective:550px!important;perspective-origin:50% calc(100% - 145px)!important;background:linear-gradient(transparent,rgba(0,0,0,0.9))!important;animation:fadeOut 1s ease-in-out 4s forwards!important;z-index:100000!important}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.i-amphtml-story-360-discovery-animation{position:absolute!important;bottom:95px!important;left:calc(50% - 30px)!important;width:55px!important;height:100px!important;border:1px solid #fff!important;border-radius:10px!important;animation:lookAround 4s!important}.i-amphtml-story-360-discovery-animation:before{content:\"\"!important;position:absolute!important;border-top:1px solid #fff!important;width:10px!important;top:5px!important;left:calc(50% - 5px)!important}@keyframes lookAround{0%{animation-timing-function:ease-in-out;transform:rotate3d(0,0,0,0) translateZ(0)}25%{animation-timing-function:ease-in-out;transform:rotateY(45deg) rotateX(20deg) translate3d(-100px,10px,0)}50%{animation-timing-function:ease-in-out;transform:rotateX(-40deg) translate3d(0,-50px,0)}75%{animation-timing-function:ease-in-out;transform:rotateY(-45deg) rotateX(20deg) translate3d(100px,10px,0)}to{animation-timing-function:ease-in-out;transform:rotate3d(0,0,0,0) translateZ(0)}}.i-amphtml-story-360-discovery-text{font-family:Roboto,sans-serif!important;position:absolute!important;bottom:40px!important;width:100%!important;font-size:16px!important;text-align:center!important;color:#fff!important}\n/*# sourceURL=/extensions/amp-story-360/0.1/amp-story-360.css*/";
exports.CSS = CSS;

},{}],2:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStory360 = void 0;

var _resolvedPromise3 = require("./../../../src/resolved-promise");

var _ampStoryStoreService = require("../../../extensions/amp-story/1.0/amp-story-store-service");

var _ampStory = require("../../../build/amp-story-360-0.1.css");

var _commonSignals = require("../../../src/common-signals");

var _localizedStrings = require("../../../src/localized-strings");

var _zuho = require("../../../third_party/zuho/zuho");

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _log = require("../../../src/log");

var _staticTemplate = require("../../../src/static-template");

var _layout = require("../../../src/layout");

var _eventHelper = require("../../../src/event-helper");

var _utils = require("../../../extensions/amp-story/1.0/utils");

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    <div class=\"i-amphtml-story-360-discovery\" aria-live=\"polite\">\n      <div class=\"i-amphtml-story-360-discovery-animation\"></div>\n      <span class=\"i-amphtml-story-360-discovery-text\" aria-hidden=\"true\">\n        Move device to explore\n      </span>\n    </div>\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    <button class=\"i-amphtml-story-360-activate-button\" role=\"button\">\n      <span class=\"i-amphtml-story-360-activate-text\"></span>\n      <span class=\"i-amphtml-story-360-activate-button-icon\"\n        >360\xB0\n        <svg\n          class=\"i-amphtml-story-360-activate-button-icon-svg\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"24\"\n          height=\"24\"\n          viewBox=\"0 0 24 24\"\n          fill=\"none\"\n        >\n          <defs>\n            <linearGradient id=\"i-amphtml-story-360-activate-gradient\">\n              <stop stop-color=\"white\" stop-opacity=\".3\"></stop>\n              <stop offset=\"1\" stop-color=\"white\"></stop>\n            </linearGradient>\n            <ellipse\n              id=\"i-amphtml-story-360-activate-ellipse\"\n              ry=\"11.5\"\n              rx=\"7.5\"\n              cy=\"12\"\n              cx=\"12\"\n              stroke=\"url(#i-amphtml-story-360-activate-gradient)\"\n            ></ellipse>\n          </defs>\n          <use xlink:href=\"#i-amphtml-story-360-activate-ellipse\"></use>\n          <use\n            xlink:href=\"#i-amphtml-story-360-activate-ellipse\"\n            transform=\"rotate(90, 12, 12)\"\n          ></use>\n        </svg>\n      </span>\n    </button>\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/** @const {string} */
var TAG = 'AMP_STORY_360';

/**
 * readyState for first rendrable frame of video element.
 * @const {number}
 */
var HAVE_CURRENT_DATA = 2;

/**
 * Centers heading and pitch value between [-90; 90]
 * @const {number}
 */
var CENTER_OFFSET = 90;

/**
 * Minimum distance from active page to activate WebGL context.
 * @const {number}
 */
var MIN_WEBGL_DISTANCE = 2;

/**
 * Generates the template for the permission button.
 *
 * @param {!Element} element
 * @return {!Element}
 */
var buildActivateButtonTemplate = function buildActivateButtonTemplate(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject());
};

/**
 * Generates the template for the gyroscope feature discovery animation.
 *
 * NOTE: i-amphtml-story-360-discovery is used in maybeShowDiscoveryAnimation_
 * and must be changed in both places if updated.
 *
 * @param {!Element} element
 * @return {!Element}
 */
var buildDiscoveryTemplate = function buildDiscoveryTemplate(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject2());
};

/**
 * @param {number} deg
 * @return {number}
 * */
function deg2rad(deg) {
  return deg * Math.PI / 180;
}

/**
 * Internal helper class representing a camera orientation (POV) in polar
 * coordinates.
 */
var CameraOrientation = /*#__PURE__*/function () {
  /**
   * @param {number} theta
   * @param {number} phi
   * @param {number} scale
   */
  function CameraOrientation(theta, phi, scale) {
    _classCallCheck(this, CameraOrientation);

    this.theta = theta;
    this.phi = phi;
    this.scale = scale;
  }

  /**
   * @param {number} heading
   * @param {number} pitch
   * @param {number} zoom
   * @return {!CameraOrientation}
   */
  _createClass(CameraOrientation, [{
    key: "rotation",

    /**
     * @return {!Float32Array}
     */
    get: function get() {
      return _zuho.Matrix.mul(3, _zuho.Matrix.rotation(3, 1, 2, this.theta), _zuho.Matrix.rotation(3, 0, 1, this.phi));
    }
  }], [{
    key: "fromDegrees",
    value: function fromDegrees(heading, pitch, zoom) {
      return new CameraOrientation(deg2rad(-pitch - CENTER_OFFSET), deg2rad(CENTER_OFFSET + heading), 1 / zoom);
    }
  }]);

  return CameraOrientation;
}();

/**
 * Internal helper class generating a sequence of frame by frame orientations
 * from a set of 2 or more CameraOrientation target points and an animation
 * duration (approximate duration in ms based on 60FPS refresh rate).
 */
var CameraAnimation = /*#__PURE__*/function () {
  /**
   * @param {number} durationMs
   * @param {!Array<!CameraOrientation>} orientations
   */
  function CameraAnimation(durationMs, orientations) {
    _classCallCheck(this, CameraAnimation);

    this.maxFrame = 60 / 1000 * durationMs;
    this.orientations = orientations;
    this.currentHeadingIndex = 0;
    this.currentFrame = 0;
    this.framesPerSection = this.maxFrame / (orientations.length - 1);
  }

  /**
   * @param {number} x
   * @return {number}
   * @private
   */
  _createClass(CameraAnimation, [{
    key: "easeInOutQuad_",
    value: function easeInOutQuad_(x) {
      return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    }
    /**
     * Returns the CameraOrientation for the next frame, or null if the animation
     * is over.
     * @return {?CameraOrientation}
     */

  }, {
    key: "getNextOrientation",
    value: function getNextOrientation() {
      if (this.currentHeadingIndex < 0 || this.currentFrame == this.maxFrame - 1) {
        // Animation ended.
        return null;
      }

      this.currentFrame++;
      var lastFrameOfCurrentSection = (this.currentHeadingIndex + 1) * this.framesPerSection;

      if (this.currentFrame >= lastFrameOfCurrentSection) {
        this.currentHeadingIndex++;

        if (this.currentHeadingIndex == this.orientations.length) {
          // End of animation.
          this.currentHeadingIndex = -1;
          return null;
        } else {
          return this.orientations[this.currentHeadingIndex];
        }
      }

      var toNext = this.orientations[this.currentHeadingIndex + 1];
      var from = this.orientations[this.currentHeadingIndex];

      if (!toNext) {
        // End of animation.
        this.currentHeadingIndex = -1;
        return null;
      }

      var easing = this.easeInOutQuad_(this.currentFrame % this.framesPerSection / this.framesPerSection);
      return new CameraOrientation(from.theta + (toNext.theta - from.theta) * easing, from.phi + (toNext.phi - from.phi) * easing, from.scale + (toNext.scale - from.scale) * easing);
    }
  }]);

  return CameraAnimation;
}();

var AmpStory360 = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(AmpStory360, _AMP$BaseElement);

  var _super = _createSuper(AmpStory360);

  /** @param {!AmpElement} element */
  function AmpStory360(element) {
    var _this;

    _classCallCheck(this, AmpStory360);

    _this = _super.call(this, element);

    /** @private {?../../../src/service/localization.LocalizationService} */
    _this.localizationService_ = null;

    /** @private {!Array<!CameraOrientation>} */
    _this.orientations_ = [];

    /** @private {number} */
    _this.duration_ = 0;

    /** @private {?Element} */
    _this.canvas_ = null;

    /** @private {?Renderer} */
    _this.renderer_ = null;

    /** @private {?CameraAnimation} */
    _this.animation_ = null;

    /** @private {boolean} */
    _this.isPlaying_ = false;

    /** @private {boolean} */
    _this.isReady_ = false;

    /** @private {boolean} */
    _this.gyroscopeControls_ = false;

    /** @private {?Element} */
    _this.activateButton_ = null;

    /** @private {?../../../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService} */
    _this.storeService_ = null;

    /** @private {?string} */
    _this.pageId_ = null;

    /** @private {boolean} */
    _this.isOnActivePage_ = false;

    /** @private {?number} */
    _this.distance_ = null;

    /** @private {number} */
    _this.sceneHeading_ = 0;

    /** @private {number} */
    _this.scenePitch_ = 0;

    /** @private {number} */
    _this.sceneRoll_ = 0;

    /** @private {?Element|?EventTarget} */
    _this.ampVideoEl_ = null;

    /** @private {?Element} */
    _this.image_ = null;

    /** @private {number} */
    _this.headingOffset_ = 0;

    /** @private WebGL extension for lost context. */
    _this.lostGlContext_ = null;

    /** @private {!Array<number>} */
    _this.rot_ = null;
    return _this;
  }

  /** @override */
  _createClass(AmpStory360, [{
    key: "buildCallback",
    value: function buildCallback() {
      var _this2 = this;

      var attr = function attr(name) {
        return _this2.element.getAttribute(name);
      };

      var attrAsFloat = function attrAsFloat(name, fallbackValue) {
        if (fallbackValue === void 0) {
          fallbackValue = 0;
        }

        return parseFloat(attr(name) || fallbackValue);
      };

      if (attr('duration')) {
        this.duration_ = (0, _utils.timeStrToMillis)(attr('duration')) || 0;
      }

      var startHeading = attrAsFloat('heading-start');
      var startPitch = attrAsFloat('pitch-start');
      var startZoom = attrAsFloat('zoom-start', 1);
      this.orientations_.push(CameraOrientation.fromDegrees(startHeading, startPitch, startZoom));

      if (attr('heading-end') !== undefined || attr('pitch-end') !== undefined || attr('zoom-end') !== undefined) {
        var endHeading = attrAsFloat('heading-end', startHeading);
        var endPitch = attrAsFloat('pitch-end', startPitch);
        var endZoom = attrAsFloat('zoom-end', startZoom);
        this.orientations_.push(CameraOrientation.fromDegrees(endHeading, endPitch, endZoom));
      }

      if (attr('scene-heading') !== undefined || attr('scene-pitch') !== undefined || attr('scene-roll') !== undefined) {
        this.sceneHeading_ = attrAsFloat('scene-heading');
        this.scenePitch_ = attrAsFloat('scene-pitch');
        this.sceneRoll_ = attrAsFloat('scene-roll');
      }

      var container = this.element.ownerDocument.createElement('div');
      this.canvas_ = this.element.ownerDocument.createElement('canvas');
      this.element.appendChild(container);
      container.appendChild(this.canvas_);
      this.applyFillContent(container,
      /* replacedContent */
      true);
      // Mutation observer for distance attribute
      var config = {
        attributes: true,
        attributeFilter: ['distance']
      };

      var callback = function callback(mutationsList) {
        _this2.distance_ = parseInt(mutationsList[0].target.getAttribute('distance'), 10);

        _this2.restoreOrLoseGlContext_();
      };

      var observer = new MutationObserver(callback);
      this.getPage_() && observer.observe(this.getPage_(), config);
      // Initialize all services before proceeding
      return Promise.all([_services.Services.storyStoreServiceForOrNull(this.win).then(function (storeService) {
        _this2.storeService_ = storeService;
        storeService.subscribe(_ampStoryStoreService.StateProperty.PAGE_SIZE, function () {
          return _this2.resizeRenderer_();
        });

        if (attr('controls') === 'gyroscope') {
          storeService.subscribe(_ampStoryStoreService.StateProperty.GYROSCOPE_PERMISSION_STATE, function (permissionState) {
            return _this2.onPermissionState_(permissionState);
          });

          _this2.checkGyroscopePermissions_();
        }

        storeService.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_ID, function (currPageId) {
          _this2.isOnActivePage_ = currPageId === _this2.getPageId_();

          _this2.onPageNavigation_();

          _this2.maybeShowDiscoveryAnimation_();
        });

        _this2.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAUSED_STATE, function (isPaused) {
          if (_this2.isOnActivePage_) {
            isPaused ? _this2.pause_() : _this2.play_();
          }
        });
      }), _services.Services.localizationServiceForOrNull(this.element).then(function (localizationService) {
        _this2.localizationService_ = localizationService;
      })]).then(function () {
        return (0, _resolvedPromise3.resolvedPromise)();
      });
    }
    /**
     * @private
     * @return {string} the page id
     */

  }, {
    key: "getPageId_",
    value: function getPageId_() {
      if (this.pageId_ == null) {
        this.pageId_ = this.getPage_().getAttribute('id');
      }

      return this.pageId_;
    }
    /**
     * @private
     * @return {?Element} the parent amp-story-page
     */

  }, {
    key: "getPage_",
    value: function getPage_() {
      return (0, _dom.closest)((0, _log.dev)().assertElement(this.element), function (el) {
        return el.tagName.toLowerCase() === 'amp-story-page';
      });
    }
    /** @private */

  }, {
    key: "onPageNavigation_",
    value: function onPageNavigation_() {
      if (this.isOnActivePage_) {
        this.play_();
      } else {
        this.pause_();
        this.rewind_();
      }
    }
    /** @private */

  }, {
    key: "restoreOrLoseGlContext_",
    value: function restoreOrLoseGlContext_() {
      if (!this.renderer_) {
        return;
      }

      if (this.distance_ < MIN_WEBGL_DISTANCE) {
        if (this.renderer_.gl.isContextLost()) {
          this.lostGlContext_.restoreContext();
        }
      } else if (!this.renderer_.gl.isContextLost()) {
        this.lostGlContext_.loseContext();
      }
    }
    /**
     * @param {string} permissionState
     * @private
     */

  }, {
    key: "onPermissionState_",
    value: function onPermissionState_(permissionState) {
      var _this3 = this;

      if (this.activateButton_) {
        this.mutateElement(function () {
          _this3.getPage_().removeChild(_this3.activateButton_);

          _this3.activateButton_ = null;
        });
      }

      if (permissionState === 'granted') {
        this.enableGyroscope_();
      } else if (permissionState === 'denied') {
        this.gyroscopeControls_ = false;
      }
    }
    /** @private */

  }, {
    key: "checkGyroscopePermissions_",
    value: function checkGyroscopePermissions_() {
      var _this4 = this;

      //  If browser doesn't support DeviceOrientationEvent.
      if (typeof this.win.DeviceOrientationEvent === 'undefined') {
        return;
      }

      // If browser doesn't require permission for DeviceOrientationEvent.
      if (typeof this.win.DeviceOrientationEvent.requestPermission === 'undefined') {
        this.enableGyroscope_();
      }

      // If permissions needed for DeviceOrientationEvent.
      if (typeof this.win.DeviceOrientationEvent.requestPermission === 'function') {
        this.win.DeviceOrientationEvent.requestPermission().catch(function () {
          // If permissions weren't set, render activate button.
          _this4.renderActivateButton_();
        }).then(function (permissionState) {
          // If permissions already set, set permission state.
          permissionState && _this4.setPermissionState_(permissionState);
        });
      }
    }
    /**
     * Listens for deviceorientation events.
     *
     * Some browsers support the 'deviceorientation' event but never call it.
     * This waits for one call before initiating a constant listener.
     * @private
     */

  }, {
    key: "enableGyroscope_",
    value: function enableGyroscope_() {
      var _this5 = this;

      // Listen for one call before initiating.
      (0, _eventHelper.listenOncePromise)(this.win, 'deviceorientation').then(function (e) {
        _this5.gyroscopeControls_ = true;

        // Renders active page orientation correctly on load.
        // isOnActivePage_ is slightly async so unfortunately we do this for all pages.
        _this5.setGyroscopeDefaultHeading_(e.alpha);

        // Debounce onDeviceOrientation_ to rAF.
        var rafTimeout;

        _this5.win.addEventListener('deviceorientation', function (e) {
          if (_this5.isReady_ && _this5.distance_ < MIN_WEBGL_DISTANCE) {
            rafTimeout && _this5.win.cancelAnimationFrame(rafTimeout);
            rafTimeout = _this5.win.requestAnimationFrame(function () {
              if (!_this5.isOnActivePage_) {
                _this5.setGyroscopeDefaultHeading_(e.alpha);
              }

              _this5.onDeviceOrientation_(e);
            });
          }
        });

        _this5.maybeShowDiscoveryAnimation_();
      });
    }
    /**
     * Ensures user is facing a specified point of interest.
     * @param {number} orientationAlpha
     * @private
     */

  }, {
    key: "setGyroscopeDefaultHeading_",
    value: function setGyroscopeDefaultHeading_(orientationAlpha) {
      this.headingOffset_ = parseFloat(this.element.getAttribute('heading-end') || this.element.getAttribute('heading-start') || 0) + CENTER_OFFSET + orientationAlpha;
    }
    /**
     * Only show once per story on first instance of 360 component.
     * @private
     */

  }, {
    key: "maybeShowDiscoveryAnimation_",
    value: function maybeShowDiscoveryAnimation_() {
      if (this.isOnActivePage_ && this.gyroscopeControls_ && !this.element.ownerDocument.querySelector(".i-amphtml-story-360-discovery")) {
        var page = this.getPage_();
        var discoveryTemplate = page && buildDiscoveryTemplate(page);
        this.mutateElement(function () {
          return page.appendChild(discoveryTemplate);
        });
      }
    }
    /**
     * @param {!Event} e
     * @private
     */

  }, {
    key: "onDeviceOrientation_",
    value: function onDeviceOrientation_(e) {
      var _this6 = this;

      var rot = _zuho.Matrix.identity(3);

      rot = _zuho.Matrix.mul(3, _zuho.Matrix.rotation(3, 1, 0, deg2rad(e.alpha - this.headingOffset_)), rot);
      rot = _zuho.Matrix.mul(3, _zuho.Matrix.rotation(3, 2, 1, deg2rad(e.beta)), rot);
      rot = _zuho.Matrix.mul(3, _zuho.Matrix.rotation(3, 0, 2, deg2rad(e.gamma)), rot);
      // Smoothen sensor data by averaging previous and next rotation values.
      this.rot_ = this.rot_ ? rot.map(function (val, i) {
        return (val + _this6.rot_[i]) / 2;
      }) : rot;
      this.renderer_.setCamera(this.rot_, 1);
      this.renderer_.render(true);
    }
    /**
     * A button to ask for permissons.
     * @private
     */

  }, {
    key: "renderActivateButton_",
    value: function renderActivateButton_() {
      var _this7 = this;

      var ampStoryPage = this.getPage_();
      this.activateButton_ = ampStoryPage && buildActivateButtonTemplate(ampStoryPage);
      this.activateButton_.querySelector('.i-amphtml-story-360-activate-text').textContent = this.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_ACTIVATE_BUTTON_TEXT);
      this.activateButton_.addEventListener('click', function () {
        return _this7.requestGyroscopePermissions_();
      });
      this.mutateElement(function () {
        return ampStoryPage.appendChild(_this7.activateButton_);
      });
    }
    /** @private */

  }, {
    key: "requestGyroscopePermissions_",
    value: function requestGyroscopePermissions_() {
      var _this8 = this;

      if (this.win.DeviceOrientationEvent.requestPermission) {
        this.win.DeviceOrientationEvent.requestPermission().then(function (permissionState) {
          _this8.setPermissionState_(permissionState);
        }).catch(function (error) {
          (0, _log.dev)().error(TAG, "Gyroscope permission error: " + error.message);
        });
      }
    }
    /**
     * @param {string} permissionState
     * @private
     */

  }, {
    key: "setPermissionState_",
    value: function setPermissionState_(permissionState) {
      if (permissionState === 'granted') {
        this.storeService_.dispatch(_ampStoryStoreService.Action.SET_GYROSCOPE_PERMISSION, 'granted');
      } else if (permissionState === 'denied') {
        this.storeService_.dispatch(_ampStoryStoreService.Action.SET_GYROSCOPE_PERMISSION, 'denied');
      }
    }
    /** @override */

  }, {
    key: "isLayoutSupported",
    value: function isLayoutSupported(layout) {
      return (0, _layout.isLayoutSizeDefined)(layout);
    }
    /**
     * Checks if the image is larger than the GPUs max texture size.
     * Scales the image down if neededed.
     * Returns the image element if image is within bounds.
     * If image is out of bounds, returns a scaled canvas element.
     * @param {!Element} imgEl
     * @return {!Element}
     * @private
     */

  }, {
    key: "checkImageReSize_",
    value: function checkImageReSize_(imgEl) {
      var MAX_TEXTURE_SIZE = this.renderer_.gl.getParameter(this.renderer_.gl.MAX_TEXTURE_SIZE);

      if (imgEl.naturalWidth > MAX_TEXTURE_SIZE || imgEl.naturalHeight > MAX_TEXTURE_SIZE) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = Math.min(imgEl.naturalWidth, MAX_TEXTURE_SIZE);
        canvas.height = Math.min(imgEl.naturalHeight, MAX_TEXTURE_SIZE);
        ctx.drawImage(imgEl, 0, 0, canvas.width, canvas.height);
        return canvas;
      } else {
        return imgEl;
      }
    }
    /** @override */

  }, {
    key: "layoutCallback",
    value: function layoutCallback() {
      var ampImgEl = this.element.querySelector('amp-img');
      // Used to update the video in animate_.
      this.ampVideoEl_ = this.element.querySelector('amp-video');
      (0, _log.userAssert)(ampImgEl || this.ampVideoEl_, 'amp-story-360 must contain an amp-img or amp-video element.');

      if (ampImgEl) {
        return this.setupAmpImgRenderer_(ampImgEl);
      }

      if (this.ampVideoEl_) {
        return this.setupAmpVideoRenderer_();
      }
    }
    /**
     * @param {!Element} ampImgEl
     * @return {!Promise}
     * @private
     */

  }, {
    key: "setupAmpImgRenderer_",
    value: function setupAmpImgRenderer_(ampImgEl) {
      var _this9 = this;

      var owners = _services.Services.ownersForDoc(this.element);

      owners.setOwner(ampImgEl, this.element);
      owners.scheduleLayout(this.element, ampImgEl);
      return (0, _dom.whenUpgradedToCustomElement)(ampImgEl).then(function () {
        return ampImgEl.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END);
      }).then(function () {
        _this9.renderer_ = new _zuho.Renderer(_this9.canvas_);

        _this9.setupGlContextListeners_();

        _this9.image_ = _this9.checkImageReSize_((0, _log.dev)().assertElement(_this9.element.querySelector('img')));

        _this9.initRenderer_();
      }, function () {
        (0, _log.user)().error(TAG, 'Failed to load the amp-img.');
      });
    }
    /**
     * @return {!Promise}
     * @private
     */

  }, {
    key: "setupAmpVideoRenderer_",
    value: function setupAmpVideoRenderer_() {
      var _this10 = this;

      return (0, _dom.whenUpgradedToCustomElement)((0, _log.dev)().assertElement(this.ampVideoEl_)).then(function () {
        return _this10.ampVideoEl_.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END);
      }).then(function () {
        var alreadyHasData = (0, _log.dev)().assertElement(_this10.ampVideoEl_.querySelector('video')).readyState >= HAVE_CURRENT_DATA;
        return alreadyHasData ? (0, _resolvedPromise3.resolvedPromise)() : (0, _eventHelper.listenOncePromise)(_this10.ampVideoEl_, 'loadeddata');
      }).then(function () {
        _this10.renderer_ = new _zuho.Renderer(_this10.canvas_);

        _this10.setupGlContextListeners_();

        _this10.initRenderer_();
      }, function () {
        (0, _log.user)().error(TAG, 'Failed to load the amp-video.');
      });
    }
    /** @private */

  }, {
    key: "setupGlContextListeners_",
    value: function setupGlContextListeners_() {
      var _this11 = this;

      this.lostGlContext_ = this.renderer_.gl.getExtension('WEBGL_lose_context');
      this.renderer_.canvas.addEventListener('webglcontextlost', function (e) {
        // Calling preventDefault is necessary for restoring context.
        e.preventDefault();
        _this11.isReady_ = false;
      });
      this.renderer_.canvas.addEventListener('webglcontextrestored', function () {
        return _this11.initRenderer_();
      });
    }
    /** @private */

  }, {
    key: "initRenderer_",
    value: function initRenderer_() {
      this.renderer_.init();
      this.renderer_.setImageOrientation(this.sceneHeading_, this.scenePitch_, this.sceneRoll_);
      this.renderer_.setImage(this.image_ ? this.image_ : (0, _log.dev)().assertElement(this.ampVideoEl_.querySelector('video')));
      this.renderer_.resize();

      if (this.orientations_.length < 1) {
        return;
      }

      this.renderInitialPosition_();
      this.isReady_ = true;

      if (this.isPlaying_) {
        this.animate_();
      }
    }
    /** @private */

  }, {
    key: "resizeRenderer_",
    value: function resizeRenderer_() {
      var _this12 = this;

      this.mutateElement(function () {
        if (_this12.renderer_) {
          _this12.renderer_.resize();

          if (!_this12.isPlaying_) {
            _this12.renderer_.render(false);
          }
        }
      });
    }
    /** @private */

  }, {
    key: "renderInitialPosition_",
    value: function renderInitialPosition_() {
      var _this13 = this;

      if (this.gyroscopeControls_) {
        return;
      }

      this.mutateElement(function () {
        _this13.renderer_.setCamera(_this13.orientations_[0].rotation, _this13.orientations_[0].scale);

        _this13.renderer_.render(false);
      });
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "animate_",

    /** @private */
    value: function animate_() {
      var _this14 = this;

      if (!this.animation_) {
        this.animation_ = new CameraAnimation(this.duration_, this.orientations_);
      }

      var loop = function loop() {
        if (!_this14.isPlaying_ || !_this14.animation_) {
          _this14.renderer_.render(false);

          return;
        }

        var nextOrientation = _this14.animation_.getNextOrientation();

        // mutateElement causes inaccurate animation speed here, so we use rAF.
        _this14.win.requestAnimationFrame(function () {
          // Stop loop if no next orientation and not a video.
          if (!nextOrientation && !_this14.ampVideoEl_) {
            _this14.isPlaying_ = false;

            _this14.renderer_.render(false);

            return;
          }

          // Only apply next orientation if not in gyroscope mode.
          if (nextOrientation && !_this14.gyroscopeControls_) {
            _this14.renderer_.setCamera(nextOrientation.rotation, nextOrientation.scale);
          }

          // If video, check if ready and copy the texture on each frame.
          if (_this14.ampVideoEl_) {
            var videoEl = (0, _log.dev)().assertElement(_this14.ampVideoEl_.querySelector('video'));

            if (videoEl.readyState >= HAVE_CURRENT_DATA) {
              _this14.renderer_.setImage(videoEl);
            }
          }

          _this14.renderer_.render(true);

          loop();
        });
      };

      this.mutateElement(function () {
        return loop();
      });
    }
    /** @private */

  }, {
    key: "pause_",
    value: function pause_() {
      this.isPlaying_ = false;
    }
    /** @private */

  }, {
    key: "play_",
    value: function play_() {
      if (!this.canAnimate) {
        return;
      }

      (0, _log.userAssert)(this.canAnimate, 'amp-story-360 is either not configured to play an animation or ' + 'still loading content.');
      this.isPlaying_ = true;

      if (this.isReady_) {
        this.animate_();
      }
    }
    /** @private */

  }, {
    key: "rewind_",
    value: function rewind_() {
      var _this15 = this;

      if (!this.canAnimate) {
        return;
      }

      this.animation_ = null;

      // Let the animation loop exit, then render the initial position and resume
      // the animation (if applicable).
      if (this.isReady_) {
        this.win.requestAnimationFrame(function () {
          _this15.renderInitialPosition_();

          if (_this15.isPlaying_) {
            _this15.animate_();
          }
        });
      }
    }
  }, {
    key: "canAnimate",
    get: function get() {
      return this.duration_ > 0 && this.orientations_.length > 1;
    }
  }]);

  return AmpStory360;
}(AMP.BaseElement);

exports.AmpStory360 = AmpStory360;
AMP.extension('amp-story-360', '0.1', function (AMP) {
  AMP.registerElement('amp-story-360', AmpStory360, _ampStory.CSS);
});

},{"../../../build/amp-story-360-0.1.css":1,"../../../extensions/amp-story/1.0/amp-story-store-service":3,"../../../extensions/amp-story/1.0/utils":5,"../../../src/common-signals":6,"../../../src/dom":9,"../../../src/event-helper":13,"../../../src/layout":17,"../../../src/localized-strings":18,"../../../src/log":19,"../../../src/services":25,"../../../src/static-template":27,"../../../third_party/zuho/zuho":44,"./../../../src/resolved-promise":23}],3:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryStoreService = exports.Action = exports.StateProperty = exports.State = exports.InteractiveReactData = exports.InteractiveComponentDef = exports.EmbeddedComponentState = exports.UIType = exports.getStoreService = void 0;

var _embedMode = require("./embed-mode");

var _observable = require("../../../src/observable");

var _services = require("../../../src/services");

var _json = require("../../../src/json");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

var _service = require("../../../src/service");

var _stateComparisonFunct;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @type {string} */
var TAG = 'amp-story';

/**
 * Util function to retrieve the store service. Ensures we can retrieve the
 * service synchronously from the amp-story codebase without running into race
 * conditions.
 * @param  {!Window} win
 * @return {!AmpStoryStoreService}
 */
var getStoreService = function getStoreService(win) {
  var service = _services.Services.storyStoreService(win);

  if (!service) {
    service = new AmpStoryStoreService(win);
    (0, _service.registerServiceBuilder)(win, 'story-store', function () {
      return service;
    });
  }

  return service;
};

exports.getStoreService = getStoreService;

/**
 * Different UI experiences to display the story.
 * @const @enum {number}
 */
var UIType = {
  MOBILE: 0,
  DESKTOP_PANELS: 1,
  // Default desktop UI.
  DESKTOP_FULLBLEED: 2,
  // Desktop UI if landscape mode is enabled.
  VERTICAL: 3 // Vertical scrolling versions, for search engine bots indexing.

};
exports.UIType = UIType;

/**
 * States in which an embedded component could be found in.
 * @enum {number}
 */
var EmbeddedComponentState = {
  HIDDEN: 0,
  // Component is present in page, but hasn't been interacted with.
  FOCUSED: 1,
  // Component has been clicked, a tooltip should be shown.
  EXPANDED: 2 // Component is in expanded mode.

};
exports.EmbeddedComponentState = EmbeddedComponentState;

/**
 * @typedef {{
 *    element: !Element,
 *    state: !EmbeddedComponentState,
 *    clientX: number,
 *    clientY: number,
 * }}
 */
var InteractiveComponentDef;
exports.InteractiveComponentDef = InteractiveComponentDef;

/**
 * @typedef {{
 *    option: ?../../amp-story-interactive/0.1/amp-story-interactive-abstract.OptionConfigType,
 *    interactiveId: string,
 *    type: ../../amp-story-interactive/0.1/amp-story-interactive-abstract.InteractiveType
 * }}
 */
var InteractiveReactData;
exports.InteractiveReactData = InteractiveReactData;

/**
 * @typedef {{
 *    canInsertAutomaticAd: boolean,
 *    canShowBookend: boolean,
 *    canShowAudioUi: boolean,
 *    canShowNavigationOverlayHint: boolean,
 *    canShowPaginationButtons: boolean,
 *    canShowPreviousPageHelp: boolean,
 *    canShowSharingUis: boolean,
 *    canShowSystemLayerButtons: boolean,
 *    viewerCustomControls: !Array<!Object>,
 *    accessState: boolean,
 *    adState: boolean,
 *    pageAttachmentState: boolean,
 *    affiliateLinkState: !Element,
 *    bookendState: boolean,
 *    desktopState: boolean,
 *    educationState: boolean,
 *    gyroscopeEnabledState: string,
 *    hasSidebarState: boolean,
 *    infoDialogState: boolean,
 *    interactiveEmbeddedComponentState: !InteractiveComponentDef,
 *    interactiveReactState: !Map<string, !InteractiveReactData>,
 *    mutedState: boolean,
 *    pageAudioState: boolean,
 *    pageHasElementsWithPlaybackState: boolean,
 *    pausedState: boolean,
 *    previewState: boolean,
 *    rtlState: boolean,
 *    shareMenuState: boolean,
 *    sidebarState: boolean,
 *    storyHasAudioState: boolean,
 *    storyHasPlaybackUiState: boolean,
 *    storyHasBackgroundAudioState: boolean,
 *    supportedBrowserState: boolean,
 *    systemUiIsVisibleState: boolean,
 *    uiState: !UIType,
 *    viewportWarningState: boolean,
 *    actionsAllowlist: !Array<{tagOrTarget: string, method: string}>,
 *    consentId: ?string,
 *    currentPageId: string,
 *    currentPageIndex: number,
 *    pageIds: !Array<string>,
 *    newPageAvailableId: string,
 *    pageSize: {width: number, height: number},
 * }}
 */
var State;
exports.State = State;

/** @const @enum {string} */
var StateProperty = {
  // Embed options.
  CAN_INSERT_AUTOMATIC_AD: 'canInsertAutomaticAd',
  CAN_SHOW_BOOKEND: 'canShowBookend',
  CAN_SHOW_AUDIO_UI: 'canShowAudioUi',
  CAN_SHOW_NAVIGATION_OVERLAY_HINT: 'canShowNavigationOverlayHint',
  CAN_SHOW_PAGINATION_BUTTONS: 'canShowPaginationButtons',
  CAN_SHOW_PREVIOUS_PAGE_HELP: 'canShowPreviousPageHelp',
  CAN_SHOW_SHARING_UIS: 'canShowSharingUis',
  CAN_SHOW_SYSTEM_LAYER_BUTTONS: 'canShowSystemLayerButtons',
  VIEWER_CUSTOM_CONTROLS: 'viewerCustomControls',
  // App States.
  ACCESS_STATE: 'accessState',
  // amp-access paywall.
  AD_STATE: 'adState',
  PAGE_ATTACHMENT_STATE: 'pageAttachmentState',
  BOOKEND_STATE: 'bookendState',
  AFFILIATE_LINK_STATE: 'affiliateLinkState',
  DESKTOP_STATE: 'desktopState',
  EDUCATION_STATE: 'educationState',
  GYROSCOPE_PERMISSION_STATE: 'gyroscopePermissionState',
  HAS_SIDEBAR_STATE: 'hasSidebarState',
  INFO_DIALOG_STATE: 'infoDialogState',
  INTERACTIVE_COMPONENT_STATE: 'interactiveEmbeddedComponentState',
  // State of interactive components (polls, quizzes) on the story.
  INTERACTIVE_REACT_STATE: 'interactiveReactState',
  MUTED_STATE: 'mutedState',
  PAGE_HAS_AUDIO_STATE: 'pageAudioState',
  PAGE_HAS_ELEMENTS_WITH_PLAYBACK_STATE: 'pageHasElementsWithPlaybackState',
  PAUSED_STATE: 'pausedState',
  // Story preview state.
  PREVIEW_STATE: 'previewState',
  RTL_STATE: 'rtlState',
  SHARE_MENU_STATE: 'shareMenuState',
  SIDEBAR_STATE: 'sidebarState',
  SUPPORTED_BROWSER_STATE: 'supportedBrowserState',
  // Any page has audio, or amp-story has a `background-audio` attribute.
  STORY_HAS_AUDIO_STATE: 'storyHasAudioState',
  // amp-story has a `background-audio` attribute.
  STORY_HAS_BACKGROUND_AUDIO_STATE: 'storyHasBackgroundAudioState',
  // Any page has elements with playback.
  STORY_HAS_PLAYBACK_UI_STATE: 'storyHasPlaybackUiState',
  SYSTEM_UI_IS_VISIBLE_STATE: 'systemUiIsVisibleState',
  UI_STATE: 'uiState',
  VIEWPORT_WARNING_STATE: 'viewportWarningState',
  // App data.
  ACTIONS_ALLOWLIST: 'actionsAllowlist',
  CONSENT_ID: 'consentId',
  CURRENT_PAGE_ID: 'currentPageId',
  CURRENT_PAGE_INDEX: 'currentPageIndex',
  ADVANCEMENT_MODE: 'advancementMode',
  NAVIGATION_PATH: 'navigationPath',
  NEW_PAGE_AVAILABLE_ID: 'newPageAvailableId',
  PAGE_IDS: 'pageIds',
  PAGE_SIZE: 'pageSize'
};
exports.StateProperty = StateProperty;

/** @const @enum {string} */
var Action = {
  ADD_INTERACTIVE_REACT: 'addInteractiveReact',
  ADD_TO_ACTIONS_ALLOWLIST: 'addToActionsAllowlist',
  CHANGE_PAGE: 'setCurrentPageId',
  SET_CONSENT_ID: 'setConsentId',
  SET_ADVANCEMENT_MODE: 'setAdvancementMode',
  SET_NAVIGATION_PATH: 'setNavigationPath',
  SET_PAGE_IDS: 'setPageIds',
  TOGGLE_ACCESS: 'toggleAccess',
  TOGGLE_AD: 'toggleAd',
  TOGGLE_AFFILIATE_LINK: 'toggleAffiliateLink',
  TOGGLE_BOOKEND: 'toggleBookend',
  TOGGLE_CAN_SHOW_BOOKEND: 'toggleCanShowBookend',
  TOGGLE_EDUCATION: 'toggleEducation',
  TOGGLE_HAS_SIDEBAR: 'toggleHasSidebar',
  TOGGLE_INFO_DIALOG: 'toggleInfoDialog',
  TOGGLE_INTERACTIVE_COMPONENT: 'toggleInteractiveComponent',
  TOGGLE_MUTED: 'toggleMuted',
  TOGGLE_PAGE_ATTACHMENT_STATE: 'togglePageAttachmentState',
  TOGGLE_PAGE_HAS_AUDIO: 'togglePageHasAudio',
  TOGGLE_PAGE_HAS_ELEMENT_WITH_PLAYBACK: 'togglePageHasElementWithPlayblack',
  TOGGLE_PAUSED: 'togglePaused',
  TOGGLE_RTL: 'toggleRtl',
  TOGGLE_SHARE_MENU: 'toggleShareMenu',
  TOGGLE_SIDEBAR: 'toggleSidebar',
  TOGGLE_SUPPORTED_BROWSER: 'toggleSupportedBrowser',
  TOGGLE_STORY_HAS_AUDIO: 'toggleStoryHasAudio',
  TOGGLE_STORY_HAS_BACKGROUND_AUDIO: 'toggleStoryHasBackgroundAudio',
  TOGGLE_STORY_HAS_PLAYBACK_UI: 'toggleStoryHasPlaybackUi',
  TOGGLE_SYSTEM_UI_IS_VISIBLE: 'toggleSystemUiIsVisible',
  TOGGLE_UI: 'toggleUi',
  SET_GYROSCOPE_PERMISSION: 'setGyroscopePermission',
  TOGGLE_VIEWPORT_WARNING: 'toggleViewportWarning',
  ADD_NEW_PAGE_ID: 'addNewPageId',
  SET_PAGE_SIZE: 'updatePageSize',
  SET_VIEWER_CUSTOM_CONTROLS: 'setCustomControls'
};
exports.Action = Action;

/**
 * Functions to compare a data structure from the previous to the new state and
 * detect a mutation, when a simple equality test would not work.
 * @private @const {!Object<string, !function(*, *):boolean>}
 */
var stateComparisonFunctions = (_stateComparisonFunct = {}, _stateComparisonFunct[StateProperty.ACTIONS_ALLOWLIST] = function (old, curr) {
  return old.length !== curr.length;
}, _stateComparisonFunct[StateProperty.INTERACTIVE_COMPONENT_STATE] =
/**
 * @param {InteractiveComponentDef} old
 * @param {InteractiveComponentDef} curr
 */
function (old, curr) {
  return old.element !== curr.element || old.state !== curr.state;
}, _stateComparisonFunct[StateProperty.NAVIGATION_PATH] = function (old, curr) {
  return old.length !== curr.length;
}, _stateComparisonFunct[StateProperty.PAGE_IDS] = function (old, curr) {
  return old.length !== curr.length;
}, _stateComparisonFunct[StateProperty.PAGE_SIZE] = function (old, curr) {
  return old === null || curr === null || old.width !== curr.width || old.height !== curr.height;
}, _stateComparisonFunct[StateProperty.INTERACTIVE_REACT_STATE] = function (old, curr) {
  return !(0, _json.deepEquals)(old, curr, 3);
}, _stateComparisonFunct);

/**
 * Returns the new sate.
 * @param  {!State} state Immutable state
 * @param  {!Action} action
 * @param  {*} data
 * @return {!State} new state
 */
var actions = function actions(state, action, data) {
  var _extends2, _extends3, _extends4, _extends5, _extends6, _extends7, _extends8, _extends9, _extends10, _extends11, _extends12, _extends13, _extends14, _extends15, _extends16, _extends17, _extends18, _extends19, _extends20, _extends21, _extends22, _extends23, _extends24, _extends25, _extends26, _extends27, _extends28, _extends29, _extends30, _extends31, _extends32, _extends33, _extends34, _extends35, _extends36, _extends37;

  switch (action) {
    case Action.ADD_INTERACTIVE_REACT:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends3 = {}, _extends3[StateProperty.INTERACTIVE_REACT_STATE] = _extends({}, state[StateProperty.INTERACTIVE_REACT_STATE], (_extends2 = {}, _extends2[data['interactiveId']] = data, _extends2)), _extends3))
      );

    case Action.ADD_NEW_PAGE_ID:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends4 = {}, _extends4[StateProperty.NEW_PAGE_AVAILABLE_ID] = data, _extends4))
      );

    case Action.ADD_TO_ACTIONS_ALLOWLIST:
      var newActionsAllowlist = [].concat(state[StateProperty.ACTIONS_ALLOWLIST], data);
      return (
        /** @type {!State} */
        _extends({}, state, (_extends5 = {}, _extends5[StateProperty.ACTIONS_ALLOWLIST] = newActionsAllowlist, _extends5))
      );
    // Triggers the amp-acess paywall.

    case Action.TOGGLE_ACCESS:
      // Don't change the PAUSED_STATE if ACCESS_STATE is not changed.
      if (state[StateProperty.ACCESS_STATE] === data) {
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends6 = {}, _extends6[StateProperty.ACCESS_STATE] = !!data, _extends6[StateProperty.PAUSED_STATE] = !!data, _extends6))
      );

    case Action.TOGGLE_PAGE_ATTACHMENT_STATE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends7 = {}, _extends7[StateProperty.PAGE_ATTACHMENT_STATE] = !!data, _extends7))
      );
    // Triggers the ad UI.

    case Action.TOGGLE_AD:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends8 = {}, _extends8[StateProperty.AD_STATE] = !!data, _extends8))
      );
    // Expands or collapses the affiliate link.

    case Action.TOGGLE_AFFILIATE_LINK:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends9 = {}, _extends9[StateProperty.AFFILIATE_LINK_STATE] = data, _extends9))
      );
    // Shows or hides the bookend.

    case Action.TOGGLE_BOOKEND:
      if (!state[StateProperty.CAN_SHOW_BOOKEND]) {
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends10 = {}, _extends10[StateProperty.BOOKEND_STATE] = !!data, _extends10[StateProperty.PAUSED_STATE] = !!data, _extends10))
      );

    case Action.TOGGLE_CAN_SHOW_BOOKEND:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends11 = {}, _extends11[StateProperty.CAN_SHOW_BOOKEND] = !!data, _extends11))
      );

    case Action.TOGGLE_EDUCATION:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends12 = {}, _extends12[StateProperty.EDUCATION_STATE] = !!data, _extends12))
      );

    case Action.TOGGLE_INTERACTIVE_COMPONENT:
      data =
      /** @type {InteractiveComponentDef} */
      data;
      return (
        /** @type {!State} */
        _extends({}, state, (_extends13 = {}, _extends13[StateProperty.PAUSED_STATE] = data.state === EmbeddedComponentState.EXPANDED || data.state === EmbeddedComponentState.FOCUSED, _extends13[StateProperty.SYSTEM_UI_IS_VISIBLE_STATE] = data.state !== EmbeddedComponentState.EXPANDED || state.uiState === UIType.DESKTOP_PANELS, _extends13[StateProperty.INTERACTIVE_COMPONENT_STATE] = data, _extends13))
      );
    // Shows or hides the info dialog.

    case Action.TOGGLE_INFO_DIALOG:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends14 = {}, _extends14[StateProperty.INFO_DIALOG_STATE] = !!data, _extends14[StateProperty.PAUSED_STATE] = !!data, _extends14))
      );
    // Shows or hides the audio controls.

    case Action.TOGGLE_STORY_HAS_AUDIO:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends15 = {}, _extends15[StateProperty.STORY_HAS_AUDIO_STATE] = !!data, _extends15))
      );

    case Action.TOGGLE_STORY_HAS_BACKGROUND_AUDIO:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends16 = {}, _extends16[StateProperty.STORY_HAS_BACKGROUND_AUDIO_STATE] = !!data, _extends16))
      );
    // Shows or hides the play/pause controls.

    case Action.TOGGLE_STORY_HAS_PLAYBACK_UI:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends17 = {}, _extends17[StateProperty.STORY_HAS_PLAYBACK_UI_STATE] = !!data, _extends17))
      );
    // Mutes or unmutes the story media.

    case Action.TOGGLE_MUTED:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends18 = {}, _extends18[StateProperty.MUTED_STATE] = !!data, _extends18))
      );

    case Action.TOGGLE_PAGE_HAS_AUDIO:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends19 = {}, _extends19[StateProperty.PAGE_HAS_AUDIO_STATE] = !!data, _extends19))
      );

    case Action.TOGGLE_PAGE_HAS_ELEMENT_WITH_PLAYBACK:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends20 = {}, _extends20[StateProperty.PAGE_HAS_ELEMENTS_WITH_PLAYBACK_STATE] = !!data, _extends20))
      );

    case Action.TOGGLE_PAUSED:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends21 = {}, _extends21[StateProperty.PAUSED_STATE] = !!data, _extends21))
      );

    case Action.TOGGLE_RTL:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends22 = {}, _extends22[StateProperty.RTL_STATE] = !!data, _extends22))
      );

    case Action.TOGGLE_SIDEBAR:
      // Don't change the PAUSED_STATE if SIDEBAR_STATE is not changed.
      if (state[StateProperty.SIDEBAR_STATE] === data) {
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends23 = {}, _extends23[StateProperty.PAUSED_STATE] = !!data, _extends23[StateProperty.SIDEBAR_STATE] = !!data, _extends23))
      );

    case Action.TOGGLE_HAS_SIDEBAR:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends24 = {}, _extends24[StateProperty.HAS_SIDEBAR_STATE] = !!data, _extends24))
      );

    case Action.TOGGLE_SUPPORTED_BROWSER:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends25 = {}, _extends25[StateProperty.SUPPORTED_BROWSER_STATE] = !!data, _extends25))
      );

    case Action.TOGGLE_SHARE_MENU:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends26 = {}, _extends26[StateProperty.PAUSED_STATE] = !!data, _extends26[StateProperty.SHARE_MENU_STATE] = !!data, _extends26))
      );

    case Action.TOGGLE_SYSTEM_UI_IS_VISIBLE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends27 = {}, _extends27[StateProperty.SYSTEM_UI_IS_VISIBLE_STATE] = !!data, _extends27))
      );

    case Action.TOGGLE_UI:
      if (state[StateProperty.UI_STATE] === UIType.VERTICAL && data !== UIType.VERTICAL) {
        (0, _log.dev)().error(TAG, 'Cannot switch away from UIType.VERTICAL');
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends28 = {}, _extends28[StateProperty.DESKTOP_STATE] = data === UIType.DESKTOP_PANELS, _extends28[StateProperty.UI_STATE] = data, _extends28))
      );

    case Action.SET_GYROSCOPE_PERMISSION:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends29 = {}, _extends29[StateProperty.GYROSCOPE_PERMISSION_STATE] = data, _extends29))
      );

    case Action.TOGGLE_VIEWPORT_WARNING:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends30 = {}, _extends30[StateProperty.VIEWPORT_WARNING_STATE] = !!data, _extends30))
      );

    case Action.SET_CONSENT_ID:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends31 = {}, _extends31[StateProperty.CONSENT_ID] = data, _extends31))
      );

    case Action.CHANGE_PAGE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends32 = {}, _extends32[StateProperty.CURRENT_PAGE_ID] = data.id, _extends32[StateProperty.CURRENT_PAGE_INDEX] = data.index, _extends32))
      );

    case Action.SET_ADVANCEMENT_MODE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends33 = {}, _extends33[StateProperty.ADVANCEMENT_MODE] = data, _extends33))
      );

    case Action.SET_NAVIGATION_PATH:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends34 = {}, _extends34[StateProperty.NAVIGATION_PATH] = data, _extends34))
      );

    case Action.SET_PAGE_IDS:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends35 = {}, _extends35[StateProperty.PAGE_IDS] = data, _extends35))
      );

    case Action.SET_PAGE_SIZE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends36 = {}, _extends36[StateProperty.PAGE_SIZE] = data, _extends36))
      );

    case Action.SET_VIEWER_CUSTOM_CONTROLS:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends37 = {}, _extends37[StateProperty.VIEWER_CUSTOM_CONTROLS] = data, _extends37))
      );

    default:
      (0, _log.dev)().error(TAG, 'Unknown action %s.', action);
      return state;
  }
};

/**
 * Store service.
 */
var AmpStoryStoreService = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function AmpStoryStoreService(win) {
    _classCallCheck(this, AmpStoryStoreService);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {!Object<string, !Observable>} */
    this.listeners_ = {};

    /** @private {!State} */
    this.state_ =
    /** @type {!State} */
    _extends({}, this.getDefaultState_(), this.getEmbedOverrides_());
  }

  /**
   * Retrieves a state property.
   * @param  {string} key Property to retrieve from the state.
   * @return {*}
   */
  _createClass(AmpStoryStoreService, [{
    key: "get",
    value: function get(key) {
      if (!(0, _object.hasOwn)(this.state_, key)) {
        (0, _log.dev)().error(TAG, 'Unknown state %s.', key);
        return;
      }

      return this.state_[key];
    }
    /**
     * Subscribes to a state property mutations.
     * @param  {string} key
     * @param  {!Function} listener
     * @param  {boolean=} callToInitialize Whether the listener should be
     *                                     triggered with current value.
     */

  }, {
    key: "subscribe",
    value: function subscribe(key, listener, callToInitialize) {
      if (callToInitialize === void 0) {
        callToInitialize = false;
      }

      if (!(0, _object.hasOwn)(this.state_, key)) {
        (0, _log.dev)().error(TAG, "Can't subscribe to unknown state %s.", key);
        return;
      }

      if (!this.listeners_[key]) {
        this.listeners_[key] = new _observable.Observable();
      }

      this.listeners_[key].add(listener);

      if (callToInitialize) {
        listener(this.get(key));
      }
    }
    /**
     * Dispatches an action and triggers the listeners for the updated state
     * properties.
     * @param  {!Action} action
     * @param  {*} data
     */

  }, {
    key: "dispatch",
    value: function dispatch(action, data) {
      var _this = this;

      var oldState = _extends({}, this.state_);

      this.state_ = actions(this.state_, action, data);
      var comparisonFn;
      Object.keys(this.listeners_).forEach(function (key) {
        comparisonFn = stateComparisonFunctions[key];

        if (comparisonFn ? comparisonFn(oldState[key], _this.state_[key]) : oldState[key] !== _this.state_[key]) {
          _this.listeners_[key].fire(_this.state_[key]);
        }
      });
    }
    /**
     * Retrieves the default state, that could be overriden by an embed mode.
     * @return {!State}
     * @private
     */

  }, {
    key: "getDefaultState_",
    value: function getDefaultState_() {
      var _ref;

      // Compiler won't resolve the object keys and trigger an error for missing
      // properties, so we have to force the type.
      return _ref = {}, _ref[StateProperty.CAN_INSERT_AUTOMATIC_AD] = true, _ref[StateProperty.CAN_SHOW_BOOKEND] = true, _ref[StateProperty.CAN_SHOW_AUDIO_UI] = true, _ref[StateProperty.CAN_SHOW_NAVIGATION_OVERLAY_HINT] = true, _ref[StateProperty.CAN_SHOW_PREVIOUS_PAGE_HELP] = true, _ref[StateProperty.CAN_SHOW_PAGINATION_BUTTONS] = true, _ref[StateProperty.CAN_SHOW_SHARING_UIS] = true, _ref[StateProperty.CAN_SHOW_SYSTEM_LAYER_BUTTONS] = true, _ref[StateProperty.VIEWER_CUSTOM_CONTROLS] = [], _ref[StateProperty.ACCESS_STATE] = false, _ref[StateProperty.AD_STATE] = false, _ref[StateProperty.AFFILIATE_LINK_STATE] = null, _ref[StateProperty.BOOKEND_STATE] = false, _ref[StateProperty.DESKTOP_STATE] = false, _ref[StateProperty.EDUCATION_STATE] = false, _ref[StateProperty.GYROSCOPE_PERMISSION_STATE] = '', _ref[StateProperty.HAS_SIDEBAR_STATE] = false, _ref[StateProperty.INFO_DIALOG_STATE] = false, _ref[StateProperty.INTERACTIVE_COMPONENT_STATE] = {
        state: EmbeddedComponentState.HIDDEN
      }, _ref[StateProperty.INTERACTIVE_REACT_STATE] = {}, _ref[StateProperty.MUTED_STATE] = true, _ref[StateProperty.PAGE_ATTACHMENT_STATE] = false, _ref[StateProperty.PAGE_HAS_AUDIO_STATE] = false, _ref[StateProperty.PAGE_HAS_ELEMENTS_WITH_PLAYBACK_STATE] = false, _ref[StateProperty.PAUSED_STATE] = false, _ref[StateProperty.RTL_STATE] = false, _ref[StateProperty.SHARE_MENU_STATE] = false, _ref[StateProperty.SIDEBAR_STATE] = false, _ref[StateProperty.SUPPORTED_BROWSER_STATE] = true, _ref[StateProperty.STORY_HAS_AUDIO_STATE] = false, _ref[StateProperty.STORY_HAS_BACKGROUND_AUDIO_STATE] = false, _ref[StateProperty.STORY_HAS_PLAYBACK_UI_STATE] = false, _ref[StateProperty.SYSTEM_UI_IS_VISIBLE_STATE] = true, _ref[StateProperty.UI_STATE] = UIType.MOBILE, _ref[StateProperty.VIEWPORT_WARNING_STATE] = false, _ref[StateProperty.ACTIONS_ALLOWLIST] = [], _ref[StateProperty.CONSENT_ID] = null, _ref[StateProperty.CURRENT_PAGE_ID] = '', _ref[StateProperty.CURRENT_PAGE_INDEX] = 0, _ref[StateProperty.ADVANCEMENT_MODE] = '', _ref[StateProperty.NEW_PAGE_AVAILABLE_ID] = '', _ref[StateProperty.NAVIGATION_PATH] = [], _ref[StateProperty.PAGE_IDS] = [], _ref[StateProperty.PAGE_SIZE] = null, _ref[StateProperty.PREVIEW_STATE] = false, _ref;
    } // @TODO(gmajoulet): These should get their own file if they start growing.

    /**
     * Retrieves the embed mode config, that will override the default state.
     * @return {!Object<StateProperty, *>} Partial state
     * @protected
     */

  }, {
    key: "getEmbedOverrides_",
    value: function getEmbedOverrides_() {
      var _ref2, _ref3, _ref4, _ref5;

      var embedMode = (0, _embedMode.parseEmbedMode)(this.win_.location.hash);

      switch (embedMode) {
        case _embedMode.EmbedMode.NAME_TBD:
          return _ref2 = {}, _ref2[StateProperty.CAN_INSERT_AUTOMATIC_AD] = false, _ref2[StateProperty.CAN_SHOW_BOOKEND] = false, _ref2[StateProperty.CAN_SHOW_NAVIGATION_OVERLAY_HINT] = false, _ref2[StateProperty.CAN_SHOW_PAGINATION_BUTTONS] = false, _ref2[StateProperty.CAN_SHOW_PREVIOUS_PAGE_HELP] = true, _ref2[StateProperty.CAN_SHOW_SYSTEM_LAYER_BUTTONS] = false, _ref2[StateProperty.MUTED_STATE] = false, _ref2;

        case _embedMode.EmbedMode.NO_SHARING:
          return _ref3 = {}, _ref3[StateProperty.CAN_SHOW_SHARING_UIS] = false, _ref3;

        case _embedMode.EmbedMode.PREVIEW:
          return _ref4 = {}, _ref4[StateProperty.PREVIEW_STATE] = true, _ref4[StateProperty.CAN_INSERT_AUTOMATIC_AD] = false, _ref4[StateProperty.CAN_SHOW_BOOKEND] = false, _ref4[StateProperty.CAN_SHOW_NAVIGATION_OVERLAY_HINT] = false, _ref4[StateProperty.CAN_SHOW_PAGINATION_BUTTONS] = false, _ref4[StateProperty.CAN_SHOW_PREVIOUS_PAGE_HELP] = false, _ref4[StateProperty.CAN_SHOW_SYSTEM_LAYER_BUTTONS] = false, _ref4;

        case _embedMode.EmbedMode.NO_SHARING_NOR_AUDIO_UI:
          return _ref5 = {}, _ref5[StateProperty.CAN_SHOW_AUDIO_UI] = false, _ref5[StateProperty.CAN_SHOW_SHARING_UIS] = false, _ref5;

        default:
          return {};
      }
    }
  }]);

  return AmpStoryStoreService;
}();

exports.AmpStoryStoreService = AmpStoryStoreService;

},{"../../../src/json":16,"../../../src/log":19,"../../../src/observable":21,"../../../src/service":24,"../../../src/services":25,"../../../src/utils/object":39,"./embed-mode":4}],4:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseEmbedMode = parseEmbedMode;
exports.EmbedModeParam = exports.EmbedMode = void 0;

var _types = require("../../../src/types");

var _url = require("../../../src/url");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Embed mode for AMP story.  See ../embed-modes.md for details.
 * @enum {number}
 */
var EmbedMode = {
  /**
   * Default mode.
   */
  NOT_EMBEDDED: 0,

  /**
   * TBD embed mode.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Hides bookend
   * - Hides all system layer buttons
   * - Disables swipe-based user education
   * - Disallows ads
   * - Unmutes audio in the story by default
   */
  NAME_TBD: 1,

  /**
   * This mode is intended for embedders that natively handle sharing the story,
   * thereby rendering the sharing functionality within the amp-story extension
   * redundant.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Removes share icon from system layer
   * - Removes sharing section from bookend
   * - TODO(#14923): Removes the link information from embedded UIs.
   */
  NO_SHARING: 2,

  /**
   * This mode is intended for a preview of the story.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Auto-advances pages by a given duration.
   * - Hides bookend
   * - Hides all system layer buttons
   * - Disables swipe-based user education
   * - Disallows ads
   */
  PREVIEW: 3,

  /**
   * This mode is intended for embedders that natively handle the audio and
   * sharing experiences, through native controls and viewer communication.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Removes share icon from system layer
   * - Removes sharing section from bookend
   * - Removes audio icon from system layer
   */
  NO_SHARING_NOR_AUDIO_UI: 4
};
exports.EmbedMode = EmbedMode;

/**
 * Parameter to retrieve the embed mode from the location hash.
 * @type {string}
 */
var EmbedModeParam = 'embedMode';
exports.EmbedModeParam = EmbedModeParam;

/**
 * @param {string} str
 * @return {!EmbedMode}
 * @package
 */
function parseEmbedMode(str) {
  var params = (0, _url.parseQueryString)(str);
  var unsanitizedEmbedMode = params[EmbedModeParam];
  var embedModeIndex = parseInt(unsanitizedEmbedMode, 10);
  return (0, _types.isEnumValue)(EmbedMode, embedModeIndex) ?
  /** @type {!EmbedMode} */
  embedModeIndex : EmbedMode.NOT_EMBEDDED;
}

},{"../../../src/types":31,"../../../src/url":34}],5:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.timeStrToMillis = timeStrToMillis;
exports.hasTapAction = hasTapAction;
exports.unscaledClientRect = unscaledClientRect;
exports.ampMediaElementFor = ampMediaElementFor;
exports.createShadowRootWithStyle = createShadowRootWithStyle;
exports.getRGBFromCssColorValue = getRGBFromCssColorValue;
exports.getTextColorForRGB = getTextColorForRGB;
exports.setAttributeInMutate = setAttributeInMutate;
exports.removeAttributeInMutate = removeAttributeInMutate;
exports.userAssertValidProtocol = userAssertValidProtocol;
exports.getSourceOriginForElement = getSourceOriginForElement;
exports.resolveImgSrc = resolveImgSrc;
exports.shouldShowStoryUrlInfo = shouldShowStoryUrlInfo;
exports.setTextBackgroundColor = setTextBackgroundColor;

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _shadowEmbed = require("../../../src/shadow-embed");

var _mode = require("../../../src/mode");

var _url = require("../../../src/url");

var _style = require("../../../src/style");

var _log = require("../../../src/log");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns millis as number if given a string(e.g. 1s, 200ms etc)
 * @param {string} time
 * @param {number=} fallbackMs Used when `time` is not a valid time string.
 * @return {number|undefined}
 */
function timeStrToMillis(time, fallbackMs) {
  if (fallbackMs === void 0) {
    fallbackMs = NaN;
  }

  var match = time.toLowerCase().match(/^([0-9\.]+)\s*(s|ms)$/);
  var num = match ? match[1] : undefined;
  var units = match ? match[2] : undefined;

  if (!match || match.length !== 3 || units !== 's' && units !== 'ms') {
    return fallbackMs;
  }

  return Math.round((units == 's' ? 1000 : 1) * parseFloat(num));
}

/**
 * Determines whether the specified element has an action for its on="tap:..."
 * handler.
 * @param {!Element} el
 * @return {boolean}
 */
function hasTapAction(el) {
  // There are better ways to determine this, but they're all bound to action
  // service race conditions. This is good enough for our use case.
  return el.hasAttribute('on') && !!el.getAttribute('on').match(/(^|;)\s*tap\s*:/);
}

/**
 * Calculates a client rect without applying scaling transformations.
 * Note: must be run in a vsync measure context.
 * @param {!Element} el
 * @return {!ClientRect}
 */
function unscaledClientRect(el) {
  var _el$getBoundingClient = el.
  /*OK*/
  getBoundingClientRect(),
      width = _el$getBoundingClient.width,
      height = _el$getBoundingClient.height,
      left = _el$getBoundingClient.left,
      top = _el$getBoundingClient.top;

  var scaleFactorX = width == 0 ? 1 : width / el.
  /*OK*/
  offsetWidth;
  var scaleFactorY = height == 0 ? 1 : height / el.
  /*OK*/
  offsetHeight;
  return (
    /** @type {!ClientRect} */
    {
      left: left / scaleFactorX,
      top: top / scaleFactorY,
      width: width / scaleFactorX,
      height: height / scaleFactorY
    }
  );
}

/**
 * Finds an amp-video/amp-audio ancestor.
 * @param {!Element} el
 * @return {?AmpElement}
 */
function ampMediaElementFor(el) {
  return (0, _dom.closestAncestorElementBySelector)(el, 'amp-video, amp-audio');
}

/**
 * Creates a shadow root for the provided container, and appends the element
 * along with its CSS.
 * @param  {!Element} container
 * @param  {!Element} element
 * @param  {string} css
 */
function createShadowRootWithStyle(container, element, css) {
  var style = self.document.createElement('style');
  style.
  /*OK*/
  textContent = css;
  var containerToUse = (0, _mode.getMode)().test ? container : (0, _shadowEmbed.createShadowRoot)(container);
  containerToUse.appendChild(style);
  containerToUse.appendChild(element);
}

/**
 * Parses the resolved CSS color property, that is always in the form of
 * `rgba(0, 0, 0, 1)` or `rgb(0, 0, 0)`, that can be retrieved using
 * `getComputedStyle`.
 * Returns an object containing the R, G, and B 8bit numbers.
 * @param  {string} cssValue
 * @return {!Object<string, number>}
 */
function getRGBFromCssColorValue(cssValue) {
  var regexPattern = /rgba?\((\d{1,3}), (\d{1,3}), (\d{1,3})/;

  if (!cssValue.match(regexPattern)) {
    (0, _log.user)().error('UTILS', 'getRGBFromCssColorValue expects a parameter in ' + ("the form of 'rgba(0, 0, 0, 1)' or 'rgb(0, 0, 0)' but got " + cssValue));
    // Returns a fallback value, to fail 'gracefully' in case a browser we don't
    // know about gave an unexpected value.
    return {
      r: 0,
      g: 0,
      b: 0
    };
  }

  var matches = regexPattern.exec(cssValue);
  return {
    r: Number(matches[1]),
    g: Number(matches[2]),
    b: Number(matches[3])
  };
}

/**
 * Returns the color, either black or white, that has the best contrast ratio
 * against the provided RGB 8bit values.
 * @param  {!Object<string, number>} rgb  ie: {r: 0, g: 0, b: 0}
 * @return {string} '#fff' or '#000'
 */
function getTextColorForRGB(rgb) {
  var r = rgb.r,
      g = rgb.g,
      b = rgb.b;

  // Calculates the relative luminance L.
  // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
  var getLinearRGBValue = function getLinearRGBValue(x) {
    // 8bit to sRGB.
    x /= 255;
    // Converts the gamma-compressed RGB values to linear RGB.
    return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  };

  var linearR = getLinearRGBValue(r);
  var linearG = getLinearRGBValue(g);
  var linearB = getLinearRGBValue(b);
  var L = 0.2126 * linearR + 0.7152 * linearG + 0.0722 * linearB;
  // Determines which one of the white and black text have a better contrast
  // ratio against the used background color.
  // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
  // @TODO(gmajoulet): Improve the text color for high contrast ratio.
  // 1 is L for #FFF, and 0 is L for #000.
  // (1 + 0.05) / (L + 0.05) > (L + 0.05) / (0 + 0.05) toggles for L = 0.179.
  return L > 0.179 ? '#000' : '#FFF';
}

/**
 * Sets given attribute to the given element in next `mutate` phase.
 * @param {!AMP.BaseElement} elementImpl
 * @param {string} name
 * @param {string=} opt_value
 */
function setAttributeInMutate(elementImpl, name, opt_value) {
  var value = opt_value || '';
  elementImpl.mutateElement(function () {
    elementImpl.element.setAttribute(name, value);
  });
}

/**
 * Removes given attribute from the given element in next `mutate` phase.
 * @param {!AMP.BaseElement} elementImpl
 * @param {string} name
 */
function removeAttributeInMutate(elementImpl, name) {
  elementImpl.mutateElement(function () {
    elementImpl.element.removeAttribute(name);
  });
}

/**
 * @param {!Element} element
 * @param {string|!Location} url
 */
function userAssertValidProtocol(element, url) {
  (0, _log.userAssert)(_services.Services.urlForDoc(element).isProtocolValid(url), 'Unsupported protocol for URL %s', url);
}

/**
 * Gets the origin url for elements that display a url. It
 * trims the protocol prefix and returns only the hostname of the origin.
 * @param {!Element} element
 * @param {string} url
 * @return {string}
 */
function getSourceOriginForElement(element, url) {
  var domainName;

  try {
    domainName = (0, _url.getSourceOrigin)(_services.Services.urlForDoc(element).parse(url));
    // Remove protocol prefix.
    domainName = _services.Services.urlForDoc(element).parse(domainName).hostname;
  } catch (e) {
    // Unknown path prefix in url.
    domainName = _services.Services.urlForDoc(element).parse(url).hostname;
  }

  return domainName;
}

/**
 * Resolves an image url and optimizes it if served from the cache.
 * @param {!Window} win
 * @param {string} url
 * @return {string}
 */
function resolveImgSrc(win, url) {
  var urlSrc = (0, _url.resolveRelativeUrl)(url, win.location);

  if ((0, _url.isProxyOrigin)(win.location.href)) {
    // TODO(Enriqe): add extra params for resized image, for example:
    // (/ii/w${width}/s)
    urlSrc = urlSrc.replace('/c/s/', '/i/s/');
  }

  return urlSrc;
}

/**
 * Whether a Story should show the URL info dialog.
 * @param {!../../../src/service/viewer-interface.ViewerInterface} viewer
 * @return {boolean}
 */
function shouldShowStoryUrlInfo(viewer) {
  var showStoryUrlInfo = viewer.getParam('showStoryUrlInfo');
  return showStoryUrlInfo ? showStoryUrlInfo !== '0' : viewer.isEmbedded();
}

/**
 * The attribute name for text background color
 * @private @const {string}
 */
var TEXT_BACKGROUND_COLOR_ATTRIBUTE_NAME = 'data-text-background-color';

/**
 * The selector for text background color
 * @private @const {string}
 */
var TEXT_BACKGROUND_COLOR_SELECTOR = "[" + TEXT_BACKGROUND_COLOR_ATTRIBUTE_NAME + "]";

/**
 * Styles text with a background color based on the value of
 * the data-text-background-color attribute
 * @param {!Element} element
 */
function setTextBackgroundColor(element) {
  var elementsToUpgradeStyles = (0, _dom.scopedQuerySelectorAll)(element, TEXT_BACKGROUND_COLOR_SELECTOR);
  Array.prototype.forEach.call(elementsToUpgradeStyles, function (el) {
    var color = el.getAttribute(TEXT_BACKGROUND_COLOR_ATTRIBUTE_NAME);
    (0, _style.setStyle)(el, 'background-color', color);
  });
}

},{"../../../src/dom":9,"../../../src/log":19,"../../../src/mode":20,"../../../src/services":25,"../../../src/shadow-embed":26,"../../../src/style":30,"../../../src/url":34}],6:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CommonSignals = void 0;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Commonly used signals across different elements and documents.
 * @enum {string}
 */
var CommonSignals = {
  /**
   * The element has been upgraded from ElementStub to its real implementation.
   */
  UPGRADED: 'upgraded',

  /**
   * The element has been built.
   */
  BUILT: 'built',

  /**
   * The element has started loading.
   * LOAD_START triggers at the start of the layoutCallback.
   */
  LOAD_START: 'load-start',

  /**
   * Rendering has been confirmed to have been started.
   * It is a signal to indicate meaningful display (e.g. text could be displayed
   * CSS is correctly installed/applied).
   *
   * Elements can optionally implement RENDER_START signal. (e.g. ad, shadowdoc)
   * if it want to define its own meaningful display time and toggle visibility.
   *
   * Simpler elements's RENDER_START can be equal to the start of the
   * buildCallback
   */
  RENDER_START: 'render-start',

  /**
   * The element has been loaded.
   * LOAD_END triggers at the end of the layoutCallback.
   *
   */
  LOAD_END: 'load-end',

  /**
   * The initial contents of an element/document/embed have been loaded.
   * INI_LOAD is an optional signal, implemented by ads, story, and elements
   * that consist of other resources.
   * It instructs that all critical resources has been loaded, and can be used
   * for more accurate visibility measurement.
   * When an element doesn't consist multiple child resources, LOAD_END signal
   * can be used to indicate resource load completion.
   * Note: Based on the implementation, INI_LOAD can trigger before or after
   * LOAD_END.
   */
  INI_LOAD: 'ini-load',

  /**
   * The element has been unlaid out.
   */
  UNLOAD: 'unload'
};
exports.CommonSignals = CommonSignals;

},{}],7:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.config = exports.urls = void 0;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Allows for runtime configuration. Internally, the runtime should
 * use the src/config.js module for various constants. We can use the
 * AMP_CONFIG global to translate user-defined configurations to this
 * module.
 * @type {!Object<string, string>}
 */
var env = self.AMP_CONFIG || {};
var thirdPartyFrameRegex = (typeof env['thirdPartyFrameRegex'] == 'string' ? new RegExp(env['thirdPartyFrameRegex']) : env['thirdPartyFrameRegex']) || /^d-\d+\.ampproject\.net$/;
var cdnProxyRegex = (typeof env['cdnProxyRegex'] == 'string' ? new RegExp(env['cdnProxyRegex']) : env['cdnProxyRegex']) || /^https:\/\/([a-zA-Z0-9_-]+\.)?cdn\.ampproject\.org$/;

/**
 * Check for a custom URL definition in special <meta> tags. Note that this does
 * not allow for distinct custom URLs in AmpDocShadow instances. The shell is
 * allowed to define one set of custom URLs via AMP_CONFIG (recommended) or by
 * including <meta> tags in the shell <head>. Those custom URLs then apply to
 * all AMP documents loaded in the shell.
 * @param {string} name
 * @return {?string}
 * @private
 */
function getMetaUrl(name) {
  // Avoid exceptions in unit tests
  if (!self.document || !self.document.head) {
    return null;
  }

  // Disallow on proxy origins
  if (self.location && cdnProxyRegex.test(self.location.origin)) {
    return null;
  }

  var metaEl = self.document.head.
  /*OK*/
  querySelector("meta[name=\"" + name + "\"]");
  return metaEl && metaEl.getAttribute('content') || null;
}

/** @type {!Object<string, string|boolean|RegExp|Array<RegExp>>} */
var urls = {
  thirdParty: env['thirdPartyUrl'] || 'https://3p.ampproject.net',
  thirdPartyFrameHost: env['thirdPartyFrameHost'] || 'ampproject.net',
  thirdPartyFrameRegex: thirdPartyFrameRegex,
  cdn: env['cdnUrl'] || getMetaUrl('runtime-host') || 'https://cdn.ampproject.org',

  /* Note that cdnProxyRegex is only ever checked against origins
   * (proto://host[:port]) so does not need to consider path
   */
  cdnProxyRegex: cdnProxyRegex,
  localhostRegex: /^https?:\/\/localhost(:\d+)?$/,
  errorReporting: env['errorReportingUrl'] || 'https://us-central1-amp-error-reporting.cloudfunctions.net/r',
  betaErrorReporting: env['betaErrorReportingUrl'] || 'https://us-central1-amp-error-reporting.cloudfunctions.net/r-beta',
  localDev: env['localDev'] || false,

  /**
   * These domains are trusted with more sensitive viewer operations such as
   * propagating the referrer. If you believe your domain should be here,
   * file the issue on GitHub to discuss. The process will be similar
   * (but somewhat more stringent) to the one described in the [3p/README.md](
   * https://github.com/ampproject/amphtml/blob/master/3p/README.md)
   *
   * {!Array<!RegExp>}
   */
  trustedViewerHosts: [/(^|\.)google\.(com?|[a-z]{2}|com?\.[a-z]{2}|cat)$/, /(^|\.)gmail\.(com|dev)$/],
  // Optional fallback API if amp-geo is left unpatched
  geoApi: env['geoApiUrl'] || getMetaUrl('amp-geo-api')
};
exports.urls = urls;
var config = {
  urls: urls
};
exports.config = config;

},{}],8:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.assertIsName = assertIsName;
exports.setScopeSelectorSupportedForTesting = setScopeSelectorSupportedForTesting;
exports.isScopeSelectorSupported = isScopeSelectorSupported;
exports.prependSelectorsWith = prependSelectorsWith;
exports.escapeCssSelectorIdent = escapeCssSelectorIdent;
exports.escapeCssSelectorNth = escapeCssSelectorNth;

var _cssEscape = require("../third_party/css-escape/css-escape");

var _log = require("./log");

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Asserts that name is just an alphanumeric word, and does not contain
 * advanced CSS selector features like attributes, psuedo-classes, class names,
 * nor ids.
 * @param {string} name
 */
function assertIsName(name) {
  (0, _log.devAssert)(/^[\w-]+$/.test(name));
}

/**
 * @type {boolean|undefined}
 */
var scopeSelectorSupported;

/**
 * @param {boolean|undefined} val
 * @visibleForTesting
 */
function setScopeSelectorSupportedForTesting(val) {
  scopeSelectorSupported = val;
}

/**
 * Test that the :scope selector is supported and behaves correctly.
 * @param {!Element|!ShadowRoot} el
 * @return {boolean}
 */
function isScopeSelectorSupported(el) {
  if (scopeSelectorSupported !== undefined) {
    return scopeSelectorSupported;
  }

  return scopeSelectorSupported = testScopeSelector(el);
}

/**
 * Test that the :scope selector is supported and behaves correctly.
 * @param {!Element|!ShadowRoot} el
 * @return {boolean}
 */
function testScopeSelector(el) {
  try {
    var doc = el.ownerDocument;
    var testElement = doc.createElement('div');
    var testChild = doc.createElement('div');
    testElement.appendChild(testChild);
    // NOTE(cvializ, #12383): Firefox's implementation is incomplete,
    // therefore we test actual functionality of`:scope` as well.
    return testElement.
    /*OK*/
    querySelector(':scope div') === testChild;
  } catch (e) {
    return false;
  }
}

/**
 * Prefixes a selector for ancestor selection. Splits in subselectors and
 * applies prefix to each.
 *
 * e.g.
 * ```
 *   prependSelectorsWith('div', '.i-amphtml-scoped');
 *   // => '.i-amphtml-scoped div'
 *   prependSelectorsWith('div, ul', ':scope');
 *   // => ':scope div, :scope ul'
 *   prependSelectorsWith('div, ul', 'article >');
 *   // => 'article > div, article > ul'
 * ```
 *
 * @param {string} selector
 * @param {string} distribute
 * @return {string}
 */
function prependSelectorsWith(selector, distribute) {
  return selector.replace(/^|,/g, "$&" + distribute + " ");
}

/**
 * Escapes an ident (ID or a class name) to be used as a CSS selector.
 *
 * See https://drafts.csswg.org/cssom/#serialize-an-identifier.
 *
 * @param {string} ident
 * @return {string}
 */
function escapeCssSelectorIdent(ident) {
  if (false) {
    return CSS.escape(ident);
  }

  return (0, _cssEscape.cssEscape)(ident);
}

/**
 * Escapes an ident in a way that can be used by :nth-child() psuedo-class.
 *
 * See https://github.com/w3c/csswg-drafts/issues/2306.
 *
 * @param {string|number} ident
 * @return {string}
 */
function escapeCssSelectorNth(ident) {
  var escaped = String(ident);
  // Ensure it doesn't close the nth-child psuedo class.
  (0, _log.devAssert)(escaped.indexOf(')') === -1);
  return escaped;
}

},{"../third_party/css-escape/css-escape":42,"./log":19}],9:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.waitForChild = waitForChild;
exports.waitForChildPromise = waitForChildPromise;
exports.waitForBodyOpen = waitForBodyOpen;
exports.waitForBodyOpenPromise = waitForBodyOpenPromise;
exports.removeElement = removeElement;
exports.removeChildren = removeChildren;
exports.copyChildren = copyChildren;
exports.insertAfterOrAtStart = insertAfterOrAtStart;
exports.insertAtStart = insertAtStart;
exports.addAttributesToElement = addAttributesToElement;
exports.createElementWithAttributes = createElementWithAttributes;
exports.isConnectedNode = isConnectedNode;
exports.rootNodeFor = rootNodeFor;
exports.isShadowRoot = isShadowRoot;
exports.closest = closest;
exports.closestNode = closestNode;
exports.closestAncestorElementBySelector = closestAncestorElementBySelector;
exports.ancestorElements = ancestorElements;
exports.ancestorElementsByTag = ancestorElementsByTag;
exports.childElement = childElement;
exports.childElements = childElements;
exports.lastChildElement = lastChildElement;
exports.childNodes = childNodes;
exports.childElementByAttr = childElementByAttr;
exports.lastChildElementByAttr = lastChildElementByAttr;
exports.childElementsByAttr = childElementsByAttr;
exports.childElementByTag = childElementByTag;
exports.childElementsByTag = childElementsByTag;
exports.matches = matches;
exports.elementByTag = elementByTag;
exports.scopedQuerySelector = scopedQuerySelector;
exports.scopedQuerySelectorAll = scopedQuerySelectorAll;
exports.getDataParamsFromAttributes = getDataParamsFromAttributes;
exports.hasNextNodeInDocumentOrder = hasNextNodeInDocumentOrder;
exports.templateContentClone = templateContentClone;
exports.iterateCursor = iterateCursor;
exports.openWindowDialog = openWindowDialog;
exports.isJsonScriptTag = isJsonScriptTag;
exports.isJsonLdScriptTag = isJsonLdScriptTag;
exports.isRTL = isRTL;
exports.escapeHtml = escapeHtml;
exports.tryFocus = tryFocus;
exports.isIframed = isIframed;
exports.isAmpElement = isAmpElement;
exports.whenUpgradedToCustomElement = whenUpgradedToCustomElement;
exports.fullscreenEnter = fullscreenEnter;
exports.fullscreenExit = fullscreenExit;
exports.isFullscreenElement = isFullscreenElement;
exports.isEnabled = isEnabled;
exports.domOrderComparator = domOrderComparator;
exports.toggleAttribute = toggleAttribute;
exports.parseBooleanAttribute = parseBooleanAttribute;
exports.getVerticalScrollbarWidth = getVerticalScrollbarWidth;
exports.dispatchCustomEvent = dispatchCustomEvent;
exports.UPGRADE_TO_CUSTOMELEMENT_RESOLVER = exports.UPGRADE_TO_CUSTOMELEMENT_PROMISE = void 0;

var _promise = require("./utils/promise");

var _css = require("./css");

var _log = require("./log");

var _object = require("./utils/object");

var _string = require("./string");

var _types = require("./types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var HTML_ESCAPE_CHARS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};
var HTML_ESCAPE_REGEX = /(&|<|>|"|'|`)/g;

/** @const {string} */
var UPGRADE_TO_CUSTOMELEMENT_PROMISE = '__AMP_UPG_PRM';
exports.UPGRADE_TO_CUSTOMELEMENT_PROMISE = UPGRADE_TO_CUSTOMELEMENT_PROMISE;

/** @const {string} */
var UPGRADE_TO_CUSTOMELEMENT_RESOLVER = '__AMP_UPG_RES';
exports.UPGRADE_TO_CUSTOMELEMENT_RESOLVER = UPGRADE_TO_CUSTOMELEMENT_RESOLVER;

/**
 * Waits until the child element is constructed. Once the child is found, the
 * callback is executed.
 * @param {!Element} parent
 * @param {function(!Element):boolean} checkFunc
 * @param {function()} callback
 */
function waitForChild(parent, checkFunc, callback) {
  if (checkFunc(parent)) {
    callback();
    return;
  }

  /** @const {!Window} */
  var win = (0, _types.toWin)(parent.ownerDocument.defaultView);

  if (win.MutationObserver) {
    /** @const {MutationObserver} */
    var observer = new win.MutationObserver(function () {
      if (checkFunc(parent)) {
        observer.disconnect();
        callback();
      }
    });
    observer.observe(parent, {
      childList: true
    });
  } else {
    /** @const {number} */
    var interval = win.setInterval(function () {
      if (checkFunc(parent)) {
        win.clearInterval(interval);
        callback();
      }
    },
    /* milliseconds */
    5);
  }
}

/**
 * Waits until the child element is constructed. Once the child is found, the
 * promise is resolved.
 * @param {!Element} parent
 * @param {function(!Element):boolean} checkFunc
 * @return {!Promise}
 */
function waitForChildPromise(parent, checkFunc) {
  return new Promise(function (resolve) {
    waitForChild(parent, checkFunc, resolve);
  });
}

/**
 * Waits for document's body to be available and ready.
 * @param {!Document} doc
 * @param {function()} callback
 */
function waitForBodyOpen(doc, callback) {
  waitForChild(doc.documentElement, function () {
    return !!doc.body;
  }, callback);
}

/**
 * Waits for document's body to be available.
 * @param {!Document} doc
 * @return {!Promise}
 */
function waitForBodyOpenPromise(doc) {
  return new Promise(function (resolve) {
    return waitForBodyOpen(doc, resolve);
  });
}

/**
 * Removes the element.
 * @param {!Element} element
 */
function removeElement(element) {
  if (element.parentElement) {
    element.parentElement.removeChild(element);
  }
}

/**
 * Removes all child nodes of the specified element.
 * @param {!Element|!DocumentFragment} parent
 */
function removeChildren(parent) {
  while (parent.firstChild) {
    parent.removeChild(parent.firstChild);
  }
}

/**
 * Copies all children nodes of element "from" to element "to". Child nodes
 * are deeply cloned. Notice, that this method should be used with care and
 * preferably on smaller subtrees.
 * @param {!Element} from
 * @param {!Element|!DocumentFragment} to
 */
function copyChildren(from, to) {
  var frag = to.ownerDocument.createDocumentFragment();

  for (var n = from.firstChild; n; n = n.nextSibling) {
    frag.appendChild(n.cloneNode(true));
  }

  to.appendChild(frag);
}

/**
 * Insert the element in the root after the element named after or
 * if that is null at the beginning.
 * @param {!Element|!ShadowRoot} root
 * @param {!Element} element
 * @param {?Node=} after
 */
function insertAfterOrAtStart(root, element, after) {
  if (after === void 0) {
    after = null;
  }

  if (!after) {
    insertAtStart(root, element);
    return;
  }

  var before = after.nextSibling;
  root.insertBefore(element, before);
}

/**
 * Insert the element in the root after the element named after or
 * if that is null at the beginning.
 * @param {!Element|!ShadowRoot} root
 * @param {!Element} element
 */
function insertAtStart(root, element) {
  root.insertBefore(element, root.firstChild);
}

/**
 * Add attributes to an element.
 * @param {!Element} element
 * @param {!JsonObject<string, string>} attributes
 * @return {!Element} created element
 */
function addAttributesToElement(element, attributes) {
  for (var attr in attributes) {
    element.setAttribute(attr, attributes[attr]);
  }

  return element;
}

/**
 * Create a new element on document with specified tagName and attributes.
 * @param {!Document} doc
 * @param {string} tagName
 * @param {!JsonObject<string, string>} attributes
 * @return {!Element} created element
 */
function createElementWithAttributes(doc, tagName, attributes) {
  var element = doc.createElement(tagName);
  return addAttributesToElement(element, attributes);
}

/**
 * Returns true if node is connected (attached).
 * @param {!Node} node
 * @return {boolean}
 * @see https://dom.spec.whatwg.org/#connected
 */
function isConnectedNode(node) {
  var connected = node.isConnected;

  if (connected !== undefined) {
    return connected;
  }

  // "An element is connected if its shadow-including root is a document."
  var n = node;

  do {
    n = rootNodeFor(n);

    if (n.host) {
      n = n.host;
    } else {
      break;
    }
  } while (true);

  return n.nodeType === Node.DOCUMENT_NODE;
}

/**
 * Returns the root for a given node. Does not cross shadow DOM boundary.
 * @param {!Node} node
 * @return {!Node}
 */
function rootNodeFor(node) {
  if (Node.prototype.getRootNode) {
    // Type checker says `getRootNode` may return null.
    return node.getRootNode() || node;
  }

  var n;

  // Check isShadowRoot() is only needed for the polyfill case.
  for (n = node; !!n.parentNode && !isShadowRoot(n); n = n.parentNode) {}

  return n;
}

/**
 * Determines if value is actually a `ShadowRoot` node.
 * @param {*} value
 * @return {boolean}
 */
function isShadowRoot(value) {
  if (!value) {
    return false;
  }

  // Node.nodeType == DOCUMENT_FRAGMENT to speed up the tests. Unfortunately,
  // nodeType of DOCUMENT_FRAGMENT is used currently for ShadowRoot nodes.
  if (value.tagName == 'I-AMPHTML-SHADOW-ROOT') {
    return true;
  }

  return value.nodeType ==
  /* DOCUMENT_FRAGMENT */
  11 && Object.prototype.toString.call(value) === '[object ShadowRoot]';
}

/**
 * Finds the closest element that satisfies the callback from this element
 * up the DOM subtree.
 * @param {!Element} element
 * @param {function(!Element):boolean} callback
 * @param {Element=} opt_stopAt optional elemnt to stop the search at.
 * @return {?Element}
 */
function closest(element, callback, opt_stopAt) {
  for (var el = element; el && el !== opt_stopAt; el = el.parentElement) {
    if (callback(el)) {
      return el;
    }
  }

  return null;
}

/**
 * Finds the closest node that satisfies the callback from this node
 * up the DOM subtree.
 * @param {!Node} node
 * @param {function(!Node):boolean} callback
 * @return {?Node}
 */
function closestNode(node, callback) {
  for (var n = node; n; n = n.parentNode) {
    if (callback(n)) {
      return n;
    }
  }

  return null;
}

/**
 * Finds the closest ancestor element with the specified selector from this
 * element.
 * @param {!Element} element
 * @param {string} selector
 * @return {?Element} closest ancestor if found.
 */
function closestAncestorElementBySelector(element, selector) {
  if (element.closest) {
    return element.closest(selector);
  }

  return closest(element, function (el) {
    return matches(el, selector);
  });
}

/**
 * Finds all ancestor elements that satisfy predicate.
 * @param {!Element} child
 * @param {function(!Element):boolean} predicate
 * @return {!Array<!Element>}
 */
function ancestorElements(child, predicate) {
  var ancestors = [];

  for (var ancestor = child.parentElement; ancestor; ancestor = ancestor.parentElement) {
    if (predicate(ancestor)) {
      ancestors.push(ancestor);
    }
  }

  return ancestors;
}

/**
 * Finds all ancestor elements that has the specified tag name.
 * @param {!Element} child
 * @param {string} tagName
 * @return {!Array<!Element>}
 */
function ancestorElementsByTag(child, tagName) {
  (0, _css.assertIsName)(tagName);
  tagName = tagName.toUpperCase();
  return ancestorElements(child, function (el) {
    return el.tagName == tagName;
  });
}

/**
 * Finds the first child element that satisfies the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {?Element}
 */
function childElement(parent, callback) {
  for (var child = parent.firstElementChild; child; child = child.nextElementSibling) {
    if (callback(child)) {
      return child;
    }
  }

  return null;
}

/**
 * Finds all child elements that satisfy the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {!Array<!Element>}
 */
function childElements(parent, callback) {
  var children = [];

  for (var child = parent.firstElementChild; child; child = child.nextElementSibling) {
    if (callback(child)) {
      children.push(child);
    }
  }

  return children;
}

/**
 * Finds the last child element that satisfies the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {?Element}
 */
function lastChildElement(parent, callback) {
  for (var child = parent.lastElementChild; child; child = child.previousElementSibling) {
    if (callback(child)) {
      return child;
    }
  }

  return null;
}

/**
 * Finds all child nodes that satisfy the callback.
 * These nodes can include Text, Comment and other child nodes.
 * @param {!Node} parent
 * @param {function(!Node):boolean} callback
 * @return {!Array<!Node>}
 */
function childNodes(parent, callback) {
  var nodes = [];

  for (var child = parent.firstChild; child; child = child.nextSibling) {
    if (callback(child)) {
      nodes.push(child);
    }
  }

  return nodes;
}

/**
 * Finds the first child element that has the specified attribute.
 * @param {!Element|!ShadowRoot} parent
 * @param {string} attr
 * @return {?Element}
 */
function childElementByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return (
    /*OK*/
    scopedQuerySelector(parent, "> [" + attr + "]")
  );
}

/**
 * Finds the last child element that has the specified attribute.
 * @param {!Element} parent
 * @param {string} attr
 * @return {?Element}
 */
function lastChildElementByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return lastChildElement(parent, function (el) {
    return el.hasAttribute(attr);
  });
}

/**
 * Finds all child elements that has the specified attribute.
 * @param {!Element|!ShadowRoot} parent
 * @param {string} attr
 * @return {!NodeList<!Element>}
 */
function childElementsByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return (
    /*OK*/
    scopedQuerySelectorAll(parent, "> [" + attr + "]")
  );
}

/**
 * Finds the first child element that has the specified tag name.
 * @param {!Element|!ShadowRoot} parent
 * @param {string} tagName
 * @return {?Element}
 */
function childElementByTag(parent, tagName) {
  (0, _css.assertIsName)(tagName);
  return (
    /*OK*/
    scopedQuerySelector(parent, "> " + tagName)
  );
}

/**
 * Finds all child elements with the specified tag name.
 * @param {!Element|!ShadowRoot} parent
 * @param {string} tagName
 * @return {!NodeList<!Element>}
 */
function childElementsByTag(parent, tagName) {
  (0, _css.assertIsName)(tagName);
  return (
    /*OK*/
    scopedQuerySelectorAll(parent, "> " + tagName)
  );
}

/**
 * Checks if the given element matches the selector
 * @param  {!Element} el The element to verify
 * @param  {string} selector The selector to check against
 * @return {boolean} True if the element matched the selector. False otherwise.
 */
function matches(el, selector) {
  var matcher = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector;

  if (matcher) {
    return matcher.call(el, selector);
  }

  return false;
}

/**
 * Finds the first descendant element with the specified name.
 * @param {!Element|!Document|!ShadowRoot} element
 * @param {string} tagName
 * @return {?Element}
 */
function elementByTag(element, tagName) {
  (0, _css.assertIsName)(tagName);
  return element.
  /*OK*/
  querySelector(tagName);
}

/**
 * Finds all elements that matche `selector`, scoped inside `root`
 * for user-agents that do not support native scoping.
 *
 * This method isn't required for modern builds, can be removed.
 *
 * @param {!Element|!ShadowRoot} root
 * @param {string} selector
 * @return {!NodeList<!Element>}
 */
function scopedQuerySelectionFallback(root, selector) {
  var unique = 'i-amphtml-scoped';
  root.classList.add(unique);
  var scopedSelector = (0, _css.prependSelectorsWith)(selector, "." + unique);
  var elements = root.
  /*OK*/
  querySelectorAll(scopedSelector);
  root.classList.remove(unique);
  return elements;
}

/**
 * Finds the first element that matches `selector`, scoped inside `root`.
 * Note: in IE, this causes a quick mutation of the element's class list.
 * @param {!Element|!ShadowRoot} root
 * @param {string} selector
 * @return {?Element}
 */
function scopedQuerySelector(root, selector) {
  if ((0, _css.isScopeSelectorSupported)(root)) {
    return root.
    /*OK*/
    querySelector((0, _css.prependSelectorsWith)(selector, ':scope'));
  }

  // Only IE.
  var fallbackResult = scopedQuerySelectionFallback(root, selector);
  return fallbackResult[0] === undefined ? null : fallbackResult[0];
}

/**
 * Finds every element that matches `selector`, scoped inside `root`.
 * Note: in IE, this causes a quick mutation of the element's class list.
 * @param {!Element|!ShadowRoot} root
 * @param {string} selector
 * @return {!NodeList<!Element>}
 */
function scopedQuerySelectorAll(root, selector) {
  if ((0, _css.isScopeSelectorSupported)(root)) {
    return root.
    /*OK*/
    querySelectorAll((0, _css.prependSelectorsWith)(selector, ':scope'));
  }

  // Only IE.
  return scopedQuerySelectionFallback(root, selector);
}

/**
 * Returns element data-param- attributes as url parameters key-value pairs.
 * e.g. data-param-some-attr=value -> {someAttr: value}.
 * @param {!Element} element
 * @param {function(string):string=} opt_computeParamNameFunc to compute the
 *    parameter name, get passed the camel-case parameter name.
 * @param {!RegExp=} opt_paramPattern Regex pattern to match data attributes.
 * @return {!JsonObject}
 */
function getDataParamsFromAttributes(element, opt_computeParamNameFunc, opt_paramPattern) {
  var computeParamNameFunc = opt_computeParamNameFunc || function (key) {
    return key;
  };

  var dataset = element.dataset;
  var params = (0, _object.dict)();
  var paramPattern = opt_paramPattern ? opt_paramPattern : /^param(.+)/;

  for (var key in dataset) {
    var _matches = key.match(paramPattern);

    if (_matches) {
      var param = _matches[1][0].toLowerCase() + _matches[1].substr(1);

      params[computeParamNameFunc(param)] = dataset[key];
    }
  }

  return params;
}

/**
 * Whether the element have a next node in the document order.
 * This means either:
 *  a. The element itself has a nextSibling.
 *  b. Any of the element ancestors has a nextSibling.
 * @param {!Element} element
 * @param {?Node} opt_stopNode
 * @return {boolean}
 */
function hasNextNodeInDocumentOrder(element, opt_stopNode) {
  var currentElement = element;

  do {
    if (currentElement.nextSibling) {
      return true;
    }
  } while ((currentElement = currentElement.parentNode) && currentElement != opt_stopNode);

  return false;
}

/**
 * Returns a clone of the content of a template element.
 *
 * Polyfill to replace .content access for browsers that do not support
 * HTMLTemplateElements natively.
 *
 * @param {!HTMLTemplateElement|!Element} template
 * @return {!DocumentFragment}
 */
function templateContentClone(template) {
  if ('content' in template) {
    return template.content.cloneNode(true);
  } else {
    var content = template.ownerDocument.createDocumentFragment();
    copyChildren(template, content);
    return content;
  }
}

/**
 * Iterate over an array-like.
 * Test cases: https://jsbench.github.io/#f638cacc866a1b2d6e517e6cfa900d6b
 * @param {!IArrayLike<T>} iterable
 * @param {function(T, number)} cb
 * @template T
 */
function iterateCursor(iterable, cb) {
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    cb(iterable[i], i);
  }
}

/**
 * This method wraps around window's open method. It first tries to execute
 * `open` call with the provided target and if it fails, it retries the call
 * with the `_top` target. This is necessary given that in some embedding
 * scenarios, such as iOS' WKWebView, navigation to `_blank` and other targets
 * is blocked by default.
 *
 * @param {!Window} win
 * @param {string} url
 * @param {string} target
 * @param {string=} opt_features
 * @return {?Window}
 */
function openWindowDialog(win, url, target, opt_features) {
  // Try first with the specified target. If we're inside the WKWebView or
  // a similar environments, this method is expected to fail by default for
  // all targets except `_top`.
  var res;

  try {
    res = win.open(url, target, opt_features);
  } catch (e) {
    (0, _log.dev)().error('DOM', 'Failed to open url on target: ', target, e);
  }

  // Then try with `_top` target.
  if (!res && target != '_top' && !(0, _string.includes)(opt_features || '', 'noopener')) {
    res = win.open(url, '_top');
  }

  return res;
}

/**
 * Whether the element is a script tag with application/json type.
 * @param {!Element} element
 * @return {boolean}
 */
function isJsonScriptTag(element) {
  return element.tagName == 'SCRIPT' && element.hasAttribute('type') && element.getAttribute('type').toUpperCase() == 'APPLICATION/JSON';
}

/**
 * Whether the element is a script tag with application/json type.
 * @param {!Element} element
 * @return {boolean}
 */
function isJsonLdScriptTag(element) {
  return element.tagName == 'SCRIPT' && element.getAttribute('type').toUpperCase() == 'APPLICATION/LD+JSON';
}

/**
 * Whether the page's direction is right to left or not.
 * @param {!Document} doc
 * @return {boolean}
 */
function isRTL(doc) {
  var dir = doc.body.getAttribute('dir') || doc.documentElement.getAttribute('dir') || 'ltr';
  return dir == 'rtl';
}

/**
 * Escapes `<`, `>` and other HTML charcaters with their escaped forms.
 * @param {string} text
 * @return {string}
 */
function escapeHtml(text) {
  if (!text) {
    return text;
  }

  return text.replace(HTML_ESCAPE_REGEX, escapeHtmlChar);
}

/**
 * @param {string} c
 * @return {string}
 */
function escapeHtmlChar(c) {
  return HTML_ESCAPE_CHARS[c];
}

/**
 * Tries to focus on the given element; fails silently if browser throws an
 * exception.
 * @param {!Element} element
 */
function tryFocus(element) {
  try {
    element.
    /*OK*/
    focus();
  } catch (e) {// IE <= 7 may throw exceptions when focusing on hidden items.
  }
}

/**
 * Whether the given window is in an iframe or not.
 * @param {!Window} win
 * @return {boolean}
 */
function isIframed(win) {
  return win.parent && win.parent != win;
}

/**
 * Determines if this element is an AMP element
 * @param {!Element} element
 * @return {boolean}
 */
function isAmpElement(element) {
  var tag = element.tagName;
  // Use prefix to recognize AMP element. This is necessary because stub
  // may not be attached yet.
  return tag.startsWith('AMP-') && // Some "amp-*" elements are not really AMP elements. :smh:
  !(tag == 'AMP-STICKY-AD-TOP-PADDING' || tag == 'AMP-BODY');
}

/**
 * Return a promise that resolve when an AMP element upgrade from HTMLElement
 * to CustomElement
 * @param {!Element} element
 * @return {!Promise<!Element>}
 */
function whenUpgradedToCustomElement(element) {
  (0, _log.devAssert)(isAmpElement(element), 'element is not AmpElement');

  if (element.createdCallback) {
    // Element already is CustomElement;
    return Promise.resolve(element);
  }

  // If Element is still HTMLElement, wait for it to upgrade to customElement
  // Note: use pure string to avoid obfuscation between versions.
  if (!element[UPGRADE_TO_CUSTOMELEMENT_PROMISE]) {
    var deferred = new _promise.Deferred();
    element[UPGRADE_TO_CUSTOMELEMENT_PROMISE] = deferred.promise;
    element[UPGRADE_TO_CUSTOMELEMENT_RESOLVER] = deferred.resolve;
  }

  return element[UPGRADE_TO_CUSTOMELEMENT_PROMISE];
}

/**
 * Replacement for `Element.requestFullscreen()` method.
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullscreen
 * @param {!Element} element
 */
function fullscreenEnter(element) {
  var requestFs = element.requestFullscreen || element.requestFullScreen || element.webkitRequestFullscreen || element.webkitEnterFullscreen || element.msRequestFullscreen || element.mozRequestFullScreen;

  if (requestFs) {
    requestFs.call(element);
  }
}

/**
 * Replacement for `Document.exitFullscreen()` method.
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/exitFullscreen
 * @param {!Element} element
 */
function fullscreenExit(element) {
  var elementBoundExit = element.cancelFullScreen || element.exitFullscreen || element.webkitExitFullscreen || element.webkitCancelFullScreen || element.mozCancelFullScreen || element.msExitFullscreen;

  if (elementBoundExit) {
    elementBoundExit.call(element);
    return;
  }

  var ownerDocument = element.ownerDocument;

  if (!ownerDocument) {
    return;
  }

  var docBoundExit = ownerDocument.cancelFullScreen || ownerDocument.exitFullscreen || ownerDocument.webkitExitFullscreen || ownerDocument.webkitCancelFullScreen || ownerDocument.mozCancelFullScreen || ownerDocument.msExitFullscreen;

  if (docBoundExit) {
    docBoundExit.call(ownerDocument);
  }
}

/**
 * Replacement for `Document.fullscreenElement`.
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreenElement
 * @param {!Element} element
 * @return {boolean}
 */
function isFullscreenElement(element) {
  var webkitDisplayingFullscreen = element.webkitDisplayingFullscreen;

  if (webkitDisplayingFullscreen !== undefined) {
    return webkitDisplayingFullscreen;
  }

  var ownerDocument = element.ownerDocument;

  if (!ownerDocument) {
    return false;
  }

  var fullscreenElement = ownerDocument.fullscreenElement || ownerDocument.webkitFullscreenElement || ownerDocument.mozFullScreenElement || ownerDocument.webkitCurrentFullScreenElement;
  return fullscreenElement == element;
}

/**
 * Returns true if node is not disabled.
 *
 * IE8 can return false positives, see {@link matches}.
 * @param {!Element} element
 * @return {boolean}
 * @see https://www.w3.org/TR/html5/forms.html#concept-fe-disabled
 */
function isEnabled(element) {
  return !(element.disabled || matches(element, ':disabled'));
}

/**
 * A sorting comparator that sorts elements in DOM tree order.
 * A first sibling is sorted to be before its nextSibling.
 * A parent node is sorted to be before a child.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
 *
 * @param {!Element} element1
 * @param {!Element} element2
 * @return {number}
 */
function domOrderComparator(element1, element2) {
  if (element1 === element2) {
    return 0;
  }

  var pos = element1.compareDocumentPosition(element2);
  var precedingOrContains = Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINS;

  // if fe2 is preceding or contains fe1 then, fe1 is after fe2
  if (pos & precedingOrContains) {
    return 1;
  }

  // if fe2 is following or contained by fe1, then fe1 is before fe2
  return -1;
}

/**
 * Like `Element.prototype.toggleAttribute`. This either toggles an attribute
 * on by adding an attribute with an empty value, or toggles it off by removing
 * the attribute. This does not mutate the element if the new state matches
 * the existing state.
 * @param {!Element} element An element to toggle the attribute for.
 * @param {string} name The name of the attribute.
 * @param {boolean=} forced Whether the attribute should be forced on/off. If
 *    not specified, it will be toggled from the current state.
 * @return {boolean} Whether or not the element now has the attribute.
 */
function toggleAttribute(element, name, forced) {
  var hasAttribute = element.hasAttribute(name);
  var enabled = forced !== undefined ? forced : !hasAttribute;

  if (enabled !== hasAttribute) {
    if (enabled) {
      element.setAttribute(name, '');
    } else {
      element.removeAttribute(name);
    }
  }

  return enabled;
}

/**
 * Parses a string as a boolean value using the expanded rules for DOM boolean
 * attributes:
 * - a `null` or `undefined` returns `null`;
 * - an empty string returns `true`;
 * - a "false" string returns `false`;
 * - otherwise, `true` is returned.
 *
 * @param {?string|undefined} s
 * @return {boolean|undefined}
 */
function parseBooleanAttribute(s) {
  return s == null ? undefined : s !== 'false';
}

/**
 * @param {!Window} win
 * @return {number} The width of the vertical scrollbar, in pixels.
 */
function getVerticalScrollbarWidth(win) {
  var documentElement = win.document.documentElement;
  var windowWidth = win.
  /*OK*/
  innerWidth;
  var documentWidth = documentElement.
  /*OK*/
  clientWidth;
  return windowWidth - documentWidth;
}

/**
 * Dispatches a custom event.
 *
 * @param {!Node} node
 * @param {string} name
 * @param {!Object=} opt_data Event data.
 */
function dispatchCustomEvent(node, name, opt_data) {
  var data = opt_data || {};
  // Constructors of events need to come from the correct window. Sigh.
  var event = node.ownerDocument.createEvent('Event');
  event.data = data;
  event.initEvent(name,
  /* bubbles */
  true,
  /* cancelable */
  true);
  node.dispatchEvent(event);
}

},{"./css":8,"./log":19,"./string":28,"./types":31,"./utils/object":39,"./utils/promise":40}],10:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getElementService = getElementService;
exports.getElementServiceIfAvailable = getElementServiceIfAvailable;
exports.getElementServiceForDoc = getElementServiceForDoc;
exports.getElementServiceIfAvailableForDoc = getElementServiceIfAvailableForDoc;
exports.getElementServiceIfAvailableForDocInEmbedScope = getElementServiceIfAvailableForDocInEmbedScope;
exports.extensionScriptsInNode = extensionScriptsInNode;
exports.isExtensionScriptInNode = isExtensionScriptInNode;

var _resolvedPromise2 = require("./resolved-promise");

var dom = _interopRequireWildcard(require("./dom"));

var _service = require("./service");

var _log = require("./log");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. Services.viewportForDoc(...)) for type safety and because the
 * factory should not be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an element,
 *     not the extension.
 * @return {!Promise<*>}
 */
function getElementService(win, id, extension, opt_element) {
  return getElementServiceIfAvailable(win, id, extension, opt_element).then(function (service) {
    return assertService(service, id, extension);
  });
}

/**
 * Same as getElementService but produces null if the given element is not
 * actually available on the current page.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an
 *     element, not the extension.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailable(win, id, extension, opt_element) {
  var s = (0, _service.getServicePromiseOrNull)(win, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      s
    );
  }

  return getElementServicePromiseOrNull(win, id, extension, opt_element);
}

/**
 * @param {!Window} win
 * @param {string} elementName Name of an extended custom element.
 * @return {boolean} Whether this element is scheduled to be loaded.
 */
function isElementScheduled(win, elementName) {
  // Set in custom-element.js
  if (!win.__AMP_EXTENDED_ELEMENTS) {
    return false;
  }

  return !!win.__AMP_EXTENDED_ELEMENTS[elementName];
}

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. Services.viewportForDoc(...)) for type safety and because the
 * factory should not be passed around.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an element,
 *     not the extension.
 * @return {!Promise<*>}
 */
function getElementServiceForDoc(element, id, extension, opt_element) {
  return getElementServiceIfAvailableForDoc(element, id, extension, opt_element).then(function (service) {
    return assertService(service, id, extension);
  });
}

/**
 * Same as getElementService but produces null if the given element is not
 * actually available on the current page.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an
 *     element, not the extension.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailableForDoc(element, id, extension, opt_element) {
  var s = (0, _service.getServicePromiseOrNullForDoc)(element, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      s
    );
  }

  var ampdoc = (0, _service.getAmpdoc)(element);
  return ampdoc.waitForBodyOpen().then(function () {
    return waitForExtensionIfPresent(ampdoc.win, extension, ampdoc.win.document.head);
  }).then(function () {
    // If this service is provided by an element, then we can't depend on
    // the service (they may not use the element).
    if (opt_element) {
      return (0, _service.getServicePromiseOrNullForDoc)(element, id);
    } else if (isElementScheduled(ampdoc.win, extension)) {
      return (0, _service.getServicePromiseForDoc)(element, id);
    }

    return null;
  });
}

/**
 * Returns a promise for service for the given id in the embed scope of
 * a given element, if it exists. Falls back to ampdoc scope if the element
 * is not embedded.
 *
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom element that provides
 *     the implementation of this service.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailableForDocInEmbedScope(element, id, extension) {
  var s = (0, _service.getServiceForDocOrNull)(element, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      Promise.resolve(s)
    );
  }

  return getElementServiceIfAvailableForDoc(element, id, extension);
}

/**
 * Throws user error if `service` is null.
 * @param {Object} service
 * @param {string} id
 * @param {string} extension
 * @return {!Object}
 * @private
 * @closurePrimitive {asserts.matchesReturn}
 */
function assertService(service, id, extension) {
  return (
    /** @type {!Object} */
    (0, _log.userAssert)(service, 'Service %s was requested to be provided through %s, ' + 'but %s is not loaded in the current page. To fix this ' + 'problem load the JavaScript file for %s in this page.', id, extension, extension, extension)
  );
}

/**
 * Get list of all the extension JS files.
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @return {!Array<string>}
 */
function extensionScriptsInNode(head) {
  // ampdoc.getHeadNode() can return null.
  if (!head) {
    return [];
  }

  var scripts = {};
  // Note: Some extensions don't have [custom-element] or [custom-template]
  // e.g. amp-viewer-integration.
  var list = head.querySelectorAll('script[custom-element],script[custom-template]');

  for (var i = 0; i < list.length; i++) {
    var script = list[i];
    var name = script.getAttribute('custom-element') || script.getAttribute('custom-template');
    scripts[name] = true;
  }

  return Object.keys(scripts);
}

/**
 * Waits for body to be present then verifies that an extension script is
 * present in head for installation.
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 * @param {string} extensionId
 * @return {!Promise<boolean>}
 */
function isExtensionScriptInNode(ampdoc, extensionId) {
  return ampdoc.waitForBodyOpen().then(function () {
    return extensionScriptInNode(ampdoc.getHeadNode(), extensionId);
  });
}

/**
 * Verifies that an extension script is present in head for
 * installation.
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @param {string} extensionId
 * @return {boolean}
 * @private
 */
function extensionScriptInNode(head, extensionId) {
  return extensionScriptsInNode(head).includes(extensionId);
}

/**
 * Waits for an extension if its script is present
 * @param {!Window} win
 * @param {string} extension
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @return {!Promise}
 * @private
 */
function waitForExtensionIfPresent(win, extension, head) {
  /**
   * If there is an extension script wait for it to load before trying
   * to get the service. Prevents a race condition when everything but
   * the extensions is in cache. If there is no script then it's either
   * not present, or the service was defined by a test. In those cases
   * we don't wait around for an extension that does not exist.
   */
  // TODO(jpettitt) investigate registerExtension to short circuit
  // the dom call in extensionScriptsInNode()
  if (!extensionScriptInNode(head, extension)) {
    return (0, _resolvedPromise2.resolvedPromise)();
  }

  var extensions = (0, _service.getService)(win, 'extensions');
  return (
    /** @type {!Promise<?Object>} */
    extensions.waitForExtension(win, extension)
  );
}

/**
 * Returns the promise for service with `id` on the given window if available.
 * Otherwise, resolves with null (service was not registered).
 * @param {!Window} win
 * @param {string} id
 * @param {string} extension
 * @param {boolean=} opt_element
 * @return {!Promise<Object>}
 * @private
 */
function getElementServicePromiseOrNull(win, id, extension, opt_element) {
  return dom.waitForBodyOpenPromise(win.document).then(function () {
    return waitForExtensionIfPresent(win, extension, win.document.head);
  }).then(function () {
    // If this service is provided by an element, then we can't depend on
    // the service (they may not use the element).
    if (opt_element) {
      return (0, _service.getServicePromiseOrNull)(win, id);
    } else if (isElementScheduled(win, extension)) {
      return (0, _service.getServicePromise)(win, id);
    }

    return null;
  });
}

},{"./dom":9,"./log":19,"./resolved-promise":23,"./service":24}],11:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.TickLabel = exports.AMPDOC_SINGLETON_NAME = void 0;

/**
 * Copyright 2020 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Registred singleton on AMP doc.
 * @enum {number}
 */
var AMPDOC_SINGLETON_NAME = {
  TRACKING_IFRAME: 1,
  LINKER: 2
};
exports.AMPDOC_SINGLETON_NAME = AMPDOC_SINGLETON_NAME;

/**
 * Enum for tick labels (used by Performance service)
 * @enum {string}
 */
var TickLabel = {
  ACCESS_AUTHORIZATION: 'aaa',
  ACCESS_AUTHORIZATION_VISIBLE: 'aaav',
  ADS_LAYOUT_DELAY: 'adld',
  BAD_FRAMES: 'bf',
  BATTERY_DROP: 'bd',
  CONTENT_LAYOUT_DELAY: 'cld',
  CUMULATIVE_LAYOUT_SHIFT: 'cls',
  CUMULATIVE_LAYOUT_SHIFT_2: 'cls-2',
  DOCUMENT_READY: 'dr',
  END_INSTALL_STYLES: 'e_is',
  FIRST_CONTENTFUL_PAINT: 'fcp',
  FIRST_CONTENTFUL_PAINT_VISIBLE: 'fcpv',
  FIRST_PAINT: 'fp',
  FIRST_INPUT_DELAY: 'fid',
  FIRST_INPUT_DELAY_POLYFILL: 'fid-polyfill',
  FIRST_VIEWPORT_READY: 'pc',
  GOOD_FRAME_PROBABILITY: 'gfp',
  INSTALL_STYLES: 'is',
  LARGEST_CONTENTFUL_PAINT_VISIBLE: 'lcpv',
  LARGEST_CONTENTFUL_PAINT_LOAD: 'lcpl',
  LARGEST_CONTENTFUL_PAINT_RENDER: 'lcpr',
  LONG_TASKS_CHILD: 'ltc',
  LONG_TASKS_SELF: 'lts',
  MAKE_BODY_VISIBLE: 'mbv',
  MESSAGING_READY: 'msr',
  ON_FIRST_VISIBLE: 'ofv',
  ON_LOAD: 'ol',
  TIME_ORIGIN: 'timeOrigin',
  VIDEO_CACHE_STATE: 'vcs',
  VIDEO_ERROR: 'verr',
  VIDEO_JOINT_LATENCY: 'vjl',
  VIDEO_MEAN_TIME_BETWEEN_REBUFFER: 'vmtbrb',
  VIDEO_REBUFFERS: 'vrb',
  VIDEO_REBUFFER_RATE: 'vrbr',
  VIDEO_WATCH_TIME: 'vwt'
};
exports.TickLabel = TickLabel;

},{}],12:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.internalListenImplementation = internalListenImplementation;
exports.detectEvtListenerOptsSupport = detectEvtListenerOptsSupport;
exports.resetEvtListenerOptsSupportForTesting = resetEvtListenerOptsSupportForTesting;
exports.supportsPassiveEventListener = supportsPassiveEventListener;
exports.resetPassiveSupportedForTesting = resetPassiveSupportedForTesting;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Whether addEventListener supports options or only takes capture as a boolean
 * @type {boolean|undefined}
 * @visibleForTesting
 */
var optsSupported;

/**
 * Whether addEventListener supports options or only takes passive as a boolean
 * @type {boolean|undefined}
 */
var passiveSupported;

/**
 * Listens for the specified event on the element.
 *
 * Do not use this directly. This method is implemented as a shared
 * dependency. Use `listen()` in either `event-helper` or `3p-frame-messaging`,
 * depending on your use case.
 *
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function internalListenImplementation(element, eventType, listener, opt_evtListenerOpts) {
  var localElement = element;
  var localListener = listener;

  /**
   * @type {?Function}
   */
  var wrapped;

  wrapped = function wrapped(event) {
    try {
      return localListener(event);
    } catch (e) {
      // __AMP_REPORT_ERROR is installed globally per window in the entry point.
      self.__AMP_REPORT_ERROR(e);

      throw e;
    }
  };

  var optsSupported = detectEvtListenerOptsSupport();
  var capture = false;

  if (opt_evtListenerOpts) {
    capture = opt_evtListenerOpts.capture;
  }

  localElement.addEventListener(eventType, wrapped, optsSupported ? opt_evtListenerOpts : capture);
  return function () {
    if (localElement) {
      localElement.removeEventListener(eventType, wrapped, optsSupported ? opt_evtListenerOpts : capture);
    }

    // Ensure these are GC'd
    localListener = null;
    localElement = null;
    wrapped = null;
  };
}

/**
 * Tests whether the browser supports options as an argument of addEventListener
 * or not.
 *
 * @return {boolean}
 */
function detectEvtListenerOptsSupport() {
  // Only run the test once
  if (optsSupported !== undefined) {
    return optsSupported;
  }

  optsSupported = false;

  try {
    // Test whether browser supports EventListenerOptions or not
    var options = {
      get capture() {
        optsSupported = true;
      }

    };
    self.addEventListener('test-options', null, options);
    self.removeEventListener('test-options', null, options);
  } catch (err) {// EventListenerOptions are not supported
  }

  return optsSupported;
}

/**
 * Resets the test for whether addEventListener supports options or not.
 */
function resetEvtListenerOptsSupportForTesting() {
  optsSupported = undefined;
}

/**
 * Return boolean. if listener option is supported, return `true`.
 * if not supported, return `false`
 * @param {!Window} win
 * @return {boolean}
 */
function supportsPassiveEventListener(win) {
  if (passiveSupported !== undefined) {
    return passiveSupported;
  }

  passiveSupported = false;

  try {
    var options = {
      get passive() {
        // This function will be called when the browser
        // attempts to access the passive property.
        passiveSupported = true;
        return false;
      }

    };
    win.addEventListener('test-options', null, options);
    win.removeEventListener('test-options', null, options);
  } catch (err) {// EventListenerOptions are not supported
  }

  return passiveSupported;
}

/**
 * Resets the test for whether addEventListener supports passive options or not.
 */
function resetPassiveSupportedForTesting() {
  passiveSupported = undefined;
}

},{}],13:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createCustomEvent = createCustomEvent;
exports.listen = listen;
exports.getData = getData;
exports.getDetail = getDetail;
exports.listenOnce = listenOnce;
exports.listenOncePromise = listenOncePromise;
exports.isLoaded = isLoaded;
exports.loadPromise = loadPromise;
exports.isLoadErrorMessage = isLoadErrorMessage;
exports.MEDIA_LOAD_FAILURE_SRC_PROPERTY = void 0;

var _eventHelperListen = require("./event-helper-listen");

var _dom = require("./dom");

var _log = require("./log");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @const {string}  */
var LOAD_FAILURE_PREFIX = 'Failed to load:';

/** @const {string} */
var MEDIA_LOAD_FAILURE_SRC_PROPERTY = '__AMP_MEDIA_LOAD_FAILURE_SRC';
exports.MEDIA_LOAD_FAILURE_SRC_PROPERTY = MEDIA_LOAD_FAILURE_SRC_PROPERTY;

/**
 * Returns a CustomEvent with a given type and detail; supports fallback for IE.
 * @param {!Window} win
 * @param {string} type
 * @param {!JsonObject|string|undefined|null} detail
 * @param {EventInit=} opt_eventInit
 * @return {!Event}
 */
function createCustomEvent(win, type, detail, opt_eventInit) {
  var eventInit =
  /** @type {!CustomEventInit} */
  {
    detail: detail
  };
  Object.assign(eventInit, opt_eventInit);

  // win.CustomEvent is a function on Edge, Chrome, FF, Safari but
  // is an object on IE 11.
  if (typeof win.CustomEvent == 'function') {
    return new win.CustomEvent(type, eventInit);
  } else {
    // Deprecated fallback for IE.
    var e = win.document.createEvent('CustomEvent');
    e.initCustomEvent(type, !!eventInit.bubbles, !!eventInit.cancelable, detail);
    return e;
  }
}

/**
 * Listens for the specified event on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listen(element, eventType, listener, opt_evtListenerOpts) {
  return (0, _eventHelperListen.internalListenImplementation)(element, eventType, listener, opt_evtListenerOpts);
}

/**
 * Returns the data property of an event with the correct type.
 * @param {!Event|{data: !JsonObject}} event
 * @return {?JsonObject|string|undefined}
 */
function getData(event) {
  return (
    /** @type {?JsonObject|string|undefined} */
    event.data
  );
}

/**
 * Returns the detail property of an event with the correct type.
 * @param {!Event|{detail: !JsonObject}} event
 * @return {?JsonObject|string|undefined}
 */
function getDetail(event) {
  return (
    /** @type {?JsonObject|string|undefined} */
    event.detail
  );
}

/**
 * Listens for the specified event on the element and removes the listener
 * as soon as event has been received.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listenOnce(element, eventType, listener, opt_evtListenerOpts) {
  var localListener = listener;
  var unlisten = (0, _eventHelperListen.internalListenImplementation)(element, eventType, function (event) {
    try {
      localListener(event);
    } finally {
      // Ensure listener is GC'd
      localListener = null;
      unlisten();
    }
  }, opt_evtListenerOpts);
  return unlisten;
}

/**
 * Returns  a promise that will resolve as soon as the specified event has
 * fired on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {Object=} opt_evtListenerOpts
 * @param {function(!UnlistenDef)=} opt_cancel An optional function that, when
 *     provided, will be called with the unlistener. This gives the caller
 *     access to the unlistener, so it may be called manually when necessary.
 * @return {!Promise<!Event>}
 */
function listenOncePromise(element, eventType, opt_evtListenerOpts, opt_cancel) {
  var unlisten;
  var eventPromise = new Promise(function (resolve) {
    unlisten = listenOnce(element, eventType, resolve, opt_evtListenerOpts);
  });
  eventPromise.then(unlisten, unlisten);

  if (opt_cancel) {
    opt_cancel(unlisten);
  }

  return eventPromise;
}

/**
 * Whether the specified element/window has been loaded already.
 * @param {!Element|!Window} eleOrWindow
 * @return {boolean}
 */
function isLoaded(eleOrWindow) {
  return !!(eleOrWindow.complete || eleOrWindow.readyState == 'complete' || isHTMLMediaElement(eleOrWindow) && eleOrWindow.readyState > 0 || // If the passed in thing is a Window, infer loaded state from
  //
  eleOrWindow.document && eleOrWindow.document.readyState == 'complete');
}

/**
 * Returns a promise that will resolve or fail based on the eleOrWindow's 'load'
 * and 'error' events. Optionally this method takes a timeout, which will reject
 * the promise if the resource has not loaded by then.
 * @param {T} eleOrWindow Supports both Elements and as a special case Windows.
 * @return {!Promise<T>}
 * @template T
 */
function loadPromise(eleOrWindow) {
  var unlistenLoad;
  var unlistenError;

  if (isLoaded(eleOrWindow)) {
    return Promise.resolve(eleOrWindow);
  }

  var isMediaElement = isHTMLMediaElement(eleOrWindow);

  if (isMediaElement && eleOrWindow[MEDIA_LOAD_FAILURE_SRC_PROPERTY] === eleOrWindow.currentSrc) {
    return Promise.reject(eleOrWindow);
  }

  var loadingPromise = new Promise(function (resolve, reject) {
    // Listen once since IE 5/6/7 fire the onload event continuously for
    // animated GIFs.
    if (isMediaElement) {
      // The following event can be triggered by the media or one of its
      // sources. Using capture is required as the media events do not bubble.
      unlistenLoad = listenOnce(eleOrWindow, 'loadedmetadata', resolve, {
        capture: true
      });
    } else {
      unlistenLoad = listenOnce(eleOrWindow, 'load', resolve);
    }

    // Don't unlisten on error for Windows.
    if (!eleOrWindow.tagName) {
      return;
    }

    var errorTarget = eleOrWindow;

    // If the media element has no `src`, it will try to load the sources in
    // document order. If the last source errors, then the media element
    // loading errored.
    if (isMediaElement && !eleOrWindow.hasAttribute('src')) {
      errorTarget = (0, _dom.lastChildElement)(eleOrWindow, function (child) {
        return child.tagName === 'SOURCE';
      });

      if (!errorTarget) {
        return reject(new Error('Media has no source.'));
      }
    }

    unlistenError = listenOnce(errorTarget, 'error', reject);
  });
  return loadingPromise.then(function () {
    if (unlistenError) {
      unlistenError();
    }

    return eleOrWindow;
  }, function () {
    if (unlistenLoad) {
      unlistenLoad();
    }

    failedToLoad(eleOrWindow);
  });
}

/**
 * Emit error on load failure.
 * @param {!Element|!Window} eleOrWindow Supports both Elements and as a special
 *     case Windows.
 */
function failedToLoad(eleOrWindow) {
  // Mark the element as errored since some elements - like HTMLMediaElement
  // using HTMLSourceElement - do not provide any synchronous way to verify if
  // they already errored, even though the error event was already dispatched.
  if (isHTMLMediaElement(eleOrWindow)) {
    eleOrWindow[MEDIA_LOAD_FAILURE_SRC_PROPERTY] = eleOrWindow.currentSrc || true;
  }

  // Report failed loads as user errors so that they automatically go
  // into the "document error" bucket.
  var target = eleOrWindow;

  if (target && target.src) {
    target = target.src;
  }

  throw (0, _log.user)().createError(LOAD_FAILURE_PREFIX, target);
}

/**
 * Returns true if the parameter is a HTMLMediaElement.
 * @param {!Element|!Window} eleOrWindow
 * @return {boolean}
 */
function isHTMLMediaElement(eleOrWindow) {
  return eleOrWindow.tagName === 'AUDIO' || eleOrWindow.tagName === 'VIDEO';
}

/**
 * Returns true if this error message is was created for a load error.
 * @param {string} message An error message
 * @return {boolean}
 */
function isLoadErrorMessage(message) {
  return message.indexOf(LOAD_FAILURE_PREFIX) != -1;
}

},{"./dom":9,"./event-helper-listen":12,"./log":19}],14:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isCanary = isCanary;
exports.getBinaryType = getBinaryType;
exports.isExperimentOn = isExperimentOn;
exports.toggleExperiment = toggleExperiment;
exports.experimentToggles = experimentToggles;
exports.experimentTogglesOrNull = experimentTogglesOrNull;
exports.getExperimentTogglesForTesting = getExperimentTogglesForTesting;
exports.resetExperimentTogglesForTesting = resetExperimentTogglesForTesting;
exports.randomlySelectUnsetExperiments = randomlySelectUnsetExperiments;
exports.getExperimentBranch = getExperimentBranch;
exports.getActiveExperimentBranches = getActiveExperimentBranches;
exports.forceExperimentBranch = forceExperimentBranch;
exports.RANDOM_NUMBER_GENERATORS = exports.ExperimentInfo = void 0;

var _log = require("./log");

var _mode = require("./mode");

var _service = require("./service");

var _object = require("./utils/object");

var _url = require("./url");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @const {string} */
var TAG = 'EXPERIMENTS';

/** @const {string} */
var LOCAL_STORAGE_KEY = 'amp-experiment-toggles';

/** @const {string} */
var TOGGLES_WINDOW_PROPERTY = '__AMP__EXPERIMENT_TOGGLES';

/**
 * @typedef {{
 *   experimentId: string,
 *   isTrafficEligible: function(!Window):boolean,
 *   branches: !Array<string>
 * }}
 */
var ExperimentInfo;
exports.ExperimentInfo = ExperimentInfo;

/**
 * Whether we are in canary.
 * @param {!Window} win
 * @return {boolean}
 */
function isCanary(win) {
  return !!(win.AMP_CONFIG && win.AMP_CONFIG.canary);
}

/**
 * Returns binary type, e.g., canary, production, control, or rc.
 * @param {!Window} win
 * @return {string}
 */
function getBinaryType(win) {
  return win.AMP_CONFIG && win.AMP_CONFIG.type ? win.AMP_CONFIG.type : 'unknown';
}

/**
 * Whether the specified experiment is on or off.
 * @param {!Window} win
 * @param {string} experimentId
 * @return {boolean}
 */
function isExperimentOn(win, experimentId) {
  var toggles = experimentToggles(win);
  return !!toggles[experimentId];
}

/**
 * Toggles the experiment on or off. Returns the actual value of the experiment
 * after toggling is done.
 * @param {!Window} win
 * @param {string} experimentId
 * @param {boolean=} opt_on
 * @param {boolean=} opt_transientExperiment  Whether to toggle the
 *     experiment state "transiently" (i.e., for this page load only) or
 *     durably (by saving the experiment IDs after toggling).
 *     Default: false (save durably).
 * @return {boolean} New state for experimentId.
 */
function toggleExperiment(win, experimentId, opt_on, opt_transientExperiment) {
  var currentlyOn = isExperimentOn(win,
  /*OK*/
  experimentId);
  var on = !!(opt_on !== undefined ? opt_on : !currentlyOn);

  if (on != currentlyOn) {
    var toggles = experimentToggles(win);
    toggles[experimentId] = on;

    if (!opt_transientExperiment) {
      var storedToggles = getExperimentToggles(win);
      storedToggles[experimentId] = on;
      saveExperimentToggles(win, storedToggles);

      // Avoid affecting tests that spy/stub warn().
      if (!(0, _mode.getMode)().test) {
        (0, _log.user)().warn(TAG, '"%s" experiment %s for the domain "%s". See: https://amp.dev/documentation/guides-and-tutorials/learn/experimental', experimentId, on ? 'enabled' : 'disabled', win.location.hostname);
      }
    }
  }

  return on;
}

/**
 * Calculate whether the experiment is on or off based off of its default value,
 * stored overriden value, or the global config frequency given.
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 */
function experimentToggles(win) {
  if (win[TOGGLES_WINDOW_PROPERTY]) {
    return win[TOGGLES_WINDOW_PROPERTY];
  }

  win[TOGGLES_WINDOW_PROPERTY] = Object.create(null);
  var toggles = win[TOGGLES_WINDOW_PROPERTY];

  // Read the default config of this build.
  if (win.AMP_CONFIG) {
    for (var experimentId in win.AMP_CONFIG) {
      var frequency = win.AMP_CONFIG[experimentId];

      if (typeof frequency === 'number' && frequency >= 0 && frequency <= 1) {
        toggles[experimentId] = Math.random() < frequency;
      }
    }
  }

  // Read document level override from meta tag.
  if (win.AMP_CONFIG && Array.isArray(win.AMP_CONFIG['allow-doc-opt-in']) && win.AMP_CONFIG['allow-doc-opt-in'].length > 0) {
    var allowed = win.AMP_CONFIG['allow-doc-opt-in'];
    var meta = win.document.head.querySelector('meta[name="amp-experiments-opt-in"]');

    if (meta) {
      var optedInExperiments = meta.getAttribute('content').split(',');

      for (var i = 0; i < optedInExperiments.length; i++) {
        if (allowed.indexOf(optedInExperiments[i]) != -1) {
          toggles[optedInExperiments[i]] = true;
        }
      }
    }
  }

  Object.assign(toggles, getExperimentToggles(win));

  if (win.AMP_CONFIG && Array.isArray(win.AMP_CONFIG['allow-url-opt-in']) && win.AMP_CONFIG['allow-url-opt-in'].length > 0) {
    var _allowed = win.AMP_CONFIG['allow-url-opt-in'];
    var hash = win.location.originalHash || win.location.hash;
    var params = (0, _url.parseQueryString)(hash);

    for (var _i = 0; _i < _allowed.length; _i++) {
      var param = params["e-" + _allowed[_i]];

      if (param == '1') {
        toggles[_allowed[_i]] = true;
      }

      if (param == '0') {
        toggles[_allowed[_i]] = false;
      }
    }
  }

  return toggles;
}

/**
 * Returns the cached experiments toggles, or null if they have not been
 * computed yet.
 * @param {!Window} win
 * @return {Object<string, boolean>}
 */
function experimentTogglesOrNull(win) {
  return win[TOGGLES_WINDOW_PROPERTY] || null;
}

/**
 * Returns a set of experiment IDs currently on.
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 */
function getExperimentToggles(win) {
  var experimentsString = '';

  try {
    if ('localStorage' in win) {
      experimentsString = win.localStorage.getItem(LOCAL_STORAGE_KEY);
    }
  } catch (e) {
    (0, _log.dev)().warn(TAG, 'Failed to retrieve experiments from localStorage.');
  }

  var tokens = experimentsString ? experimentsString.split(/\s*,\s*/g) : [];
  var toggles = Object.create(null);

  for (var i = 0; i < tokens.length; i++) {
    if (tokens[i].length == 0) {
      continue;
    }

    if (tokens[i][0] == '-') {
      toggles[tokens[i].substr(1)] = false;
    } else {
      toggles[tokens[i]] = true;
    }
  }

  return toggles;
}

/**
 * Saves a set of experiment IDs currently on.
 * @param {!Window} win
 * @param {!Object<string, boolean>} toggles
 */
function saveExperimentToggles(win, toggles) {
  var experimentIds = [];

  for (var experiment in toggles) {
    experimentIds.push((toggles[experiment] === false ? '-' : '') + experiment);
  }

  try {
    if ('localStorage' in win) {
      win.localStorage.setItem(LOCAL_STORAGE_KEY, experimentIds.join(','));
    }
  } catch (e) {
    (0, _log.user)().error(TAG, 'Failed to save experiments to localStorage.');
  }
}

/**
 * See getExperimentToggles().
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 * @visibleForTesting
 */
function getExperimentTogglesForTesting(win) {
  return getExperimentToggles(win);
}

/**
 * Resets the experimentsToggle cache for testing purposes.
 * @param {!Window} win
 * @visibleForTesting
 */
function resetExperimentTogglesForTesting(win) {
  saveExperimentToggles(win, {});
  win[TOGGLES_WINDOW_PROPERTY] = null;
}

/**
 * In some browser implementations of Math.random(), sequential calls of
 * Math.random() are correlated and can cause a bias.  In particular,
 * if the previous random() call was < 0.001 (as it will be if we select
 * into an experiment), the next value could be less than 0.5 more than
 * 50.7% of the time.  This provides an implementation that roots down into
 * the crypto API, when available, to produce less biased samples.
 *
 * @return {number} Pseudo-random floating-point value on the range [0, 1).
 */
function slowButAccuratePrng() {
  // TODO(tdrl): Implement.
  return Math.random();
}

/**
 * Container for alternate random number generator implementations.  This
 * allows us to set an "accurate" PRNG for branch selection, but to mock it
 * out easily in tests.
 *
 * @visibleForTesting
 * @const {!{accuratePrng: function():number}}
 */
var RANDOM_NUMBER_GENERATORS = {
  accuratePrng: slowButAccuratePrng
};
exports.RANDOM_NUMBER_GENERATORS = RANDOM_NUMBER_GENERATORS;

/**
 * Selects, uniformly at random, a single item from the array.
 * @param {!Array<string>} arr Object to select from.
 * @return {?string} Single item from arr or null if arr was empty.
 */
function selectRandomItem(arr) {
  var rn = RANDOM_NUMBER_GENERATORS.accuratePrng();
  return (0, _log.dev)().assertString(arr[Math.floor(rn * arr.length)]) || null;
}

/**
 * Selects which page-level experiment branches are enabled. If a given
 * experiment name is already set (including to the null / no branches selected
 * state), this won't alter its state.
 *
 * Check whether a given experiment is set using isExperimentOn(win,
 * experimentName) and, if it is on, look for which branch is selected in
 * win.__AMP_EXPERIMENT_BRANCHES[experimentName].
 *
 * @param {!Window} win Window context on which to save experiment
 *     selection state.
 * @param {!Array<!ExperimentInfo>} experiments  Set of experiments to
 *     configure for this page load.
 * @return {!Object<string, string>} Map of experiment names to selected
 *     branches.
 */
function randomlySelectUnsetExperiments(win, experiments) {
  win.__AMP_EXPERIMENT_BRANCHES = win.__AMP_EXPERIMENT_BRANCHES || {};
  var selectedExperiments = {};

  for (var i = 0; i < experiments.length; i++) {
    var experiment = experiments[i];
    var experimentName = experiment.experimentId;

    if ((0, _object.hasOwn)(win.__AMP_EXPERIMENT_BRANCHES, experimentName)) {
      selectedExperiments[experimentName] = win.__AMP_EXPERIMENT_BRANCHES[experimentName];
      continue;
    }

    if (!experiment.isTrafficEligible || !experiment.isTrafficEligible(win)) {
      win.__AMP_EXPERIMENT_BRANCHES[experimentName] = null;
      continue;
    }

    // If we're in the experiment, but we haven't already forced a specific
    // experiment branch (e.g., via a test setup), then randomize the branch
    // choice.
    if (!win.__AMP_EXPERIMENT_BRANCHES[experimentName] && isExperimentOn(win,
    /*OK*/
    experimentName)) {
      win.__AMP_EXPERIMENT_BRANCHES[experimentName] = selectRandomItem(experiment.branches);
      selectedExperiments[experimentName] = win.__AMP_EXPERIMENT_BRANCHES[experimentName];
    }
  }

  return selectedExperiments;
}

/**
 * Returns the experiment branch enabled for the given experiment ID.
 * For example, 'control' or 'experiment'.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @param {string} experimentName Name of the experiment to check.
 * @return {?string} Active experiment branch ID for experimentName (possibly
 *     null if experimentName has been tested but no branch was enabled).
 */
function getExperimentBranch(win, experimentName) {
  return win.__AMP_EXPERIMENT_BRANCHES ? win.__AMP_EXPERIMENT_BRANCHES[experimentName] : null;
}

/**
 * Returns an object containing all active experiment branches on the
 * top Window.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @return {!Object} contains all experiment branches and their ids.
 */
function getActiveExperimentBranches(win) {
  var topWin = (0, _service.getTopWindow)(win);

  if (!topWin.__AMP_EXPERIMENT_BRANCHES) {
    topWin.__AMP_EXPERIMENT_BRANCHES = {};
  }

  return _extends({}, topWin.__AMP_EXPERIMENT_BRANCHES);
}

/**
 * Force enable (or disable) a specific branch of a given experiment name.
 * Disables the experiment name altogether if branchId is falseish.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @param {string} experimentName Name of the experiment to check.
 * @param {?string} branchId ID of branch to force or null to disable
 *     altogether.
 * @visibleForTesting
 */
function forceExperimentBranch(win, experimentName, branchId) {
  win.__AMP_EXPERIMENT_BRANCHES = win.__AMP_EXPERIMENT_BRANCHES || {};
  toggleExperiment(win, experimentName, !!branchId, true);
  win.__AMP_EXPERIMENT_BRANCHES[experimentName] = branchId;
}

},{"./log":19,"./mode":20,"./service":24,"./url":34,"./utils/object":39}],15:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.internalRuntimeVersion = internalRuntimeVersion;

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns the internal AMP runtime version. Note that this is not the RTV,
 * which is a prefix and the runtime version.
 *
 * The call sites for this function are replaced with a compile time constant
 * string.
 *
 * @return {string}
 */
function internalRuntimeVersion() {
  return '$internalRuntimeVersion$';
}

},{}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.recreateNonProtoObject = recreateNonProtoObject;
exports.getValueForExpr = getValueForExpr;
exports.parseJson = parseJson;
exports.tryParseJson = tryParseJson;
exports.getChildJsonConfig = getChildJsonConfig;
exports.deepEquals = deepEquals;
exports.jsonConfiguration = jsonConfiguration;
exports.jsonLiteral = jsonLiteral;
exports.includeJsonLiteral = includeJsonLiteral;

var _dom = require("./dom");

var _types = require("./types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview This module declares JSON types as defined in the
 * {@link http://json.org/}.
 */
// NOTE Type are changed to {*} because of
// https://github.com/google/closure-compiler/issues/1999

/**
 * JSON scalar. It's either string, number or boolean.
 * @typedef {*} should be string|number|boolean|null
 */
var JSONScalarDef;

/**
 * JSON object. It's a map with string keys and JSON values.
 * @typedef {*} should be !Object<string, ?JSONValueDef>
 */
var JSONObjectDef;

/**
 * JSON array. It's an array with JSON values.
 * @typedef {*} should be !Array<?JSONValueDef>
 */
var JSONArrayDef;

/**
 * JSON value. It's either a scalar, an object or an array.
 * @typedef {*} should be !JSONScalarDef|!JSONObjectDef|!JSONArrayDef
 */
var JSONValueDef;

/**
 * Recreates objects with prototype-less copies.
 * @param {!JsonObject} obj
 * @return {!JsonObject}
 */
function recreateNonProtoObject(obj) {
  var copy = Object.create(null);

  for (var k in obj) {
    if (!hasOwnProperty(obj, k)) {
      continue;
    }

    var v = obj[k];
    copy[k] = (0, _types.isObject)(v) ? recreateNonProtoObject(v) : v;
  }

  return (
    /** @type {!JsonObject} */
    copy
  );
}

/**
 * Returns a value from an object for a field-based expression. The expression
 * is a simple nested dot-notation of fields, such as `field1.field2`. If any
 * field in a chain does not exist or is not an object or array, the returned
 * value will be `undefined`.
 *
 * @param {!JsonObject} obj
 * @param {string} expr
 * @return {*}
 */
function getValueForExpr(obj, expr) {
  // The `.` indicates "the object itself".
  if (expr == '.') {
    return obj;
  }

  // Otherwise, navigate via properties.
  var parts = expr.split('.');
  var value = obj;

  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];

    if (part && value && value[part] !== undefined && hasOwnProperty(value, part)) {
      value = value[part];
      continue;
    }

    value = undefined;
    break;
  }

  return value;
}

/**
 * Simple wrapper around JSON.parse that casts the return value
 * to JsonObject.
 * Create a new wrapper if an array return value is desired.
 * @param {*} json JSON string to parse
 * @return {?JsonObject} May be extend to parse arrays.
 */
function parseJson(json) {
  return (
    /** @type {?JsonObject} */
    JSON.parse(
    /** @type {string} */
    json)
  );
}

/**
 * Parses the given `json` string without throwing an exception if not valid.
 * Returns `undefined` if parsing fails.
 * Returns the `Object` corresponding to the JSON string when parsing succeeds.
 * @param {*} json JSON string to parse
 * @param {function(!Error)=} opt_onFailed Optional function that will be called
 *     with the error if parsing fails.
 * @return {?JsonObject} May be extend to parse arrays.
 */
function tryParseJson(json, opt_onFailed) {
  try {
    return parseJson(json);
  } catch (e) {
    if (opt_onFailed) {
      opt_onFailed(e);
    }

    return null;
  }
}

/**
 * Helper method to get the json config from an element <script> tag
 * @param {!Element} element
 * @return {?JsonObject}
 * @throws {!Error} If element does not have exactly one <script> child
 * with type="application/json", or if the <script> contents are not valid JSON.
 */
function getChildJsonConfig(element) {
  var scripts = (0, _dom.childElementsByTag)(element, 'script');
  var n = scripts.length;

  if (n !== 1) {
    throw new Error("Found " + scripts.length + " <script> children. Expected 1.");
  }

  var script = scripts[0];

  if (!(0, _dom.isJsonScriptTag)(script)) {
    throw new Error('<script> child must have type="application/json"');
  }

  try {
    return parseJson(script.textContent);
  } catch (unusedError) {
    throw new Error('Failed to parse <script> contents. Is it valid JSON?');
  }
}

/**
 * Deeply checks strict equality of items in nested arrays and objects.
 *
 * @param {JSONValueDef} a
 * @param {JSONValueDef} b
 * @param {number} depth The maximum depth. Must be finite.
 * @return {boolean}
 * @throws {Error} If depth argument is not finite.
 */
function deepEquals(a, b, depth) {
  if (depth === void 0) {
    depth = 5;
  }

  if (!isFinite(depth) || depth < 0) {
    throw new Error('Invalid depth: ' + depth);
  }

  if (a === b) {
    return true;
  }

  /** @type {!Array<{a: JSONValueDef, b: JSONValueDef, depth: number}>} */
  var queue = [{
    a: a,
    b: b,
    depth: depth
  }];

  while (queue.length > 0) {
    var _queue$shift = queue.shift(),
        _a = _queue$shift.a,
        _b = _queue$shift.b,
        _depth = _queue$shift.depth;

    // Only check deep equality if depth > 0.
    if (_depth > 0) {
      if (typeof _a !== typeof _b) {
        return false;
      } else if (Array.isArray(_a) && Array.isArray(_b)) {
        if (_a.length !== _b.length) {
          return false;
        }

        for (var i = 0; i < _a.length; i++) {
          queue.push({
            a: _a[i],
            b: _b[i],
            depth: _depth - 1
          });
        }

        continue;
      } else if (_a && _b && typeof _a === 'object' && typeof _b === 'object') {
        var keysA = Object.keys(
        /** @type {!Object} */
        _a);
        var keysB = Object.keys(
        /** @type {!Object} */
        _b);

        if (keysA.length !== keysB.length) {
          return false;
        }

        for (var _i = 0; _i < keysA.length; _i++) {
          var k = keysA[_i];
          queue.push({
            a: _a[k],
            b: _b[k],
            depth: _depth - 1
          });
        }

        continue;
      }
    }

    // If we get here, then depth == 0 or (a, b) are primitives.
    if (_a !== _b) {
      return false;
    }
  }

  return true;
}

/**
 * @param {*} obj
 * @param {string} key
 * @return {boolean}
 */
function hasOwnProperty(obj, key) {
  if (obj == null || typeof obj != 'object') {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(
  /** @type {!Object} */
  obj, key);
}

/**
 * This helper function handles configurations specified in a JSON format.
 *
 * It allows the configuration is to be written in plain JS (which has better
 * dev ergonomics like comments and trailing commas), and allows the
 * configuration to be transformed into an efficient JSON-parsed representation
 * in the dist build. See https://v8.dev/blog/cost-of-javascript-2019#json
 *
 * @param {!Object} obj
 * @return {!JsonObject}
 */
function jsonConfiguration(obj) {
  return (
    /** @type {!JsonObject} */
    obj
  );
}

/**
 * This converts an Object into a suitable type to be used in `includeJsonLiteral`.
 * This doesn't actually do any conversion, it only changes the closure type.
 *
 * @param {!Object|!Array|string|number|boolean|null} value
 * @return {!InternalJsonLiteralTypeDef}
 */
function jsonLiteral(value) {
  return (
    /** @type {!InternalJsonLiteralTypeDef} */
    value
  );
}

/**
 * Allows inclusion of a variable (that's wrapped in a jsonLiteral
 * call) to be included inside a jsonConfiguration.
 *
 * @param {!InternalJsonLiteralTypeDef} value
 * @return {*}
 */
function includeJsonLiteral(value) {
  return value;
}

},{"./dom":9,"./types":31}],17:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseLayout = parseLayout;
exports.getLayoutClass = getLayoutClass;
exports.isLayoutSizeDefined = isLayoutSizeDefined;
exports.isLayoutSizeFixed = isLayoutSizeFixed;
exports.isInternalElement = isInternalElement;
exports.parseLength = parseLength;
exports.assertLength = assertLength;
exports.assertLengthOrPercent = assertLengthOrPercent;
exports.getLengthUnits = getLengthUnits;
exports.getLengthNumeral = getLengthNumeral;
exports.hasNaturalDimensions = hasNaturalDimensions;
exports.getNaturalDimensions = getNaturalDimensions;
exports.isLoadingAllowed = isLoadingAllowed;
exports.isIframeVideoPlayerComponent = isIframeVideoPlayerComponent;
exports.applyStaticLayout = applyStaticLayout;
exports.resetShouldUseAspectRatioCssForTesting = resetShouldUseAspectRatioCssForTesting;
exports.LOADING_ELEMENTS_ = exports.naturalDimensions_ = exports.LengthDef = exports.LayoutPriority = exports.Layout = void 0;

var _log = require("./log");

var _staticTemplate = require("./static-template");

var _experiments = require("./experiments");

var _types = require("./types");

var _style = require("./style");

var _img = require("./utils/img");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <i-amphtml-sizer class=\"i-amphtml-sizer\" slot=\"i-amphtml-svc\">\n        <img alt=\"\" role=\"presentation\" aria-hidden=\"true\"\n             class=\"i-amphtml-intrinsic-sizer\" />\n      </i-amphtml-sizer>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/**
 * @enum {string}
 */
var Layout = {
  NODISPLAY: 'nodisplay',
  FIXED: 'fixed',
  FIXED_HEIGHT: 'fixed-height',
  RESPONSIVE: 'responsive',
  CONTAINER: 'container',
  FILL: 'fill',
  FLEX_ITEM: 'flex-item',
  FLUID: 'fluid',
  INTRINSIC: 'intrinsic'
};
exports.Layout = Layout;

/**
 * Layout priorities to use with BaseElement#getLayoutPriority() and
 * BaseElement#updateLayoutPriority().
 * @enum {number}
 */
var LayoutPriority = {
  CONTENT: 0,
  METADATA: 1,
  ADS: 2,
  BACKGROUND: 3
};
exports.LayoutPriority = LayoutPriority;

/**
 * CSS Length type. E.g. "1px" or "20vh".
 * @typedef {string}
 */
var LengthDef;
exports.LengthDef = LengthDef;

/**
 * @typedef {{
 *   width: string,
 *   height: string
 * }}
 */
var DimensionsDef;

/**
 * The set of elements with natural dimensions, that is, elements
 * which have a known dimension either based on their value specified here,
 * or, if the value is null, a dimension specific to the browser.
 * `hasNaturalDimensions` checks for membership in this set.
 * `getNaturalDimensions` determines the dimensions for an element in the
 *    set and caches it.
 * @type {!Object<string, ?DimensionsDef>}
 * @private  Visible for testing only!
 */
var naturalDimensions_ = {
  'AMP-PIXEL': {
    width: '0px',
    height: '0px'
  },
  'AMP-ANALYTICS': {
    width: '1px',
    height: '1px'
  },
  // TODO(dvoytenko): audio should have width:auto.
  'AMP-AUDIO': null,
  'AMP-SOCIAL-SHARE': {
    width: '60px',
    height: '44px'
  }
};
exports.naturalDimensions_ = naturalDimensions_;

/**
 * Elements that the progress can be shown for. This set has to be externalized
 * since the element's implementation may not be downloaded yet.
 * This list does not include video players which are found via regex later.
 * @enum {boolean}
 * @private  Visible for testing only!
 */
var LOADING_ELEMENTS_ = {
  'AMP-AD': true,
  'AMP-ANIM': true,
  'AMP-EMBED': true,
  'AMP-FACEBOOK': true,
  'AMP-FACEBOOK-COMMENTS': true,
  'AMP-FACEBOOK-PAGE': true,
  'AMP-GOOGLE-DOCUMENT-EMBED': true,
  'AMP-IFRAME': true,
  'AMP-IMG': true,
  'AMP-INSTAGRAM': true,
  'AMP-LIST': true,
  'AMP-PINTEREST': true,
  'AMP-PLAYBUZZ': true,
  'AMP-TWITTER': true
};
exports.LOADING_ELEMENTS_ = LOADING_ELEMENTS_;

/**
 * All video player components must either have a) "video" or b) "player" in
 * their name. A few components don't follow this convention for historical
 * reasons, so they are listed individually.
 * @private @const {!RegExp}
 */
var videoPlayerTagNameRe = /^amp\-(video|.+player)|AMP-BRIGHTCOVE|AMP-DAILYMOTION|AMP-YOUTUBE|AMP-VIMEO|AMP-IMA-VIDEO/i;

/**
 * Whether aspect-ratio CSS can be used to implement responsive layouts.
 * @type {?boolean}
 */
var aspectRatioCssCache = null;

/**
 * @param {string} s
 * @return {Layout|undefined} Returns undefined in case of failure to parse
 *   the layout string.
 */
function parseLayout(s) {
  for (var k in Layout) {
    if (Layout[k] == s) {
      return Layout[k];
    }
  }

  return undefined;
}

/**
 * @param {!Layout} layout
 * @return {string}
 */
function getLayoutClass(layout) {
  return 'i-amphtml-layout-' + layout;
}

/**
 * Whether an element with this layout inherently defines the size.
 * @param {!Layout} layout
 * @return {boolean}
 */
function isLayoutSizeDefined(layout) {
  return layout == Layout.FIXED || layout == Layout.FIXED_HEIGHT || layout == Layout.RESPONSIVE || layout == Layout.FILL || layout == Layout.FLEX_ITEM || layout == Layout.FLUID || layout == Layout.INTRINSIC;
}

/**
 * Whether an element with this layout has a fixed dimension.
 * @param {!Layout} layout
 * @return {boolean}
 */
function isLayoutSizeFixed(layout) {
  return layout == Layout.FIXED || layout == Layout.FIXED_HEIGHT;
}

/**
 * Whether the tag is an internal (service) AMP tag.
 * @param {!Node|string} tag
 * @return {boolean}
 */
function isInternalElement(tag) {
  var tagName = typeof tag == 'string' ? tag : tag.tagName;
  return tagName && tagName.toLowerCase().startsWith('i-');
}

/**
 * Parses the CSS length value. If no units specified, the assumed value is
 * "px". Returns undefined in case of parsing error.
 * @param {string|undefined|null} s
 * @return {!LengthDef|undefined}
 */
function parseLength(s) {
  if (typeof s == 'number') {
    return s + 'px';
  }

  if (!s) {
    return undefined;
  }

  if (!/^\d+(\.\d+)?(px|em|rem|vh|vw|vmin|vmax|cm|mm|q|in|pc|pt)?$/.test(s)) {
    return undefined;
  }

  if (/^\d+(\.\d+)?$/.test(s)) {
    return s + 'px';
  }

  return s;
}

/**
 * Asserts that the supplied value is a non-percent CSS Length value.
 * @param {!LengthDef|string|null|undefined} length
 * @return {!LengthDef}
 * @closurePrimitive {asserts.matchesReturn}
 */
function assertLength(length) {
  (0, _log.userAssert)(/^\d+(\.\d+)?(px|em|rem|vh|vw|vmin|vmax|cm|mm|q|in|pc|pt)$/.test(length), 'Invalid length value: %s', length);
  return (
    /** @type {!LengthDef} */
    length
  );
}

/**
 * Asserts that the supplied value is a CSS Length value
 * (including percent unit).
 * @param {!LengthDef|string} length
 * @return {!LengthDef}
 * @closurePrimitive {asserts.matchesReturn}
 */
function assertLengthOrPercent(length) {
  (0, _log.userAssert)(/^\d+(\.\d+)?(px|em|rem|vh|vw|vmin|vmax|%)$/.test(length), 'Invalid length or percent value: %s', length);
  return length;
}

/**
 * Returns units from the CSS length value.
 * @param {!LengthDef|string|null|undefined} length
 * @return {string}
 */
function getLengthUnits(length) {
  assertLength(length);
  var m = (0, _log.userAssert)(/[a-z]+/i.exec(length), 'Failed to read units from %s', length);
  return m[0];
}

/**
 * Returns the numeric value of a CSS length value.
 * @param {!LengthDef|string|null|undefined} length
 * @return {number|undefined}
 */
function getLengthNumeral(length) {
  var res = parseFloat(length);
  return (0, _types.isFiniteNumber)(res) ? res : undefined;
}

/**
 * Determines whether the tagName is a known element that has natural dimensions
 * in our runtime or the browser.
 * @param {string} tagName The element tag name.
 * @return {boolean}
 */
function hasNaturalDimensions(tagName) {
  tagName = tagName.toUpperCase();
  return naturalDimensions_[tagName] !== undefined;
}

/**
 * Determines the default dimensions for an element which could vary across
 * different browser implementations, like <audio> for instance.
 * This operation can only be completed for an element allowlisted by
 * `hasNaturalDimensions`.
 * @param {!Element} element
 * @return {DimensionsDef}
 */
function getNaturalDimensions(element) {
  var tagName = element.tagName.toUpperCase();
  (0, _log.devAssert)(naturalDimensions_[tagName] !== undefined);

  if (!naturalDimensions_[tagName]) {
    var doc = element.ownerDocument;
    var naturalTagName = tagName.replace(/^AMP\-/, '');
    var temp = doc.createElement(naturalTagName);
    // For audio, should no-op elsewhere.
    temp.controls = true;
    (0, _style.setStyles)(temp, {
      position: 'absolute',
      visibility: 'hidden'
    });
    doc.body.appendChild(temp);
    naturalDimensions_[tagName] = {
      width: (temp.
      /*OK*/
      offsetWidth || 1) + 'px',
      height: (temp.
      /*OK*/
      offsetHeight || 1) + 'px'
    };
    doc.body.removeChild(temp);
  }

  return (
    /** @type {DimensionsDef} */
    naturalDimensions_[tagName]
  );
}

/**
 * Whether the loading can be shown for the specified element. This set has
 * to be externalized since the element's implementation may not be
 * downloaded yet.
 * @param {!Element} element
 * @return {boolean}
 */
function isLoadingAllowed(element) {
  var tagName = element.tagName.toUpperCase();
  return LOADING_ELEMENTS_[tagName] || isIframeVideoPlayerComponent(tagName);
}

/**
 * All video player components must either have a) "video" or b) "player" in
 * their name. A few components don't follow this convention for historical
 * reasons, so they're present in the LOADING_ELEMENTS_ allowlist.
 * @param {string} tagName
 * @return {boolean}
 */
function isIframeVideoPlayerComponent(tagName) {
  if (tagName == 'AMP-VIDEO') {
    return false;
  }

  return videoPlayerTagNameRe.test(tagName);
}

/**
 * Applies layout to the element. Visible for testing only.
 *
 * \   \  /  \  /   / /   \     |   _  \     |  \ |  | |  | |  \ |  |  / _____|
 *  \   \/    \/   / /  ^  \    |  |_)  |    |   \|  | |  | |   \|  | |  |  __
 *   \            / /  /_\  \   |      /     |  . `  | |  | |  . `  | |  | |_ |
 *    \    /\    / /  _____  \  |  |\  \----.|  |\   | |  | |  |\   | |  |__| |
 *     \__/  \__/ /__/     \__\ | _| `._____||__| \__| |__| |__| \__|  \______|
 *
 * The equivalent of this method is used for server-side rendering (SSR) and
 * any changes made to it must be made in coordination with caches that
 * implement SSR. For more information on SSR see bit.ly/amp-ssr.
 *
 * @param {!Element} element
 * @param {boolean} fixIeIntrinsic
 * @return {!Layout}
 */
function applyStaticLayout(element, fixIeIntrinsic) {
  if (fixIeIntrinsic === void 0) {
    fixIeIntrinsic = false;
  }

  // Check if the layout has already been done by server-side rendering or
  // client-side rendering and the element was cloned. The document may be
  // visible to the user if the boilerplate was removed so please take care in
  // making changes here.
  var completedLayoutAttr = element.getAttribute('i-amphtml-layout');

  if (completedLayoutAttr) {
    var _layout =
    /** @type {!Layout} */
    (0, _log.devAssert)(parseLayout(completedLayoutAttr));

    if ((_layout == Layout.RESPONSIVE || _layout == Layout.INTRINSIC) && element.firstElementChild) {
      // Find sizer, but assume that it might not have been parsed yet.
      element.sizerElement = element.querySelector('i-amphtml-sizer') || undefined;

      if (element.sizerElement) {
        element.sizerElement.setAttribute('slot', 'i-amphtml-svc');
      }
    } else if (_layout == Layout.NODISPLAY) {
      (0, _style.toggle)(element, false);
      // TODO(jridgewell): Temporary hack while SSR still adds an inline
      // `display: none`
      element['style']['display'] = '';
    }

    return _layout;
  }

  // If the layout was already done by server-side rendering (SSR), then the
  // code below will not run. Any changes below will necessitate a change to SSR
  // and must be coordinated with caches that implement SSR. See bit.ly/amp-ssr.
  // Parse layout from the element.
  var layoutAttr = element.getAttribute('layout');
  var widthAttr = element.getAttribute('width');
  var heightAttr = element.getAttribute('height');
  var sizesAttr = element.getAttribute('sizes');
  var heightsAttr = element.getAttribute('heights');
  // Input layout attributes.
  var inputLayout = layoutAttr ? parseLayout(layoutAttr) : null;
  (0, _log.userAssert)(inputLayout !== undefined, 'Invalid "layout" value: %s, %s', layoutAttr, element);

  /** @const {string|null|undefined} */
  var inputWidth = widthAttr && widthAttr != 'auto' ? parseLength(widthAttr) : widthAttr;
  (0, _log.userAssert)(inputWidth !== undefined, 'Invalid "width" value: %s, %s', widthAttr, element);

  /** @const {string|null|undefined} */
  var inputHeight = heightAttr && heightAttr != 'fluid' ? parseLength(heightAttr) : heightAttr;
  (0, _log.userAssert)(inputHeight !== undefined, 'Invalid "height" value: %s, %s', heightAttr, element);
  // Effective layout attributes. These are effectively constants.
  var width;
  var height;
  var layout;

  // Calculate effective width and height.
  if ((!inputLayout || inputLayout == Layout.FIXED || inputLayout == Layout.FIXED_HEIGHT) && (!inputWidth || !inputHeight) && hasNaturalDimensions(element.tagName)) {
    // Default width and height: handle elements that do not specify a
    // width/height and are defined to have natural browser dimensions.
    var dimensions = getNaturalDimensions(element);
    width = inputWidth || inputLayout == Layout.FIXED_HEIGHT ? inputWidth : dimensions.width;
    height = inputHeight || dimensions.height;
  } else {
    width = inputWidth;
    height = inputHeight;
  }

  // Calculate effective layout.
  if (inputLayout) {
    layout = inputLayout;
  } else if (!width && !height) {
    layout = Layout.CONTAINER;
  } else if (height == 'fluid') {
    layout = Layout.FLUID;
  } else if (height && (!width || width == 'auto')) {
    layout = Layout.FIXED_HEIGHT;
  } else if (height && width && (sizesAttr || heightsAttr)) {
    layout = Layout.RESPONSIVE;
  } else {
    layout = Layout.FIXED;
  }

  // Verify layout attributes.
  if (layout == Layout.FIXED || layout == Layout.FIXED_HEIGHT || layout == Layout.RESPONSIVE || layout == Layout.INTRINSIC) {
    (0, _log.userAssert)(height, 'The "height" attribute is missing: %s', element);
  }

  if (layout == Layout.FIXED_HEIGHT) {
    (0, _log.userAssert)(!width || width == 'auto', 'The "width" attribute must be missing or "auto": %s', element);
  }

  if (layout == Layout.FIXED || layout == Layout.RESPONSIVE || layout == Layout.INTRINSIC) {
    (0, _log.userAssert)(width && width != 'auto', 'The "width" attribute must be present and not "auto": %s', element);
  }

  if (layout == Layout.RESPONSIVE || layout == Layout.INTRINSIC) {
    (0, _log.userAssert)(getLengthUnits(width) == getLengthUnits(height), 'Length units should be the same for "width" and "height": %s, %s, %s', widthAttr, heightAttr, element);
  } else {
    (0, _log.userAssert)(heightsAttr === null, '"heights" attribute must be missing: %s', element);
  }

  // Apply UI.
  element.classList.add(getLayoutClass(layout));

  if (isLayoutSizeDefined(layout)) {
    element.classList.add('i-amphtml-layout-size-defined');
  }

  if (layout == Layout.NODISPLAY) {
    // CSS defines layout=nodisplay automatically with `display:none`. Thus
    // no additional styling is needed.
    (0, _style.toggle)(element, false);
    // TODO(jridgewell): Temporary hack while SSR still adds an inline
    // `display: none`
    element['style']['display'] = '';
  } else if (layout == Layout.FIXED) {
    (0, _style.setStyles)(element, {
      width: (0, _log.dev)().assertString(width),
      height: (0, _log.dev)().assertString(height)
    });
  } else if (layout == Layout.FIXED_HEIGHT) {
    (0, _style.setStyle)(element, 'height', (0, _log.dev)().assertString(height));
  } else if (layout == Layout.RESPONSIVE) {
    if (shouldUseAspectRatioCss((0, _types.toWin)(element.ownerDocument.defaultView))) {
      (0, _style.setStyle)(element, 'aspect-ratio', getLengthNumeral(width) + "/" + getLengthNumeral(height));
    } else {
      var sizer = element.ownerDocument.createElement('i-amphtml-sizer');
      sizer.setAttribute('slot', 'i-amphtml-svc');
      (0, _style.setStyles)(sizer, {
        paddingTop: getLengthNumeral(height) / getLengthNumeral(width) * 100 + '%'
      });
      element.insertBefore(sizer, element.firstChild);
      element.sizerElement = sizer;
    }
  } else if (layout == Layout.INTRINSIC) {
    // Intrinsic uses an svg inside the sizer element rather than the padding
    // trick Note a naked svg won't work becasue other thing expect the
    // i-amphtml-sizer element
    var _sizer = (0, _staticTemplate.htmlFor)(element)(_templateObject());

    var intrinsicSizer = _sizer.firstElementChild;
    intrinsicSizer.setAttribute('src', !false && fixIeIntrinsic && element.ownerDocument ? (0, _img.transparentPng)(element.ownerDocument, (0, _log.dev)().assertNumber(getLengthNumeral(width)), (0, _log.dev)().assertNumber(getLengthNumeral(height))) : "data:image/svg+xml;charset=utf-8,<svg height=\"" + height + "\" width=\"" + width + "\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\"/>");
    element.insertBefore(_sizer, element.firstChild);
    element.sizerElement = _sizer;
  } else if (layout == Layout.FILL) {// Do nothing.
  } else if (layout == Layout.CONTAINER) {// Do nothing. Elements themselves will check whether the supplied
    // layout value is acceptable. In particular container is only OK
    // sometimes.
  } else if (layout == Layout.FLEX_ITEM) {
    // Set height and width to a flex item if they exist.
    // The size set to a flex item could be overridden by `display: flex` later.
    if (width) {
      (0, _style.setStyle)(element, 'width', width);
    }

    if (height) {
      (0, _style.setStyle)(element, 'height', height);
    }
  } else if (layout == Layout.FLUID) {
    element.classList.add('i-amphtml-layout-awaiting-size');

    if (width) {
      (0, _style.setStyle)(element, 'width', width);
    }

    (0, _style.setStyle)(element, 'height', 0);
  }

  // Mark the element as having completed static layout, in case it is cloned
  // in the future.
  element.setAttribute('i-amphtml-layout', layout);
  return layout;
}

/**
 * Whether aspect-ratio CSS can be used to implement responsive layouts.
 *
 * @param {!Window} win
 * @return {boolean}
 */
function shouldUseAspectRatioCss(win) {
  if (aspectRatioCssCache == null) {
    aspectRatioCssCache = (0, _experiments.isExperimentOn)(win, 'layout-aspect-ratio-css') && win.CSS && win.CSS.supports && win.CSS.supports('aspect-ratio: 1/1') || false;
  }

  return aspectRatioCssCache;
}

/** @visibleForTesting */
function resetShouldUseAspectRatioCssForTesting() {
  aspectRatioCssCache = null;
}

},{"./experiments":14,"./log":19,"./static-template":27,"./style":30,"./types":31,"./utils/img":37}],18:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createPseudoLocale = createPseudoLocale;
exports.LocalizedStringBundleDef = exports.LocalizedStringDef = exports.LocalizedStringId = void 0;

var _json = require("./json");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A unique identifier for each localized string.  Localized string IDs should:
 *
 *   - Maintain alphabetical order, by component
 *   - Be prefixed with the name of the extension that uses the string
 *     (e.g. "AMP_STORY_"), or with "AMP_" if they are general
 *   - NOT be reused; to deprecate an ID, comment it out and prefix its key with
 *     the string "DEPRECATED_"
 *
 * Next ID: 89
 *
 * @const @enum {string}
 */
var LocalizedStringId = {
  // amp-story
  AMP_STORY_ACTIVATE_BUTTON_TEXT: '83',
  AMP_STORY_AUDIO_MUTE_BUTTON_LABEL: '66',
  AMP_STORY_AUDIO_MUTE_BUTTON_TEXT: '31',
  AMP_STORY_AUDIO_UNMUTE_BUTTON_LABEL: '67',
  AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT: '33',
  AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT: '32',
  AMP_STORY_BOOKEND_MORE_TO_READ_LABEL: '30',
  AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE: '29',
  AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL: '28',
  AMP_STORY_CLOSE_BUTTON_LABEL: '87',
  AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL: '22',
  AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL: '23',
  AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL: '27',
  AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL: '25',
  AMP_STORY_DOMAIN_DIALOG_HEADING_LINK: '26',
  AMP_STORY_EDUCATION_NAVIGATION_SWIPE_PROGRESS: '78',
  AMP_STORY_EDUCATION_NAVIGATION_SWIPE_INSTRUCTIONS: '79',
  AMP_STORY_EDUCATION_NAVIGATION_SWIPE_DISMISS: '80',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS: '75',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS_SINGLE: '81',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_INSTRUCTIONS: '76',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_DISMISS: '77',
  AMP_STORY_HAS_NEW_PAGE_TEXT: '64',
  AMP_STORY_HINT_UI_NEXT_LABEL: '2',
  AMP_STORY_HINT_UI_PREVIOUS_LABEL: '3',
  AMP_STORY_INFO_BUTTON_LABEL: '68',
  AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL: '35',
  AMP_STORY_PAGINATION_BUTTON_PREVIOUS_PAGE_LABEL: '82',
  AMP_STORY_PAGE_ERROR_VIDEO: '65',
  AMP_STORY_PAGE_PLAY_VIDEO: '34',
  AMP_STORY_PAUSE_BUTTON_LABEL: '85',
  AMP_STORY_PLAY_BUTTON_LABEL: '86',
  AMP_STORY_SHARE_BUTTON_LABEL: '69',
  AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT: '4',
  AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT: '5',
  AMP_STORY_SHARING_PAGE_LABEL: '62',
  AMP_STORY_SHARING_PROVIDER_NAME_EMAIL: '6',
  AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK: '7',
  AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS: '8',
  AMP_STORY_SHARING_PROVIDER_NAME_LINE: '63',
  AMP_STORY_SHARING_PROVIDER_NAME_LINK: '9',
  AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN: '10',
  AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST: '11',
  AMP_STORY_SHARING_PROVIDER_NAME_SMS: '12',
  AMP_STORY_SHARING_PROVIDER_NAME_SYSTEM: '13',
  AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR: '14',
  AMP_STORY_SHARING_PROVIDER_NAME_TWITTER: '15',
  AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP: '16',
  AMP_STORY_SIDEBAR_BUTTON_LABEL: '70',
  AMP_STORY_SKIP_NEXT_BUTTON_LABEL: '88',
  AMP_STORY_TOOLTIP_EXPAND_TWEET: '36',
  AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT: '37',
  AMP_STORY_WARNING_DESKTOP_SIZE_TEXT: '18',
  AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT: '38',
  AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT: '19',
  AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT: '20',
  AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT: '21',
  // amp-story-auto-ads
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_APPLY_NOW: '39',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_BOOK_NOW: '40',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_BUY_TICKETS: '41',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_DOWNLOAD: '42',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_EXPLORE: '43',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_GET_NOW: '44',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_INSTALL: '45',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_LEARN_MORE: '46',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_LISTEN: '47',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_MORE: '48',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_OPEN_APP: '49',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_ORDER_NOW: '50',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_PLAY: '51',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_READ: '52',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SHOP: '53',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SHOW: '54',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SHOWTIMES: '55',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SIGN_UP: '56',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SUBSCRIBE: '57',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_USE_APP: '58',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_VIEW: '59',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_WATCH: '60',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_WATCH_EPISODE: '61',
  // amp-story-interactive
  AMP_STORY_INTERACTIVE_RESULTS_SCORE: '84',
  AMP_STORY_INTERACTIVE_QUIZ_ANSWER_CHOICE_A: '71',
  AMP_STORY_INTERACTIVE_QUIZ_ANSWER_CHOICE_B: '72',
  AMP_STORY_INTERACTIVE_QUIZ_ANSWER_CHOICE_C: '73',
  AMP_STORY_INTERACTIVE_QUIZ_ANSWER_CHOICE_D: '74' // DEPRECATED_AMP_STORY_EXPERIMENT_ENABLE_BUTTON_LABEL: '0',
  // DEPRECATED_AMP_STORY_EXPERIMENT_ENABLED_TEXT: '1',
  // DEPRECATED_AMP_STORY_CONSENT_DISMISS_DIALOG_BUTTON_LABEL: '24',
  // DEPRECATED_AMP_STORY_SYSTEM_LAYER_SHARE_WIDGET_LABEL: '17',

};
exports.LocalizedStringId = LocalizedStringId;

/**
 * @typedef {{
 *   string: string,
 *   description: string,
 * }}
 */
var LocalizedStringDef;
exports.LocalizedStringDef = LocalizedStringDef;

/**
 * @typedef {!Object<!LocalizedStringId, !LocalizedStringDef>}
 */
var LocalizedStringBundleDef;
exports.LocalizedStringBundleDef = LocalizedStringBundleDef;

/**
 * Creates a deep copy of the specified LocalizedStringBundle.
 * @param {!LocalizedStringBundleDef} localizedStringBundle
 * @return {!LocalizedStringBundleDef}
 */
function cloneLocalizedStringBundle(localizedStringBundle) {
  return (
    /** @type {!LocalizedStringBundleDef} */
    (0, _json.parseJson)(JSON.stringify(
    /** @type {!JsonObject} */
    localizedStringBundle))
  );
}

/**
 * Creates a pseudo locale by applying string transformations (specified by the
 * localizationFn) to an existing string bundle, without modifying the original.
 * @param {!LocalizedStringBundleDef} localizedStringBundle The localized
 *     string bundle to be transformed.
 * @param {function(string): string} localizationFn The transformation to be
 *     applied to each string in the bundle.
 * @return {!LocalizedStringBundleDef} The new strings.
 */
function createPseudoLocale(localizedStringBundle, localizationFn) {
  /** @type {!LocalizedStringBundleDef} */
  var pseudoLocaleStringBundle = cloneLocalizedStringBundle(localizedStringBundle);
  Object.keys(pseudoLocaleStringBundle).forEach(function (localizedStringIdAsStr) {
    var localizedStringId =
    /** @type {!LocalizedStringId} */
    localizedStringIdAsStr;
    pseudoLocaleStringBundle[localizedStringId].string = localizationFn(localizedStringBundle[localizedStringId].string);
    pseudoLocaleStringBundle[localizedStringId].fallback = localizationFn(localizedStringBundle[localizedStringId].fallback);
  });
  return pseudoLocaleStringBundle;
}

},{"./json":16}],19:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isUserErrorMessage = isUserErrorMessage;
exports.stripUserError = stripUserError;
exports.isUserErrorEmbed = isUserErrorEmbed;
exports.setReportError = setReportError;
exports.overrideLogLevel = overrideLogLevel;
exports.duplicateErrorIfNecessary = duplicateErrorIfNecessary;
exports.createErrorVargs = createErrorVargs;
exports.rethrowAsync = rethrowAsync;
exports.initLogConstructor = initLogConstructor;
exports.resetLogConstructorForTesting = resetLogConstructorForTesting;
exports.user = user;
exports.dev = dev;
exports.isFromEmbed = isFromEmbed;
exports.devAssert = devAssert;
exports.userAssert = userAssert;
exports.Log = exports.LogLevel = exports.USER_ERROR_EMBED_SENTINEL = exports.USER_ERROR_SENTINEL = void 0;

var _mode = require("./mode");

var _internalVersion = require("./internal-version");

var _types = require("./types");

var _function = require("./utils/function");

var _config = require("./config");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var noop = function noop() {};

/**
 * Triple zero width space.
 *
 * This is added to user error messages, so that we can later identify
 * them, when the only thing that we have is the message. This is the
 * case in many browsers when the global exception handler is invoked.
 *
 * @const {string}
 */
var USER_ERROR_SENTINEL = "\u200B\u200B\u200B";
exports.USER_ERROR_SENTINEL = USER_ERROR_SENTINEL;

/**
 * Four zero width space.
 *
 * @const {string}
 */
var USER_ERROR_EMBED_SENTINEL = "\u200B\u200B\u200B\u200B";
exports.USER_ERROR_EMBED_SENTINEL = USER_ERROR_EMBED_SENTINEL;

/**
 * @param {string} message
 * @return {boolean} Whether this message was a user error.
 */
function isUserErrorMessage(message) {
  return message.indexOf(USER_ERROR_SENTINEL) >= 0;
}

/**
 * @param {string} message
 * @return {string} The new message without USER_ERROR_SENTINEL
 */
function stripUserError(message) {
  return message.replace(USER_ERROR_SENTINEL, '');
}

/**
 * @param {string} message
 * @return {boolean} Whether this message was a a user error from an iframe embed.
 */
function isUserErrorEmbed(message) {
  return message.indexOf(USER_ERROR_EMBED_SENTINEL) >= 0;
}

/**
 * @enum {number}
 */
var LogLevel = {
  OFF: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  FINE: 4
};
exports.LogLevel = LogLevel;

/**
 * Sets reportError function. Called from error.js to break cyclic
 * dependency.
 * @param {function(*, !Element=)|undefined} fn
 */
function setReportError(fn) {
  self.__AMP_REPORT_ERROR = fn;
}

/**
 * @type {!LogLevel|undefined}
 * @private
 */
var levelOverride_ = undefined;

/**
 * @param {!LogLevel} level
 */
function overrideLogLevel(level) {
  levelOverride_ = level;
}

/**
 * Prefixes `internalRuntimeVersion` with the `01` channel signifier (for prod.) for
 * extracted message URLs.
 * (Specific channel is irrelevant: message tables are invariant on internal version.)
 * @return {string}
 */
var messageUrlRtv = function messageUrlRtv() {
  return "01" + (0, _internalVersion.internalRuntimeVersion)();
};

/**
 * Gets a URL to display a message on amp.dev.
 * @param {string} id
 * @param {!Array} interpolatedParts
 * @return {string}
 */
var externalMessageUrl = function externalMessageUrl(id, interpolatedParts) {
  return interpolatedParts.reduce(function (prefix, arg) {
    return prefix + "&s[]=" + messageArgToEncodedComponent(arg);
  }, "https://log.amp.dev/?v=" + messageUrlRtv() + "&id=" + encodeURIComponent(id));
};

/**
 * URL to simple log messages table JSON file, which contains an Object<string, string>
 * which maps message id to full message template.
 * @return {string}
 */
var externalMessagesSimpleTableUrl = function externalMessagesSimpleTableUrl() {
  return _config.urls.cdn + "/rtv/" + messageUrlRtv() + "/log-messages.simple.json";
};

/**
 * @param {*} arg
 * @return {string}
 */
var messageArgToEncodedComponent = function messageArgToEncodedComponent(arg) {
  return encodeURIComponent(String(elementStringOrPassthru(arg)));
};

/**
 * Logging class. Use of sentinel string instead of a boolean to check user/dev
 * errors because errors could be rethrown by some native code as a new error,
 * and only a message would survive. Also, some browser don’t support a 5th
 * error object argument in window.onerror. List of supporting browser can be
 * found here:
 * https://blog.sentry.io/2016/01/04/client-javascript-reporting-window-onerror.html
 * @final
 * @private Visible for testing only.
 */
var Log = /*#__PURE__*/function () {
  /**
   * opt_suffix will be appended to error message to identify the type of the
   * error message. We can't rely on the error object to pass along the type
   * because some browsers do not have this param in its window.onerror API.
   * See:
   * https://blog.sentry.io/2016/01/04/client-javascript-reporting-window-onerror.html
   *
   * @param {!Window} win
   * @param {function(number, boolean):!LogLevel} levelFunc
   * @param {string=} opt_suffix
   */
  function Log(win, levelFunc, opt_suffix) {
    var _this = this;

    if (opt_suffix === void 0) {
      opt_suffix = '';
    }

    _classCallCheck(this, Log);

    /**
     * In tests we use the main test window instead of the iframe where
     * the tests runs because only the former is relayed to the console.
     * @const {!Window}
     */
    this.win = (0, _mode.getMode)().test && win.__AMP_TEST_IFRAME ? win.parent : win;

    /** @private @const {function(number, boolean):!LogLevel} */
    this.levelFunc_ = levelFunc;

    /** @private @const {!LogLevel} */
    this.level_ = this.defaultLevel_();

    /** @private @const {string} */
    this.suffix_ = opt_suffix;

    /** @private {?JsonObject} */
    this.messages_ = null;
    this.fetchExternalMessagesOnce_ = (0, _function.once)(function () {
      win.fetch(externalMessagesSimpleTableUrl()).then(function (response) {
        return response.json();
      }, noop).then(function (opt_messages) {
        if (opt_messages) {
          _this.messages_ =
          /** @type {!JsonObject} */
          opt_messages;
        }
      });
    });
  }

  /**
   * @return {!LogLevel}
   * @private
   */
  _createClass(Log, [{
    key: "getLevel_",
    value: function getLevel_() {
      return levelOverride_ !== undefined ? levelOverride_ : this.level_;
    }
    /**
     * @return {!LogLevel}
     * @private
     */

  }, {
    key: "defaultLevel_",
    value: function defaultLevel_() {
      // No console - can't enable logging.
      if (!this.win.console || !this.win.console.log) {
        return LogLevel.OFF;
      }

      // Logging has been explicitly disabled.
      if ((0, _mode.getMode)().log == '0') {
        return LogLevel.OFF;
      }

      // Logging is enabled for tests directly.
      if ((0, _mode.getMode)().test && this.win.ENABLE_LOG) {
        return LogLevel.FINE;
      }

      // LocalDev by default allows INFO level, unless overriden by `#log`.
      if ((0, _mode.getMode)().localDev && !(0, _mode.getMode)().log) {
        return LogLevel.INFO;
      }

      return this.defaultLevelWithFunc_();
    }
    /**
     * @return {!LogLevel}
     * @private
     */

  }, {
    key: "defaultLevelWithFunc_",
    value: function defaultLevelWithFunc_() {
      // Delegate to the specific resolver.
      return this.levelFunc_(parseInt((0, _mode.getMode)().log, 10), (0, _mode.getMode)().development);
    }
    /**
     * @param {string} tag
     * @param {string} level
     * @param {!Array} messages
     */

  }, {
    key: "msg_",
    value: function msg_(tag, level, messages) {
      if (this.getLevel_() != LogLevel.OFF) {
        var fn = this.win.console.log;

        if (level == 'ERROR') {
          fn = this.win.console.error || fn;
        } else if (level == 'INFO') {
          fn = this.win.console.info || fn;
        } else if (level == 'WARN') {
          fn = this.win.console.warn || fn;
        }

        var args = this.maybeExpandMessageArgs_(messages);
        // Prefix console message with "[tag]".
        var prefix = "[" + tag + "]";

        if (typeof args[0] === 'string') {
          // Prepend string to avoid breaking string substitutions e.g. %s.
          args[0] = prefix + ' ' + args[0];
        } else {
          args.unshift(prefix);
        }

        fn.apply(this.win.console, args);
      }
    }
    /**
     * Whether the logging is enabled.
     * @return {boolean}
     */

  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.getLevel_() != LogLevel.OFF;
    }
    /**
     * Reports a fine-grained message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "fine",
    value: function fine(tag, var_args) {
      if (this.getLevel_() >= LogLevel.FINE) {
        this.msg_(tag, 'FINE', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports a informational message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "info",
    value: function info(tag, var_args) {
      if (this.getLevel_() >= LogLevel.INFO) {
        this.msg_(tag, 'INFO', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports a warning message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "warn",
    value: function warn(tag, var_args) {
      if (this.getLevel_() >= LogLevel.WARN) {
        this.msg_(tag, 'WARN', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports an error message. If the logging is disabled, the error is rethrown
     * asynchronously.
     * @param {string} tag
     * @param {...*} var_args
     * @return {!Error|undefined}
     * @private
     */

  }, {
    key: "error_",
    value: function error_(tag, var_args) {
      if (this.getLevel_() >= LogLevel.ERROR) {
        this.msg_(tag, 'ERROR', Array.prototype.slice.call(arguments, 1));
      } else {
        var error = createErrorVargs.apply(null, Array.prototype.slice.call(arguments, 1));
        this.prepareError_(error);
        return error;
      }
    }
    /**
     * Reports an error message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "error",
    value: function error(tag, var_args) {
      var error = this.error_.apply(this, arguments);

      if (error) {
        error.name = tag || error.name;

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(error);
      }
    }
    /**
     * Reports an error message and marks with an expected property. If the
     * logging is disabled, the error is rethrown asynchronously.
     * @param {string} unusedTag
     * @param {...*} var_args
     */

  }, {
    key: "expectedError",
    value: function expectedError(unusedTag, var_args) {
      var error = this.error_.apply(this, arguments);

      if (error) {
        error.expected = true;

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(error);
      }
    }
    /**
     * Creates an error object.
     * @param {...*} var_args
     * @return {!Error}
     */

  }, {
    key: "createError",
    value: function createError(var_args) {
      var error = createErrorVargs.apply(null, arguments);
      this.prepareError_(error);
      return error;
    }
    /**
     * Creates an error object with its expected property set to true.
     * @param {...*} var_args
     * @return {!Error}
     */

  }, {
    key: "createExpectedError",
    value: function createExpectedError(var_args) {
      var error = createErrorVargs.apply(null, arguments);
      this.prepareError_(error);
      error.expected = true;
      return error;
    }
    /**
     * Throws an error if the first argument isn't trueish.
     *
     * Supports argument substitution into the message via %s placeholders.
     *
     * Throws an error object that has two extra properties:
     * - associatedElement: This is the first element provided in the var args.
     *   It can be used for improved display of error messages.
     * - messageArray: The elements of the substituted message as non-stringified
     *   elements in an array. When e.g. passed to console.error this yields
     *   native displays of things like HTML elements.
     *
     * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
     *     not evaluate to true.
     * @param {!Array|string=} opt_message The assertion message
     * @param {...*} var_args Arguments substituted into %s in the message.
     * @return {T} The value of shouldBeTrueish.
     * @throws {!Error} When `value` is falsey.
     * @template T
     * @closurePrimitive {asserts.truthy}
     */

  }, {
    key: "assert",
    value: function assert(shouldBeTrueish, opt_message, var_args) {
      var firstElement;

      if ((0, _types.isArray)(opt_message)) {
        return this.assert.apply(this, [shouldBeTrueish].concat(this.expandMessageArgs_(
        /** @type {!Array} */
        opt_message)));
      }

      if (!shouldBeTrueish) {
        var message = opt_message || 'Assertion failed';
        var splitMessage = message.split('%s');
        var first = splitMessage.shift();
        var formatted = first;
        var messageArray = [];
        var i = 2;
        pushIfNonEmpty(messageArray, first);

        while (splitMessage.length > 0) {
          var nextConstant = splitMessage.shift();
          var val = arguments[i++];

          if (val && val.tagName) {
            firstElement = val;
          }

          messageArray.push(val);
          pushIfNonEmpty(messageArray, nextConstant.trim());
          formatted += stringOrElementString(val) + nextConstant;
        }

        var e = new Error(formatted);
        e.fromAssert = true;
        e.associatedElement = firstElement;
        e.messageArray = messageArray;
        this.prepareError_(e);

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(e);

        throw e;
      }

      return shouldBeTrueish;
    }
    /**
     * Throws an error if the first argument isn't an Element
     *
     * Otherwise see `assert` for usage
     *
     * @param {*} shouldBeElement
     * @param {!Array|string=} opt_message The assertion message
     * @return {!Element} The value of shouldBeTrueish.
     * @template T
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertElement",
    value: function assertElement(shouldBeElement, opt_message) {
      var shouldBeTrueish = shouldBeElement && shouldBeElement.nodeType == 1;
      this.assertType_(shouldBeElement, shouldBeTrueish, 'Element expected', opt_message);
      return (
        /** @type {!Element} */
        shouldBeElement
      );
    }
    /**
     * Throws an error if the first argument isn't a string. The string can
     * be empty.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeString
     * @param {!Array|string=} opt_message The assertion message
     * @return {string} The string value. Can be an empty string.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertString",
    value: function assertString(shouldBeString, opt_message) {
      this.assertType_(shouldBeString, typeof shouldBeString == 'string', 'String expected', opt_message);
      return (
        /** @type {string} */
        shouldBeString
      );
    }
    /**
     * Throws an error if the first argument isn't a number. The allowed values
     * include `0` and `NaN`.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeNumber
     * @param {!Array|string=} opt_message The assertion message
     * @return {number} The number value. The allowed values include `0`
     *   and `NaN`.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertNumber",
    value: function assertNumber(shouldBeNumber, opt_message) {
      this.assertType_(shouldBeNumber, typeof shouldBeNumber == 'number', 'Number expected', opt_message);
      return (
        /** @type {number} */
        shouldBeNumber
      );
    }
    /**
     * Throws an error if the first argument is not an array.
     * The array can be empty.
     *
     * @param {*} shouldBeArray
     * @param {!Array|string=} opt_message The assertion message
     * @return {!Array} The array value
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertArray",
    value: function assertArray(shouldBeArray, opt_message) {
      this.assertType_(shouldBeArray, (0, _types.isArray)(shouldBeArray), 'Array expected', opt_message);
      return (
        /** @type {!Array} */
        shouldBeArray
      );
    }
    /**
     * Throws an error if the first argument isn't a boolean.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeBoolean
     * @param {!Array|string=} opt_message The assertion message
     * @return {boolean} The boolean value.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertBoolean",
    value: function assertBoolean(shouldBeBoolean, opt_message) {
      this.assertType_(shouldBeBoolean, !!shouldBeBoolean === shouldBeBoolean, 'Boolean expected', opt_message);
      return (
        /** @type {boolean} */
        shouldBeBoolean
      );
    }
    /**
     * Asserts and returns the enum value. If the enum doesn't contain such a
     * value, the error is thrown.
     *
     * @param {!Object<T>} enumObj
     * @param {string} s
     * @param {string=} opt_enumName
     * @return {T}
     * @template T
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertEnumValue",
    value: function assertEnumValue(enumObj, s, opt_enumName) {
      if ((0, _types.isEnumValue)(enumObj, s)) {
        return s;
      }

      this.assert(false, 'Unknown %s value: "%s"', opt_enumName || 'enum', s);
    }
    /**
     * @param {!Error} error
     * @private
     */

  }, {
    key: "prepareError_",
    value: function prepareError_(error) {
      error = duplicateErrorIfNecessary(error);

      if (this.suffix_) {
        if (!error.message) {
          error.message = this.suffix_;
        } else if (error.message.indexOf(this.suffix_) == -1) {
          error.message += this.suffix_;
        }
      } else if (isUserErrorMessage(error.message)) {
        error.message = error.message.replace(USER_ERROR_SENTINEL, '');
      }
    }
    /**
     * @param {!Array} args
     * @return {!Array}
     * @private
     */

  }, {
    key: "maybeExpandMessageArgs_",
    value: function maybeExpandMessageArgs_(args) {
      if ((0, _types.isArray)(args[0])) {
        return this.expandMessageArgs_(
        /** @type {!Array} */
        args[0]);
      }

      return args;
    }
    /**
     * Either redirects a pair of (errorId, ...args) to a URL where the full
     * message is displayed, or displays it from a fetched table.
     *
     * This method is used by the output of the `transform-log-methods` babel
     * plugin. It should not be used directly. Use the (*error|assert*|info|warn)
     * methods instead.
     *
     * @param {!Array} parts
     * @return {!Array}
     * @private
     */

  }, {
    key: "expandMessageArgs_",
    value: function expandMessageArgs_(parts) {
      // First value should exist.
      var id = parts.shift();

      // Best effort fetch of message template table.
      // Since this is async, the first few logs might be indirected to a URL even
      // if in development mode. Message table is ~small so this should be a short
      // gap.
      if ((0, _mode.getMode)(this.win).development) {
        this.fetchExternalMessagesOnce_();
      }

      if (this.messages_ && id in this.messages_) {
        return [this.messages_[id]].concat(parts);
      }

      return ["More info at " + externalMessageUrl(id, parts)];
    }
    /**
     * Asserts types, backbone of `assertNumber`, `assertString`, etc.
     *
     * It understands array-based "id"-contracted messages.
     *
     * Otherwise creates a sprintf syntax string containing the optional message or the
     * default. An interpolation token is added at the end to include the `subject`.
     * @param {*} subject
     * @param {*} assertion
     * @param {string} defaultMessage
     * @param {!Array|string=} opt_message
     * @private
     */

  }, {
    key: "assertType_",
    value: function assertType_(subject, assertion, defaultMessage, opt_message) {
      if ((0, _types.isArray)(opt_message)) {
        this.assert(assertion, opt_message.concat(subject));
      } else {
        this.assert(assertion, (opt_message || defaultMessage) + ": %s", subject);
      }
    }
  }]);

  return Log;
}();

exports.Log = Log;

/**
 * @param {string|!Element} val
 * @return {string}
 */
var stringOrElementString = function stringOrElementString(val) {
  return (
    /** @type {string} */
    elementStringOrPassthru(val)
  );
};

/**
 * @param {*} val
 * @return {*}
 */
function elementStringOrPassthru(val) {
  // Do check equivalent to `val instanceof Element` without cross-window bug
  if (val && val.nodeType == 1) {
    return val.tagName.toLowerCase() + (val.id ? '#' + val.id : '');
  }

  return val;
}

/**
 * @param {!Array} array
 * @param {*} val
 */
function pushIfNonEmpty(array, val) {
  if (val != '') {
    array.push(val);
  }
}

/**
 * Some exceptions (DOMException, namely) have read-only message.
 * @param {!Error} error
 * @return {!Error};
 */
function duplicateErrorIfNecessary(error) {
  var messageProperty = Object.getOwnPropertyDescriptor(error, 'message');

  if (messageProperty && messageProperty.writable) {
    return error;
  }

  var message = error.message,
      stack = error.stack;
  var e = new Error(message);

  // Copy all the extraneous things we attach.
  for (var prop in error) {
    e[prop] = error[prop];
  }

  // Ensure these are copied.
  e.stack = stack;
  return e;
}

/**
 * @param {...*} var_args
 * @return {!Error}
 * @visibleForTesting
 */
function createErrorVargs(var_args) {
  var error = null;
  var message = '';

  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];

    if (arg instanceof Error && !error) {
      error = duplicateErrorIfNecessary(arg);
    } else {
      if (message) {
        message += ' ';
      }

      message += arg;
    }
  }

  if (!error) {
    error = new Error(message);
  } else if (message) {
    error.message = message + ': ' + error.message;
  }

  return error;
}

/**
 * Rethrows the error without terminating the current context. This preserves
 * whether the original error designation is a user error or a dev error.
 * @param {...*} var_args
 */
function rethrowAsync(var_args) {
  var error = createErrorVargs.apply(null, arguments);
  setTimeout(function () {
    // reportError is installed globally per window in the entry point.
    self.__AMP_REPORT_ERROR(error);

    throw error;
  });
}

/**
 * Cache for logs. We do not use a Service since the service module depends
 * on Log and closure literally can't even.
 * @type {{user: ?Log, dev: ?Log, userForEmbed: ?Log}}
 */
self.__AMP_LOG = self.__AMP_LOG || {
  user: null,
  dev: null,
  userForEmbed: null
};
var logs = self.__AMP_LOG;

/**
 * Eventually holds a constructor for Log objects. Lazily initialized, so we
 * can avoid ever referencing the real constructor except in JS binaries
 * that actually want to include the implementation.
 * @type {?typeof Log}
 */
var logConstructor = null;

/**
 * Initializes log constructor.
 */
function initLogConstructor() {
  logConstructor = Log;
  // Initialize instances for use. If a binary (an extension for example) that
  // does not call `initLogConstructor` invokes `dev()` or `user()` earlier than
  // the binary that does call `initLogConstructor` (amp.js), the extension will
  // throw an error as that extension will never be able to initialize the log
  // instances and we also don't want it to call `initLogConstructor` either
  // (since that will cause the Log implementation to be bundled into that
  // binary). So we must initialize the instances eagerly so that they are ready
  // for use (stored globally) after the main binary calls `initLogConstructor`.
  dev();
  user();
}

/**
 * Resets log constructor for testing.
 */
function resetLogConstructorForTesting() {
  logConstructor = null;
}

/**
 * Publisher level log.
 *
 * Enabled in the following conditions:
 *  1. Not disabled using `#log=0`.
 *  2. Development mode is enabled via `#development=1` or logging is explicitly
 *     enabled via `#log=D` where D >= 1.
 *  3. AMP.setLogLevel(D) is called, where D >= 1.
 *
 * @param {!Element=} opt_element
 * @return {!Log}
 */
function user(opt_element) {
  if (!logs.user) {
    logs.user = getUserLogger(USER_ERROR_SENTINEL);
  }

  if (!isFromEmbed(logs.user.win, opt_element)) {
    return logs.user;
  } else {
    if (logs.userForEmbed) {
      return logs.userForEmbed;
    }

    return logs.userForEmbed = getUserLogger(USER_ERROR_EMBED_SENTINEL);
  }
}

/**
 * Getter for user logger
 * @param {string=} suffix
 * @return {!Log}
 */
function getUserLogger(suffix) {
  if (!logConstructor) {
    throw new Error('failed to call initLogConstructor');
  }

  return new logConstructor(self, function (logNum, development) {
    if (development || logNum >= 1) {
      return LogLevel.FINE;
    }

    return LogLevel.WARN;
  }, suffix);
}

/**
 * AMP development log. Calls to `devLog().assert` and `dev.fine` are stripped
 * in the PROD binary. However, `devLog().assert` result is preserved in either
 * case.
 *
 * Enabled in the following conditions:
 *  1. Not disabled using `#log=0`.
 *  2. Logging is explicitly enabled via `#log=D`, where D >= 2.
 *  3. AMP.setLogLevel(D) is called, where D >= 2.
 *
 * @return {!Log}
 */
function dev() {
  if (logs.dev) {
    return logs.dev;
  }

  if (!logConstructor) {
    throw new Error('failed to call initLogConstructor');
  }

  return logs.dev = new logConstructor(self, function (logNum) {
    if (logNum >= 3) {
      return LogLevel.FINE;
    }

    if (logNum >= 2) {
      return LogLevel.INFO;
    }

    return LogLevel.OFF;
  });
}

/**
 * @param {!Window} win
 * @param {!Element=} opt_element
 * @return {boolean} isEmbed
 */
function isFromEmbed(win, opt_element) {
  if (!opt_element) {
    return false;
  }

  return opt_element.ownerDocument.defaultView != win;
}

/**
 * Throws an error if the first argument isn't trueish.
 *
 * Supports argument substitution into the message via %s placeholders.
 *
 * Throws an error object that has two extra properties:
 * - associatedElement: This is the first element provided in the var args.
 *   It can be used for improved display of error messages.
 * - messageArray: The elements of the substituted message as non-stringified
 *   elements in an array. When e.g. passed to console.error this yields
 *   native displays of things like HTML elements.
 *
 * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
 *     not evaluate to true.
 * @param {!Array|string=} opt_message The assertion message
 * @param {*=} opt_1 Optional argument (Var arg as individual params for better
 * @param {*=} opt_2 Optional argument inlining)
 * @param {*=} opt_3 Optional argument
 * @param {*=} opt_4 Optional argument
 * @param {*=} opt_5 Optional argument
 * @param {*=} opt_6 Optional argument
 * @param {*=} opt_7 Optional argument
 * @param {*=} opt_8 Optional argument
 * @param {*=} opt_9 Optional argument
 * @return {T} The value of shouldBeTrueish.
 * @throws {!Error} When `shouldBeTrueish` is falsey.
 * @template T
 * @closurePrimitive {asserts.truthy}
 */
function devAssert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9) {
  if ((0, _mode.getMode)().minified) {
    return shouldBeTrueish;
  }

  return dev().
  /*Orig call*/
  assert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9);
}

/**
 * Throws an error if the first argument isn't trueish.
 *
 * Supports argument substitution into the message via %s placeholders.
 *
 * Throws an error object that has two extra properties:
 * - associatedElement: This is the first element provided in the var args.
 *   It can be used for improved display of error messages.
 * - messageArray: The elements of the substituted message as non-stringified
 *   elements in an array. When e.g. passed to console.error this yields
 *   native displays of things like HTML elements.
 *
 * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
 *     not evaluate to true.
 * @param {!Array|string=} opt_message The assertion message
 * @param {*=} opt_1 Optional argument (Var arg as individual params for better
 * @param {*=} opt_2 Optional argument inlining)
 * @param {*=} opt_3 Optional argument
 * @param {*=} opt_4 Optional argument
 * @param {*=} opt_5 Optional argument
 * @param {*=} opt_6 Optional argument
 * @param {*=} opt_7 Optional argument
 * @param {*=} opt_8 Optional argument
 * @param {*=} opt_9 Optional argument
 * @return {T} The value of shouldBeTrueish.
 * @throws {!Error} When `shouldBeTrueish` is falsey.
 * @template T
 * @closurePrimitive {asserts.truthy}
 */
function userAssert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9) {
  return user().
  /*Orig call*/
  assert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9);
}

},{"./config":7,"./internal-version":15,"./mode":20,"./types":31,"./utils/function":36}],20:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getMode = getMode;
exports.getRtvVersionForTesting = getRtvVersionForTesting;
exports.resetRtvVersionForTesting = resetRtvVersionForTesting;
exports.ModeDef = void 0;

var _internalVersion = require("./internal-version");

var _urlParseQueryString = require("./url-parse-query-string");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @typedef {{
 *   localDev: boolean,
 *   development: boolean,
 *   minified: boolean,
 *   lite: boolean,
 *   test: boolean,
 *   log: (string|undefined),
 *   version: string,
 *   rtvVersion: string,
 *   runtime: (null|string|undefined),
 *   a4aId: (null|string|undefined),
 *   esm: (boolean|undefined)
 * }}
 */
var ModeDef;
exports.ModeDef = ModeDef;

/**
 * `rtvVersion` is the prefixed version we serve off of the cdn.
 * The prefix denotes canary(00) or prod(01) or an experiment version ( > 01).
 * @type {string}
 */
var rtvVersion = '';

/**
 * Provides info about the current app.
 * @param {?Window=} opt_win
 * @return {!ModeDef}
 */
function getMode(opt_win) {
  var win = opt_win || self;

  if (win.__AMP_MODE) {
    return win.__AMP_MODE;
  }

  return win.__AMP_MODE = getMode_(win);
}

/**
 * Provides info about the current app.
 * @param {!Window} win
 * @return {!ModeDef}
 */
function getMode_(win) {
  // TODO(erwinmombay): simplify the logic here
  var AMP_CONFIG = self.AMP_CONFIG || {};
  // Magic constants that are replaced by closure compiler.
  // IS_MINIFIED is always replaced with true when closure compiler is used
  // while IS_DEV is only replaced when `gulp dist` is called without the
  // --fortesting flag.
  var IS_DEV = true;
  var IS_MINIFIED = false;
  var runningTests = IS_DEV && !!(AMP_CONFIG.test || win.__AMP_TEST || win.__karma__);
  var isLocalDev = IS_DEV && (!!AMP_CONFIG.localDev || runningTests);
  var hashQuery = (0, _urlParseQueryString.parseQueryString_)( // location.originalHash is set by the viewer when it removes the fragment
  // from the URL.
  win.location.originalHash || win.location.hash);
  var searchQuery = (0, _urlParseQueryString.parseQueryString_)(win.location.search);

  if (!rtvVersion) {
    rtvVersion = getRtvVersion(win);
  }

  // The `minified`, `test` and `localDev` properties are replaced
  // as boolean literals when we run `gulp dist` without the `--fortesting`
  // flags. This improved DCE on the production file we deploy as the code
  // paths for localhost/testing/development are eliminated.
  return {
    localDev: isLocalDev,
    // Triggers validation or enable pub level logging. Validation can be
    // bypassed via #validate=0.
    // Note that AMP_DEV_MODE flag is used for testing purposes.
    // Use Array.indexOf instead of Array.includes because of #24219
    development: !!(['1', 'actions', 'amp', 'amp4ads', 'amp4email'].indexOf(hashQuery['development']) >= 0 || win.AMP_DEV_MODE),
    examiner: hashQuery['development'] == '2',
    esm: false,
    // amp-geo override
    geoOverride: hashQuery['amp-geo'],
    minified: IS_MINIFIED,
    // Whether document is in an amp-lite viewer. It signal that the user
    // would prefer to use less bandwidth.
    lite: searchQuery['amp_lite'] != undefined,
    test: runningTests,
    log: hashQuery['log'],
    version: (0, _internalVersion.internalRuntimeVersion)(),
    rtvVersion: rtvVersion
  };
}

/**
 * Retrieve the `rtvVersion` which will have a numeric prefix
 * denoting canary/prod/experiment (unless `isLocalDev` is true).
 *
 * @param {!Window} win
 * @return {string}
 */
function getRtvVersion(win) {
  if (win.AMP_CONFIG && win.AMP_CONFIG.v) {
    return win.AMP_CONFIG.v;
  }

  // Currently `internalRuntimeVersion` and thus `mode.version` contain only
  // major version. The full version however must also carry the minor version.
  // We will default to production default `01` minor version for now.
  // TODO(erwinmombay): decide whether internalRuntimeVersion should contain
  // minor version.
  return "01" + (0, _internalVersion.internalRuntimeVersion)();
}

/**
 * @param {!Window} win
 * @return {string}
 * @visibleForTesting
 */
function getRtvVersionForTesting(win) {
  return getRtvVersion(win);
}

/** @visibleForTesting */
function resetRtvVersionForTesting() {
  rtvVersion = '';
}

},{"./internal-version":15,"./url-parse-query-string":32}],21:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * This class helps to manage observers. Observers can be added, removed or
 * fired through and instance of this class.
 * @template TYPE
 */
var Observable = /*#__PURE__*/function () {
  /**
   * Creates an instance of Observable.
   */
  function Observable() {
    _classCallCheck(this, Observable);

    /** @type {?Array<function(TYPE)>} */
    this.handlers_ = null;
  }

  /**
   * Adds the observer to this instance.
   * @param {function(TYPE)} handler Observer's handler.
   * @return {!UnlistenDef}
   */
  _createClass(Observable, [{
    key: "add",
    value: function add(handler) {
      var _this = this;

      if (!this.handlers_) {
        this.handlers_ = [];
      }

      this.handlers_.push(handler);
      return function () {
        _this.remove(handler);
      };
    }
    /**
     * Removes the observer from this instance.
     * @param {function(TYPE)} handler Observer's instance.
     */

  }, {
    key: "remove",
    value: function remove(handler) {
      if (!this.handlers_) {
        return;
      }

      var index = this.handlers_.indexOf(handler);

      if (index > -1) {
        this.handlers_.splice(index, 1);
      }
    }
    /**
     * Removes all observers.
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      if (!this.handlers_) {
        return;
      }

      this.handlers_.length = 0;
    }
    /**
     * Fires an event. All observers are called.
     * @param {TYPE=} opt_event
     */

  }, {
    key: "fire",
    value: function fire(opt_event) {
      if (!this.handlers_) {
        return;
      }

      var handlers = this.handlers_;

      for (var i = 0; i < handlers.length; i++) {
        var handler = handlers[i];
        handler(opt_event);
      }
    }
    /**
     * Returns number of handlers. Mostly needed for tests.
     * @return {number}
     */

  }, {
    key: "getHandlerCount",
    value: function getHandlerCount() {
      if (!this.handlers_) {
        return 0;
      }

      return this.handlers_.length;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

},{}],22:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.waitForServices = waitForServices;
exports.hasRenderDelayingServices = hasRenderDelayingServices;
exports.isRenderDelayingService = isRenderDelayingService;
exports.includedServices = includedServices;
exports.RenderDelayingService = void 0;

var _services = require("./services");

var _log = require("./log");

var _service = require("./service");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A map of services that delay rendering. The key is the name of the service
 * and the value is a DOM query which is used to check if the service is needed
 * in the current document.
 * Do not add a service unless absolutely necessary.
 *
 * \   \  /  \  /   / /   \     |   _  \     |  \ |  | |  | |  \ |  |  / _____|
 *  \   \/    \/   / /  ^  \    |  |_)  |    |   \|  | |  | |   \|  | |  |  __
 *   \            / /  /_\  \   |      /     |  . `  | |  | |  . `  | |  | |_ |
 *    \    /\    / /  _____  \  |  |\  \----.|  |\   | |  | |  |\   | |  |__| |
 *     \__/  \__/ /__/     \__\ | _| `._____||__| \__| |__| |__| \__|  \______|
 *
 * The equivalent of this list is used for server-side rendering (SSR) and any
 * changes made to it must be made in coordination with caches that implement
 * SSR. For more information on SSR see bit.ly/amp-ssr.
 *
 * @const {!Object<string, string>}
 */
var SERVICES = {
  'amp-dynamic-css-classes': '[custom-element=amp-dynamic-css-classes]',
  'variant': 'amp-experiment',
  'amp-story-render': 'amp-story[standalone]'
};

/**
 * Base class for render delaying services.
 * This should be extended to ensure the service
 * is properly handled
 *
 * @interface
 */
var RenderDelayingService = /*#__PURE__*/function () {
  function RenderDelayingService() {
    _classCallCheck(this, RenderDelayingService);
  }

  _createClass(RenderDelayingService, [{
    key: "whenReady",

    /**
     * Function to return a promise for when
     * it is finished delaying render, and is ready.
     * NOTE: This should simply return Promise.resolve,
     * if your service does not need to perform any logic
     * after being registered.
     * @return {!Promise}
     */
    value: function whenReady() {}
  }]);

  return RenderDelayingService;
}();

exports.RenderDelayingService = RenderDelayingService;

/**
 * Maximum milliseconds to wait for all extensions to load before erroring.
 * @const
 */
var LOAD_TIMEOUT = 3000;

/**
 * Detects any render delaying services that are required on the page, and
 * returns a promise with a timeout.
 * @param {!Window} win
 * @return {!Promise<!Array<*>>} resolves to an Array that has the same length
 *     as the detected render delaying services
 */
function waitForServices(win) {
  var promises = includedServices(win).map(function (serviceId) {
    var serviceReadyPromise = (0, _service.getServicePromise)(win, serviceId).then(function (service) {
      if (service && isRenderDelayingService(service)) {
        return service.whenReady().then(function () {
          return service;
        });
      }

      return service;
    });
    return _services.Services.timerFor(win).timeoutPromise(LOAD_TIMEOUT, serviceReadyPromise, "Render timeout waiting for service " + serviceId + " to be ready.");
  });
  return Promise.all(promises);
}

/**
 * Returns true if the page has a render delaying service.
 * @param {!Window} win
 * @return {boolean}
 */
function hasRenderDelayingServices(win) {
  return includedServices(win).length > 0;
}

/**
 * Function to determine if the passed
 * Object is a Render Delaying Service
 * @param {!Object} service
 * @return {boolean}
 */
function isRenderDelayingService(service) {
  var maybeRenderDelayingService =
  /** @type {!RenderDelayingService}*/
  service;
  return typeof maybeRenderDelayingService.whenReady == 'function';
}

/**
 * Detects which, if any, render-delaying extensions are included on the page.
 * @param {!Window} win
 * @return {!Array<string>}
 */
function includedServices(win) {
  /** @const {!Document} */
  var doc = win.document;
  (0, _log.devAssert)(doc.body);
  return Object.keys(SERVICES).filter(function (service) {
    return doc.querySelector(SERVICES[service]);
  });
}

},{"./log":19,"./service":24,"./services":25}],23:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.resolvedPromise = resolvedPromise;

/**
 * Copyright 2020 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var resolved;

/**
 * Returns a cached resolved promise.
 * Use this instead of directly calling Promise.resolve().
 * @return {!Promise<undefined>}
 */
function resolvedPromise() {
  if (resolved) {
    return resolved;
  }

  // It's important that we call with `undefined` here, to prevent a transform
  // recursion. If we didn't pass an arg, then the transformer would replace
  // this callsite with a call to `resolvedPromise()`.
  resolved = Promise.resolve(undefined);
  return resolved;
}

},{}],24:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.installServiceInEmbedScope = installServiceInEmbedScope;
exports.registerServiceBuilder = registerServiceBuilder;
exports.registerServiceBuilderForDoc = registerServiceBuilderForDoc;
exports.rejectServicePromiseForDoc = rejectServicePromiseForDoc;
exports.getService = getService;
exports.getServicePromise = getServicePromise;
exports.getExistingServiceOrNull = getExistingServiceOrNull;
exports.getServicePromiseOrNull = getServicePromiseOrNull;
exports.getServiceForDoc = getServiceForDoc;
exports.getServiceForDocOrNull = getServiceForDocOrNull;
exports.getServicePromiseForDoc = getServicePromiseForDoc;
exports.getServicePromiseOrNullForDoc = getServicePromiseOrNullForDoc;
exports.setParentWindow = setParentWindow;
exports.getParentWindow = getParentWindow;
exports.getTopWindow = getTopWindow;
exports.getParentWindowFrameElement = getParentWindowFrameElement;
exports.getAmpdoc = getAmpdoc;
exports.isDisposable = isDisposable;
exports.assertDisposable = assertDisposable;
exports.disposeServicesForDoc = disposeServicesForDoc;
exports.disposeServicesForEmbed = disposeServicesForEmbed;
exports.adoptServiceForEmbedDoc = adoptServiceForEmbedDoc;
exports.resetServiceForTesting = resetServiceForTesting;
exports.Disposable = void 0;

var _promise = require("./utils/promise");

var _log = require("./log");

var _types = require("./types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Holds info about a service.
 * - obj: Actual service implementation when available.
 * - promise: Promise for the obj.
 * - resolve: Function to resolve the promise with the object.
 * - context: Argument for ctor, either a window or an ampdoc.
 * - ctor: Function that constructs and returns the service.
 * @typedef {{
 *   obj: (?Object),
 *   promise: (?Promise),
 *   resolve: (?function(!Object)),
 *   reject: (?function((*))),
 *   context: (?Window|?./service/ampdoc-impl.AmpDoc),
 *   ctor: (?function(new:Object, !Window)|
 *          ?function(new:Object, !./service/ampdoc-impl.AmpDoc)),
 * }}
 */
var ServiceHolderDef;

/**
 * This interface provides a `dispose` method that will be called by
 * runtime when a service needs to be disposed of.
 * @interface
 */
var Disposable = /*#__PURE__*/function () {
  function Disposable() {
    _classCallCheck(this, Disposable);
  }

  _createClass(Disposable, [{
    key: "dispose",

    /**
     * Instructs the service to release any resources it might be holding. Can
     * be called only once in the lifecycle of a service.
     */
    value: function dispose() {}
  }]);

  return Disposable;
}();

exports.Disposable = Disposable;

/**
 * Installs a service override on amp-doc level.
 * @param {!Window} embedWin
 * @param {string} id
 * @param {!Object} service The service.
 */
function installServiceInEmbedScope(embedWin, id, service) {
  // TODO(#22733): completely remove this method once ampdoc-fie launches.
  var topWin = getTopWindow(embedWin);
  (0, _log.devAssert)(embedWin != topWin, 'Service override can only be installed in embed window: %s', id);
  var ampdoc = getAmpdoc(embedWin.document);
  registerServiceInternal(getAmpdocServiceHolder(ampdoc), ampdoc, id, function () {
    return service;
  },
  /* override */
  true);
}

/**
 * Registers a service given a class to be used as implementation.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {function(new:Object, !Window)} constructor
 * @param {boolean=} opt_instantiate Whether to immediately create the service
 */
function registerServiceBuilder(win, id, constructor, opt_instantiate) {
  win = getTopWindow(win);
  registerServiceInternal(win, win, id, constructor);

  if (opt_instantiate) {
    getServiceInternal(win, id);
  }
}

/**
 * Returns a service and registers it given a class to be used as
 * implementation.
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @param {string} id of the service.
 * @param {function(new:Object, !./service/ampdoc-impl.AmpDoc)} constructor
 * @param {boolean=} opt_instantiate Whether to immediately create the service
 */
function registerServiceBuilderForDoc(nodeOrDoc, id, constructor, opt_instantiate) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  registerServiceInternal(holder, ampdoc, id, constructor);

  if (opt_instantiate) {
    getServiceInternal(holder, id);
  }
}

/**
 * Reject a service promise.
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @param {string} id
 * @param {*} error
 */
function rejectServicePromiseForDoc(nodeOrDoc, id, error) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  rejectServicePromiseInternal(holder, id, error);
}

/**
 * Returns a service for the given id and window (a per-window singleton). Users
 * should typically wrap this as a special purpose function (e.g.
 * `Services.vsyncFor(win)`) for type safety and because the factory should not
 * be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @template T
 * @return {T}
 */
function getService(win, id) {
  win = getTopWindow(win);
  return getServiceInternal(win, id);
}

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. `Services.vsyncFor(win)`) for type safety and because the
 * factory should not be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @return {!Promise<!Object>}
 */
function getServicePromise(win, id) {
  return getServicePromiseInternal(win, id);
}

/**
 * Returns a service or null with the given id.
 * @param {!Window} win
 * @param {string} id
 * @return {?Object} The service.
 */
function getExistingServiceOrNull(win, id) {
  win = getTopWindow(win);

  if (isServiceRegistered(win, id)) {
    return getServiceInternal(win, id);
  } else {
    return null;
  }
}

/**
 * Like getServicePromise but returns null if the service was never registered.
 * @param {!Window} win
 * @param {string} id
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNull(win, id) {
  return getServicePromiseOrNullInternal(win, id);
}

/**
 * Returns a service for the given id and ampdoc (a per-ampdoc singleton).
 * Expects service `id` to be registered.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {T}
 * @template T
 */
function getServiceForDoc(elementOrAmpDoc, id) {
  var ampdoc = getAmpdoc(elementOrAmpDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  return getServiceInternal(holder, id);
}

/**
 * Returns a service for the given id and ampdoc (a per-ampdoc singleton).
 * If service `id` is not registered, returns null.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {?Object}
 */
function getServiceForDocOrNull(elementOrAmpDoc, id) {
  var ampdoc = getAmpdoc(elementOrAmpDoc);
  var holder = getAmpdocServiceHolder(ampdoc);

  if (isServiceRegistered(holder, id)) {
    return getServiceInternal(holder, id);
  } else {
    return null;
  }
}

/**
 * Returns a promise for a service for the given id and ampdoc. Also expects
 * a service that has the actual implementation. The promise resolves when
 * the implementation loaded.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {!Promise<!Object>}
 */
function getServicePromiseForDoc(elementOrAmpDoc, id) {
  return getServicePromiseInternal(getAmpdocServiceHolder(elementOrAmpDoc), id);
}

/**
 * Like getServicePromiseForDoc but returns null if the service was never
 * registered for this ampdoc.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNullForDoc(elementOrAmpDoc, id) {
  return getServicePromiseOrNullInternal(getAmpdocServiceHolder(elementOrAmpDoc), id);
}

/**
 * Set the parent and top windows on a child window (friendly iframe).
 * @param {!Window} win
 * @param {!Window} parentWin
 */
function setParentWindow(win, parentWin) {
  win.__AMP_PARENT = parentWin;
  win.__AMP_TOP = getTopWindow(parentWin);
}

/**
 * Returns the parent window for a child window (friendly iframe).
 * @param {!Window} win
 * @return {!Window}
 */
function getParentWindow(win) {
  return win.__AMP_PARENT || win;
}

/**
 * Returns the top window where AMP Runtime is installed for a child window
 * (friendly iframe).
 * @param {!Window} win
 * @return {!Window}
 */
function getTopWindow(win) {
  return win.__AMP_TOP || (win.__AMP_TOP = win);
}

/**
 * Returns the parent "friendly" iframe if the node belongs to a child window.
 * @param {!Node} node
 * @param {!Window=} opt_topWin
 * @return {?HTMLIFrameElement}
 */
function getParentWindowFrameElement(node, opt_topWin) {
  var childWin = (node.ownerDocument || node).defaultView;
  var topWin = opt_topWin || getTopWindow(childWin);

  if (childWin && childWin != topWin && getTopWindow(childWin) == topWin) {
    try {
      return (
        /** @type {?HTMLIFrameElement} */
        childWin.frameElement
      );
    } catch (e) {// Ignore the error.
    }
  }

  return null;
}

/**
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @return {!./service/ampdoc-impl.AmpDoc}
 */
function getAmpdoc(nodeOrDoc) {
  if (nodeOrDoc.nodeType) {
    var win = (0, _types.toWin)(
    /** @type {!Document} */
    (nodeOrDoc.ownerDocument || nodeOrDoc).defaultView);
    return getAmpdocService(win).getAmpDoc(
    /** @type {!Node} */
    nodeOrDoc);
  }

  return (
    /** @type {!./service/ampdoc-impl.AmpDoc} */
    nodeOrDoc
  );
}

/**
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @return {!./service/ampdoc-impl.AmpDoc|!Window}
 */
function getAmpdocServiceHolder(nodeOrDoc) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  return ampdoc.isSingleDoc() ? ampdoc.win : ampdoc;
}

/**
 * This is essentially a duplicate of `ampdoc.js`, but necessary to avoid
 * circular dependencies.
 * @param {!Window} win
 * @return {!./service/ampdoc-impl.AmpDocService}
 */
function getAmpdocService(win) {
  return (
    /** @type {!./service/ampdoc-impl.AmpDocService} */
    getService(win, 'ampdoc')
  );
}

/**
 * Get service `id` from `holder`. Assumes the service
 * has already been registered.
 * @param {!Object} holder Object holding the service instance.
 * @param {string} id of the service.
 * @return {Object}
 * @template T
 */
function getServiceInternal(holder, id) {
  (0, _log.devAssert)(isServiceRegistered(holder, id), "Expected service " + id + " to be registered");
  var services = getServices(holder);
  var s = services[id];

  if (!s.obj) {
    (0, _log.devAssert)(s.ctor, "Service " + id + " registered without ctor nor impl.");
    (0, _log.devAssert)(s.context, "Service " + id + " registered without context.");
    s.obj = new s.ctor(s.context);
    (0, _log.devAssert)(s.obj, "Service " + id + " constructed to null.");
    s.ctor = null;
    s.context = null;

    // The service may have been requested already, in which case we have a
    // pending promise we need to fulfill.
    if (s.resolve) {
      s.resolve(s.obj);
    }
  }

  return s.obj;
}

/**
 * @param {!Object} holder Object holding the service instance.
 * @param {!Window|!./service/ampdoc-impl.AmpDoc} context Win or AmpDoc.
 * @param {string} id of the service.
 * @param {?function(new:Object, !Window)|?function(new:Object, !./service/ampdoc-impl.AmpDoc)} ctor Constructor function to new the service. Called with context.
 * @param {boolean=} opt_override
 */
function registerServiceInternal(holder, context, id, ctor, opt_override) {
  var services = getServices(holder);
  var s = services[id];

  if (!s) {
    s = services[id] = {
      obj: null,
      promise: null,
      resolve: null,
      reject: null,
      context: null,
      ctor: null
    };
  }

  if (!opt_override && (s.ctor || s.obj)) {
    // Service already registered.
    return;
  }

  s.ctor = ctor;
  s.context = context;

  // The service may have been requested already, in which case there is a
  // pending promise that needs to fulfilled.
  if (s.resolve) {
    // getServiceInternal will resolve the promise.
    getServiceInternal(holder, id);
  }
}

/**
 * @param {!Object} holder
 * @param {string} id of the service.
 * @return {!Promise<!Object>}
 */
function getServicePromiseInternal(holder, id) {
  var cached = getServicePromiseOrNullInternal(holder, id);

  if (cached) {
    return cached;
  }

  // Service is not registered.
  // TODO(@cramforce): Add a check that if the element is eventually registered
  // that the service is actually provided and this promise resolves.
  var services = getServices(holder);
  services[id] = emptyServiceHolderWithPromise();
  return (
    /** @type {!Promise<!Object>} */
    services[id].promise
  );
}

/**
 * @param {!Object} holder
 * @param {string} id of the service.
 * @param {*} error
 */
function rejectServicePromiseInternal(holder, id, error) {
  var services = getServices(holder);
  var s = services[id];

  if (s) {
    if (s.reject) {
      s.reject(error);
    }

    return;
  }

  services[id] = emptyServiceHolderWithPromise();
  services[id].reject(error);
}

/**
 * Returns a promise for service `id` if the service has been registered
 * on `holder`.
 * @param {!Object} holder
 * @param {string} id of the service.
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNullInternal(holder, id) {
  var services = getServices(holder);
  var s = services[id];

  if (s) {
    if (s.promise) {
      return s.promise;
    } else {
      // Instantiate service if not already instantiated.
      getServiceInternal(holder, id);
      return s.promise = Promise.resolve(
      /** @type {!Object} */
      s.obj);
    }
  }

  return null;
}

/**
 * Returns the object that holds the services registered in a holder.
 * @param {!Object} holder
 * @return {!Object<string,!ServiceHolderDef>}
 */
function getServices(holder) {
  var services = holder.__AMP_SERVICES;

  if (!services) {
    services = holder.__AMP_SERVICES = {};
  }

  return services;
}

/**
 * Whether the specified service implements `Disposable` interface.
 * @param {!Object} service
 * @return {boolean}
 */
function isDisposable(service) {
  return typeof service.dispose == 'function';
}

/**
 * Asserts that the specified service implements `Disposable` interface and
 * typecasts the instance to `Disposable`.
 * @param {!Object} service
 * @return {!Disposable}
 */
function assertDisposable(service) {
  (0, _log.devAssert)(isDisposable(service), 'required to implement Disposable');
  return (
    /** @type {!Disposable} */
    service
  );
}

/**
 * Disposes all disposable (implements `Disposable` interface) services in
 * ampdoc scope.
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 */
function disposeServicesForDoc(ampdoc) {
  disposeServicesInternal(ampdoc);
}

/**
 * Disposes all disposable (implements `Disposable` interface) services in
 * embed scope.
 * @param {!Window} embedWin
 */
function disposeServicesForEmbed(embedWin) {
  disposeServicesInternal(embedWin);
}

/**
 * @param {!Object} holder Object holding the service instances.
 */
function disposeServicesInternal(holder) {
  // TODO(dvoytenko): Consider marking holder as destroyed for later-arriving
  // service to be canceled automatically.
  var services = getServices(holder);

  var _loop = function _loop(id) {
    if (!Object.prototype.hasOwnProperty.call(services, id)) {
      return "continue";
    }

    var serviceHolder = services[id];

    if (serviceHolder.obj) {
      disposeServiceInternal(id, serviceHolder.obj);
    } else if (serviceHolder.promise) {
      serviceHolder.promise.then(function (instance) {
        return disposeServiceInternal(id, instance);
      });
    }
  };

  for (var id in services) {
    var _ret = _loop(id);

    if (_ret === "continue") continue;
  }
}

/**
 * @param {string} id
 * @param {!Object} service
 */
function disposeServiceInternal(id, service) {
  if (!isDisposable(service)) {
    return;
  }

  try {
    assertDisposable(service).dispose();
  } catch (e) {
    // Ensure that a failure to dispose a service does not disrupt other
    // services.
    (0, _log.dev)().error('SERVICE', 'failed to dispose service', id, e);
  }
}

/**
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 * @param {string} id
 */
function adoptServiceForEmbedDoc(ampdoc, id) {
  var service = getServiceInternal(getAmpdocServiceHolder((0, _log.devAssert)(ampdoc.getParent())), id);
  registerServiceInternal(getAmpdocServiceHolder(ampdoc), ampdoc, id, function () {
    return service;
  });
}

/**
 * Resets a single service, so it gets recreated on next getService invocation.
 * @param {!Object} holder
 * @param {string} id of the service.
 */
function resetServiceForTesting(holder, id) {
  if (holder.__AMP_SERVICES) {
    holder.__AMP_SERVICES[id] = null;
  }
}

/**
 * @param {!Object} holder Object holding the service instance.
 * @param {string} id of the service.
 * @return {boolean}
 */
function isServiceRegistered(holder, id) {
  var service = holder.__AMP_SERVICES && holder.__AMP_SERVICES[id];
  // All registered services must have an implementation or a constructor.
  return !!(service && (service.ctor || service.obj));
}

/** @return {!ServiceHolderDef} */
function emptyServiceHolderWithPromise() {
  var deferred = new _promise.Deferred();
  var promise = deferred.promise,
      resolve = deferred.resolve,
      reject = deferred.reject;
  promise.catch(function () {});
  // avoid uncaught exception when service gets rejected
  return {
    obj: null,
    promise: promise,
    resolve: resolve,
    reject: reject,
    context: null,
    ctor: null
  };
}

},{"./log":19,"./types":31,"./utils/promise":40}],25:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Services = exports.SubscriptionService = void 0;

var _service = require("./service");

var _elementService = require("./element-service");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @typedef {!../extensions/amp-subscriptions/0.1/amp-subscriptions.SubscriptionService} */
var SubscriptionService;
exports.SubscriptionService = SubscriptionService;

var Services = /*#__PURE__*/function () {
  function Services() {
    _classCallCheck(this, Services);
  }

  _createClass(Services, null, [{
    key: "accessServiceForDoc",

    /**
     * Hint: Add extensions folder path to compile.js with
     * warnings cannot find modules.
     */

    /**
     * Returns a promise for the Access service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-access/0.1/amp-access.AccessService>}
     */
    value: function accessServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-access/0.1/amp-access.AccessService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'access', 'amp-access')
      );
    }
    /**
     * Returns a promise for the Access service or a promise for null if the
     * service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-access/0.1/amp-access.AccessService>}
     */

  }, {
    key: "accessServiceForDocOrNull",
    value: function accessServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-access/0.1/amp-access.AccessService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'access', 'amp-access')
      );
    }
    /**
     * Returns a promise for the Subscriptions service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!SubscriptionService>}
     */

  }, {
    key: "subscriptionsServiceForDoc",
    value: function subscriptionsServiceForDoc(element) {
      return (
        /** @type {!Promise<!SubscriptionService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'subscriptions', 'amp-subscriptions')
      );
    }
    /**
     * Returns a promise for the Subscriptions service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?SubscriptionService>}
     */

  }, {
    key: "subscriptionsServiceForDocOrNull",
    value: function subscriptionsServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?SubscriptionService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'subscriptions', 'amp-subscriptions')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/action-impl.ActionService}
     */

  }, {
    key: "actionServiceForDoc",
    value: function actionServiceForDoc(element) {
      return (
        /** @type {!./service/action-impl.ActionService} */
        (0, _service.getServiceForDocOrNull)(element, 'action')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/standard-actions-impl.StandardActions}
     */

  }, {
    key: "standardActionsForDoc",
    value: function standardActionsForDoc(element) {
      return (
        /** @type {!./service/standard-actions-impl.StandardActions} */
        (0, _service.getServiceForDocOrNull)(element, 'standard-actions')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-analytics/0.1/activity-impl.Activity>}
     */

  }, {
    key: "activityForDoc",
    value: function activityForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-analytics/0.1/activity-impl.Activity>} */
        (0, _elementService.getElementServiceForDoc)(element, 'activity', 'amp-analytics')
      );
    }
    /**
     * Returns the global instance of the `AmpDocService` service that can be
     * used to resolve an ampdoc for any node: either in the single-doc or
     * shadow-doc environment.
     * @param {!Window} window
     * @return {!./service/ampdoc-impl.AmpDocService}
     */

  }, {
    key: "ampdocServiceFor",
    value: function ampdocServiceFor(window) {
      return (
        /** @type {!./service/ampdoc-impl.AmpDocService} */
        (0, _service.getService)(window, 'ampdoc')
      );
    }
    /**
     * Returns the AmpDoc for the specified context node.
     * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrAmpDoc
     * @return {!./service/ampdoc-impl.AmpDoc}
     */

  }, {
    key: "ampdoc",
    value: function ampdoc(nodeOrAmpDoc) {
      return (0, _service.getAmpdoc)(nodeOrAmpDoc);
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @param {boolean=} loadAnalytics
     * @return {!Promise<!../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>}
     */

  }, {
    key: "analyticsForDoc",
    value: function analyticsForDoc(element, loadAnalytics) {
      if (loadAnalytics === void 0) {
        loadAnalytics = false;
      }

      if (loadAnalytics) {
        // Get Extensions service and force load analytics extension.
        var ampdoc = (0, _service.getAmpdoc)(element);
        Services.extensionsFor(ampdoc.win).
        /*OK*/
        installExtensionForDoc(ampdoc, 'amp-analytics');
      }

      return (
        /** @type {!Promise<!../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'amp-analytics-instrumentation', 'amp-analytics')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>}
     */

  }, {
    key: "analyticsForDocOrNull",
    value: function analyticsForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'amp-analytics-instrumentation', 'amp-analytics')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/batched-xhr-impl.BatchedXhr}
     */

  }, {
    key: "batchedXhrFor",
    value: function batchedXhrFor(window) {
      return (
        /** @type {!./service/batched-xhr-impl.BatchedXhr} */
        (0, _service.getService)(window, 'batched-xhr')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-bind/0.1/bind-impl.Bind>}
     */

  }, {
    key: "bindForDocOrNull",
    value: function bindForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-bind/0.1/bind-impl.Bind>} */
        (0, _elementService.getElementServiceIfAvailableForDocInEmbedScope)(element, 'bind', 'amp-bind')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-script/0.1/amp-script.AmpScriptService>}
     */

  }, {
    key: "scriptForDocOrNull",
    value: function scriptForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-script/0.1/amp-script.AmpScriptService>} */
        (0, _elementService.getElementServiceIfAvailableForDocInEmbedScope)(element, 'amp-script', 'amp-script')
      );
    }
    /**
     * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/cid-impl.CidDef>}
     */

  }, {
    key: "cidForDoc",
    value: function cidForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/cid-impl.CidDef>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'cid')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/navigation.Navigation}
     */

  }, {
    key: "navigationForDoc",
    value: function navigationForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/navigation.Navigation} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'navigation')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-loader/0.1/amp-loader.LoaderService>}
     */

  }, {
    key: "loaderServiceForDoc",
    value: function loaderServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-loader/0.1/amp-loader.LoaderService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'loader', 'amp-loader')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-standalone/0.1/amp-standalone.StandaloneService>}
     */

  }, {
    key: "standaloneServiceForDoc",
    value: function standaloneServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-standalone/0.1/amp-standalone.StandaloneService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'standalone', 'amp-standalone')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/crypto-impl.Crypto}
     */

  }, {
    key: "cryptoFor",
    value: function cryptoFor(window) {
      return (
        /** @type {!./service/crypto-impl.Crypto} */
        (0, _service.getService)(window, 'crypto')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/document-info-impl.DocumentInfoDef} Info about the doc
     */

  }, {
    key: "documentInfoForDoc",
    value: function documentInfoForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/document-info-impl.DocInfo} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'documentInfo').get()
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/extensions-impl.Extensions}
     */

  }, {
    key: "extensionsFor",
    value: function extensionsFor(window) {
      return (
        /** @type {!./service/extensions-impl.Extensions} */
        (0, _service.getService)(window, 'extensions')
      );
    }
    /**
     * Returns a service to register callbacks we wish to execute when an
     * amp-form is submitted.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<../extensions/amp-form/0.1/form-submit-service.FormSubmitService>}
     */

  }, {
    key: "formSubmitForDoc",
    value: function formSubmitForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<../extensions/amp-form/0.1/form-submit-service.FormSubmitService>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'form-submit-service')
      );
    }
    /**
     * Returns service to listen for `hidden` attribute mutations.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/hidden-observer-impl.HiddenObserver}
     */

  }, {
    key: "hiddenObserverForDoc",
    value: function hiddenObserverForDoc(element) {
      return (
        /** @type {!./service/hidden-observer-impl.HiddenObserver} */
        (0, _service.getServiceForDocOrNull)(element, 'hidden-observer')
      );
    }
    /**
     * Returns service implemented in service/history-impl.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/history-impl.History}
     */

  }, {
    key: "historyForDoc",
    value: function historyForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/history-impl.History} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'history')
      );
    }
    /**
     * @param {!Window} win
     * @return {!./input.Input}
     */

  }, {
    key: "inputFor",
    value: function inputFor(win) {
      return (0, _service.getService)(win, 'input');
    }
    /**s
     * Returns a promise for the Inputmask service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-inputmask/0.1/amp-inputmask.AmpInputmaskService>}
     */

  }, {
    key: "inputmaskServiceForDocOrNull",
    value: function inputmaskServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-inputmask/0.1/amp-inputmask.AmpInputmaskService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'inputmask', 'amp-inputmask')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {?./service/loading-indicator.LoadingIndicatorImpl}
     */

  }, {
    key: "loadingIndicatorOrNull",
    value: function loadingIndicatorOrNull(elementOrAmpDoc) {
      return (
        /** @type {?./service/loading-indicator.LoadingIndicatorImpl} */
        (0, _service.getServiceForDocOrNull)(elementOrAmpDoc, 'loadingIndicator')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!../extensions/amp-next-page/1.0/service.NextPageService}
     */

  }, {
    key: "nextPageServiceForDoc",
    value: function nextPageServiceForDoc(elementOrAmpDoc) {
      return (
        /** @type {!../extensions/amp-next-page/1.0/service.NextPageService} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'next-page')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/mutator-interface.MutatorInterface}
     */

  }, {
    key: "mutatorForDoc",
    value: function mutatorForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/mutator-interface.MutatorInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'mutator')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/owners-interface.OwnersInterface}
     */

  }, {
    key: "ownersForDoc",
    value: function ownersForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/owners-interface.OwnersInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'owners')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/performance-impl.Performance}
     */

  }, {
    key: "performanceFor",
    value: function performanceFor(window) {
      return (
        /** @type {!./service/performance-impl.Performance}*/
        (0, _service.getService)(window, 'performance')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/performance-impl.Performance}
     */

  }, {
    key: "performanceForOrNull",
    value: function performanceForOrNull(window) {
      return (
        /** @type {!./service/performance-impl.Performance}*/
        (0, _service.getExistingServiceOrNull)(window, 'performance')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/platform-impl.Platform}
     */

  }, {
    key: "platformFor",
    value: function platformFor(window) {
      return (
        /** @type {!./service/platform-impl.Platform} */
        (0, _service.getService)(window, 'platform')
      );
    }
    /**
     * Not installed by default; must be installed in extension code before use.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/position-observer/position-observer-impl.PositionObserver}
     * @throws If the service is not installed.
     */

  }, {
    key: "positionObserverForDoc",
    value: function positionObserverForDoc(element) {
      return (
        /** @type {!./service/position-observer/position-observer-impl.PositionObserver} */
        (0, _service.getServiceForDoc)(element, 'position-observer')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./preconnect.PreconnectService}
     */

  }, {
    key: "preconnectFor",
    value: function preconnectFor(window) {
      return (0, _service.getService)(window, 'preconnect');
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/resources-interface.ResourcesInterface}
     */

  }, {
    key: "resourcesForDoc",
    value: function resourcesForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/resources-interface.ResourcesInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'resources')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/resources-interface.ResourcesInterface>}
     */

  }, {
    key: "resourcesPromiseForDoc",
    value: function resourcesPromiseForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/resources-interface.ResourcesInterface>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'resources')
      );
    }
    /**
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService>}
     */

  }, {
    key: "storyVariableServiceForOrNull",
    value: function storyVariableServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-variable', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService}
     */

  }, {
    key: "storyVariableService",
    value: function storyVariableService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-variable')
      );
    }
    /**
     * Version of the story store service depends on which version of amp-story
     * the publisher is loading. They all have the same implementation.
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService>}
     */

  }, {
    key: "storyStoreServiceForOrNull",
    value: function storyStoreServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-store', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService}
     */

  }, {
    key: "storyStoreService",
    value: function storyStoreService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-store')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-media-query-service.AmpStoryMediaQueryService}
     */

  }, {
    key: "storyMediaQueryService",
    value: function storyMediaQueryService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-media-query-service.AmpStoryMediaQueryService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-media-query')
      );
    }
    /**
     * Get promise with story request service
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService>}
     */

  }, {
    key: "storyRequestServiceForOrNull",
    value: function storyRequestServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-request', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService}
     */

  }, {
    key: "storyRequestService",
    value: function storyRequestService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-request')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/media-performance-metrics-service.MediaPerformanceMetricsService}
     */

  }, {
    key: "mediaPerformanceMetricsService",
    value: function mediaPerformanceMetricsService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/media-performance-metrics-service.MediaPerformanceMetricsService} */
        (0, _service.getExistingServiceOrNull)(win, 'media-performance-metrics')
      );
    }
    /**
     * @param {!Element} el
     * @return {!Promise<./service/localization.LocalizationService>}
     */

  }, {
    key: "localizationServiceForOrNull",
    value: function localizationServiceForOrNull(el) {
      return (
        /** @type {!Promise<?./service/localization.LocalizationService>} */
        (0, _service.getServicePromiseForDoc)(el, 'localization')
      );
    }
    /**
     * @param {!Element} element
     * @return {?./service/localization.LocalizationService}
     */

  }, {
    key: "localizationForDoc",
    value: function localizationForDoc(element) {
      return (
        /** @type {?./service/localization.LocalizationService} */
        (0, _service.getServiceForDocOrNull)(element, 'localization')
      );
    }
    /**
     * TODO(#14357): Remove this when amp-story:0.1 is deprecated.
     * @param {!Window} win
     * @return {!Promise<?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService>}
     */

  }, {
    key: "storyAnalyticsServiceForOrNull",
    value: function storyAnalyticsServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-analytics', 'amp-story', true)
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService}
     */

  }, {
    key: "storyAnalyticsService",
    value: function storyAnalyticsService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-analytics')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-animation/0.1/web-animation-service.WebAnimationService>}
     */

  }, {
    key: "webAnimationServiceFor",
    value: function webAnimationServiceFor(element) {
      return (
        /** @type {!Promise<!../extensions/amp-animation/0.1/web-animation-service.WebAnimationService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'web-animation', 'amp-animation')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/storage-impl.Storage>}
     */

  }, {
    key: "storageForDoc",
    value: function storageForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/storage-impl.Storage>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'storage')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/template-impl.Templates}
     */

  }, {
    key: "templatesFor",
    value: function templatesFor(window) {
      return (
        /** @type {!./service/template-impl.Templates} */
        (0, _service.getService)(window, 'templates')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/timer-impl.Timer}
     */

  }, {
    key: "timerFor",
    value: function timerFor(window) {
      // TODO(alabiaga): This will always return the top window's Timer service.
      return (
        /** @type {!./service/timer-impl.Timer} */
        (0, _service.getService)(window, 'timer')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/url-replacements-impl.UrlReplacements}
     */

  }, {
    key: "urlReplacementsForDoc",
    value: function urlReplacementsForDoc(element) {
      return (
        /** @type {!./service/url-replacements-impl.UrlReplacements} */
        (0, _service.getServiceForDocOrNull)(element, 'url-replace')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-user-notification/0.1/amp-user-notification.UserNotificationManager>}
     */

  }, {
    key: "userNotificationManagerForDoc",
    value: function userNotificationManagerForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-user-notification/0.1/amp-user-notification.UserNotificationManager>} */
        (0, _elementService.getElementServiceForDoc)(element, 'userNotificationManager', 'amp-user-notification')
      );
    }
    /**
     * Returns a promise for the consentPolicy Service or a promise for null if
     * the service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-consent/0.1/consent-policy-manager.ConsentPolicyManager>}
     */

  }, {
    key: "consentPolicyServiceForDocOrNull",
    value: function consentPolicyServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-consent/0.1/consent-policy-manager.ConsentPolicyManager>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'consentPolicyManager', 'amp-consent')
      );
    }
    /**
     * Returns a promise for the geo service or a promise for null if
     * the service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-geo/0.1/amp-geo.GeoDef>}
     */

  }, {
    key: "geoForDocOrNull",
    value: function geoForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-geo/0.1/amp-geo.GeoDef>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'geo', 'amp-geo', true)
      );
    }
    /**
     * Unlike most service getters, passing `Node` is necessary for some FIE-scope
     * services since sometimes we only have the FIE Document for context.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/url-impl.Url}
     */

  }, {
    key: "urlForDoc",
    value: function urlForDoc(element) {
      return (
        /** @type {!./service/url-impl.Url} */
        (0, _service.getServiceForDocOrNull)(element, 'url')
      );
    }
    /**
     * Returns a promise for the experiment variants or a promise for null if it
     * is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-experiment/0.1/variant.Variants>}
     */

  }, {
    key: "variantsForDocOrNull",
    value: function variantsForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-experiment/0.1/variant.Variants>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'variant', 'amp-experiment', true)
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/video-manager-impl.VideoManager}
     */

  }, {
    key: "videoManagerForDoc",
    value: function videoManagerForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/video-manager-impl.VideoManager} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'video-manager')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/viewer-interface.ViewerInterface}
     */

  }, {
    key: "viewerForDoc",
    value: function viewerForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/viewer-interface.ViewerInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'viewer')
      );
    }
    /**
     * Returns promise for the viewer. This is an unusual case and necessary only
     * for services that need reference to the viewer before it has been
     * initialized. Most of the code, however, just should use `viewerForDoc`.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/viewer-interface.ViewerInterface>}
     */

  }, {
    key: "viewerPromiseForDoc",
    value: function viewerPromiseForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/viewer-interface.ViewerInterface>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'viewer')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/vsync-impl.Vsync}
     */

  }, {
    key: "vsyncFor",
    value: function vsyncFor(window) {
      return (
        /** @type {!./service/vsync-impl.Vsync} */
        (0, _service.getService)(window, 'vsync')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/viewport/viewport-interface.ViewportInterface}
     */

  }, {
    key: "viewportForDoc",
    value: function viewportForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/viewport/viewport-interface.ViewportInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'viewport')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/xhr-impl.Xhr}
     */

  }, {
    key: "xhrFor",
    value: function xhrFor(window) {
      return (
        /** @type {!./service/xhr-impl.Xhr} */
        (0, _service.getService)(window, 'xhr')
      );
    }
  }]);

  return Services;
}();

exports.Services = Services;

},{"./element-service":10,"./service":24}],26:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createShadowRoot = createShadowRoot;
exports.importShadowBody = importShadowBody;
exports.transformShadowCss = transformShadowCss;
exports.scopeShadowCss = scopeShadowCss;
exports.installShadowStyle = installShadowStyle;
exports.resetShadowStyleCacheForTesting = resetShadowStyleCacheForTesting;
exports.setShadowDomStreamingSupportedForTesting = setShadowDomStreamingSupportedForTesting;
exports.isShadowDomStreamingSupported = isShadowDomStreamingSupported;
exports.createShadowDomWriter = createShadowDomWriter;

var _domWriter = require("./utils/dom-writer");

var _services = require("./services");

var _ShadowCSS = require("../third_party/webcomponentsjs/ShadowCSS");

var _webComponents = require("./web-components");

var _log = require("./log");

var _css = require("./css");

var _styleInstaller = require("./style-installer");

var _dom = require("./dom");

var _style = require("./style");

var _types = require("./types");

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @const {!RegExp} */
var CSS_SELECTOR_BEG_REGEX = /[^\.\-\_0-9a-zA-Z]/;

/** @const {!RegExp} */
var CSS_SELECTOR_END_REGEX = /[^\-\_0-9a-zA-Z]/;
var SHADOW_CSS_CACHE = '__AMP_SHADOW_CSS';

/**
 * @type {boolean|undefined}
 */
var shadowDomStreamingSupported;

/**
 * Creates a shadow root for the specified host and returns it. Polyfills
 * shadow root creation if necessary.
 * @param {!Element} hostElement
 * @return {!ShadowRoot}
 */
function createShadowRoot(hostElement) {
  var win = (0, _types.toWin)(hostElement.ownerDocument.defaultView);
  var existingRoot = hostElement.shadowRoot || hostElement.__AMP_SHADOW_ROOT;

  if (existingRoot) {
    existingRoot.
    /*OK*/
    innerHTML = '';
    return existingRoot;
  }

  var shadowRoot;
  var shadowDomSupported = (0, _webComponents.getShadowDomSupportedVersion)();

  if (shadowDomSupported == _webComponents.ShadowDomVersion.V1) {
    shadowRoot = hostElement.attachShadow({
      mode: 'open'
    });

    if (!shadowRoot.styleSheets) {
      Object.defineProperty(shadowRoot, 'styleSheets', {
        get: function get() {
          var items = [];
          (0, _dom.iterateCursor)(shadowRoot.childNodes, function (child) {
            if (child.tagName === 'STYLE') {
              items.push(child.sheet);
            }
          });
          return items;
        }
      });
    }
  } else if (shadowDomSupported == _webComponents.ShadowDomVersion.V0) {
    shadowRoot = hostElement.createShadowRoot();
  } else {
    shadowRoot = createShadowRootPolyfill(hostElement);
  }

  if (!(0, _webComponents.isShadowCssSupported)()) {
    var rootId = "i-amphtml-sd-" + win.Math.floor(win.Math.random() * 10000);
    shadowRoot.id = rootId;
    shadowRoot.host.classList.add(rootId);
    // CSS isolation.
    (0, _styleInstaller.installCssTransformer)(shadowRoot, function (css) {
      return transformShadowCss(shadowRoot, css);
    });
  }

  return shadowRoot;
}

/**
 * Shadow root polyfill.
 * @param {!Element} hostElement
 * @return {!ShadowRoot}
 */
function createShadowRootPolyfill(hostElement) {
  var doc = hostElement.ownerDocument;
  // Host CSS polyfill.
  hostElement.classList.add('i-amphtml-shadow-host-polyfill');
  var hostStyle = doc.createElement('style');
  hostStyle.textContent = '.i-amphtml-shadow-host-polyfill>:not(i-amphtml-shadow-root)' + '{display:none!important}';
  hostElement.appendChild(hostStyle);
  // Shadow root.
  var shadowRoot
  /** @type {!ShadowRoot} */
  = // Cast to ShadowRoot even though it is an Element
  // TODO(@dvoytenko) Consider to switch to a type union instead.

  /** @type {?}  */
  doc.createElement('i-amphtml-shadow-root');
  hostElement.appendChild(shadowRoot);
  hostElement.__AMP_SHADOW_ROOT = shadowRoot;
  Object.defineProperty(hostElement, 'shadowRoot', {
    enumerable: true,
    configurable: true,
    value: shadowRoot
  });
  // API: https://www.w3.org/TR/shadow-dom/#the-shadowroot-interface
  shadowRoot.host = hostElement;

  // `getElementById` is resolved via `querySelector('#id')`.
  shadowRoot.getElementById = function (id) {
    var escapedId = (0, _css.escapeCssSelectorIdent)(id);
    return (
      /** @type {HTMLElement|null} */
      shadowRoot.
      /*OK*/
      querySelector("#" + escapedId)
    );
  };

  // The styleSheets property should have a list of local styles.
  Object.defineProperty(shadowRoot, 'styleSheets', {
    get: function get() {
      if (!doc.styleSheets) {
        return [];
      }

      return (0, _types.toArray)(doc.styleSheets).filter(function (styleSheet) {
        return shadowRoot.contains(styleSheet.ownerNode);
      });
    }
  });
  return shadowRoot;
}

/**
 * Imports a body into a shadow root with the workaround for a polyfill case.
 * @param {!ShadowRoot} shadowRoot
 * @param {!Element} body
 * @param {boolean} deep
 * @return {!Element}
 */
function importShadowBody(shadowRoot, body, deep) {
  var doc = shadowRoot.ownerDocument;
  var resultBody;

  if ((0, _webComponents.isShadowCssSupported)()) {
    resultBody = (0, _log.dev)().assertElement(doc.importNode(body, deep));
  } else {
    resultBody = doc.createElement('amp-body');
    (0, _style.setInitialDisplay)(resultBody, 'block');

    for (var i = 0; i < body.attributes.length; i++) {
      resultBody.setAttribute(body.attributes[0].name, body.attributes[0].value);
    }

    if (deep) {
      for (var n = body.firstChild; !!n; n = n.nextSibling) {
        resultBody.appendChild(doc.importNode(n, true));
      }
    }
  }

  (0, _style.setStyle)(resultBody, 'position', 'relative');
  var oldBody = shadowRoot.body;

  if (oldBody) {
    shadowRoot.removeChild(oldBody);
  }

  shadowRoot.appendChild(resultBody);
  Object.defineProperty(shadowRoot, 'body', {
    configurable: true,
    value: resultBody
  });
  return resultBody;
}

/**
 * If necessary, transforms CSS to isolate AMP CSS within the shaodw root and
 * reduce the possibility of high-level conflicts.
 * @param {!ShadowRoot} shadowRoot
 * @param {string} css
 * @return {string}
 */
function transformShadowCss(shadowRoot, css) {
  return scopeShadowCss(shadowRoot, css);
}

/**
 * Transforms CSS to isolate AMP CSS within the shadow root and reduce the
 * possibility of high-level conflicts. There are two types of transformations:
 * 1. Root transformation: `body` -> `amp-body`, etc.
 * 2. Scoping: `a {}` -> `.i-amphtml-sd-123 a {}`.
 *
 * @param {!ShadowRoot} shadowRoot
 * @param {string} css
 * @return {string}
 * @visibleForTesting
 */
function scopeShadowCss(shadowRoot, css) {
  var id = (0, _log.devAssert)(shadowRoot.id);
  var doc = shadowRoot.ownerDocument;
  var rules = null;

  // Try to use a separate document.
  try {
    rules = getStylesheetRules(doc.implementation.createHTMLDocument(''), css);
  } catch (e) {// Ignore.
  }

  // Try to use the current document.
  if (!rules) {
    try {
      rules = getStylesheetRules(doc, css);
    } catch (e) {// Ignore.
    }
  }

  // No rules could be parsed - return css as is.
  if (!rules) {
    return css;
  }

  // Patch selectors.
  // Invoke `ShadowCSS.scopeRules` via `call` because the way it uses `this`
  // internally conflicts with Closure compiler's advanced optimizations.
  var scopeRules = _ShadowCSS.ShadowCSS.scopeRules;
  return scopeRules.call(_ShadowCSS.ShadowCSS, rules, "." + id, transformRootSelectors);
}

/**
 * Replaces top-level selectors such as `html` and `body` with their polyfill
 * counterparts: `amp-html` and `amp-body`.
 * @param {string} selector
 * @return {string}
 */
function transformRootSelectors(selector) {
  return selector.replace(/(html|body)/g, rootSelectorPrefixer);
}

/**
 * See `transformRootSelectors`.
 * @param {string} match
 * @param {string} name
 * @param {number} pos
 * @param {string} selector
 * @return {string}
 * @private
 */
function rootSelectorPrefixer(match, name, pos, selector) {
  var prev = selector.charAt(pos - 1);
  var next = selector.charAt(pos + match.length);

  if ((!prev || CSS_SELECTOR_BEG_REGEX.test(prev)) && (!next || CSS_SELECTOR_END_REGEX.test(next))) {
    return 'amp-' + match;
  }

  return match;
}

/**
 * @param {!Document} doc
 * @param {string} css
 * @return {?CSSRuleList}
 */
function getStylesheetRules(doc, css) {
  var style = doc.createElement('style');
  style.
  /*OK*/
  textContent = css;

  try {
    (doc.head || doc.documentElement).appendChild(style);

    if (style.sheet) {
      return style.sheet.cssRules;
    }

    return null;
  } finally {
    if (style.parentNode) {
      style.parentNode.removeChild(style);
    }
  }
}

/**
 * @param {!ShadowRoot} shadowRoot
 * @param {string} name
 * @param {string} cssText
 */
function installShadowStyle(shadowRoot, name, cssText) {
  var doc = shadowRoot.ownerDocument;
  var win = (0, _types.toWin)(doc.defaultView);

  if (shadowRoot.adoptedStyleSheets !== undefined && win.CSSStyleSheet.prototype.replaceSync !== undefined) {
    var cache = win[SHADOW_CSS_CACHE] || (win[SHADOW_CSS_CACHE] = {});
    var styleSheet = cache[name];

    if (!styleSheet) {
      styleSheet = new win.CSSStyleSheet();
      styleSheet.replaceSync(cssText);
      cache[name] = styleSheet;
    }

    shadowRoot.adoptedStyleSheets = shadowRoot.adoptedStyleSheets.concat(styleSheet);
  } else {
    var styleEl = doc.createElement('style');
    styleEl.setAttribute('data-name', name);
    styleEl.textContent = cssText;
    shadowRoot.appendChild(styleEl);
  }
}

/**
 * @param {!Window} win
 * @visibleForTesting
 */
function resetShadowStyleCacheForTesting(win) {
  win[SHADOW_CSS_CACHE] = null;
}

/**
 * @param {boolean|undefined} val
 * @visibleForTesting
 */
function setShadowDomStreamingSupportedForTesting(val) {
  shadowDomStreamingSupported = val;
}

/**
 * Returns `true` if the Shadow DOM streaming is supported.
 * @param {!Window} win
 * @return {boolean}
 */
function isShadowDomStreamingSupported(win) {
  if (shadowDomStreamingSupported === undefined) {
    shadowDomStreamingSupported = calcShadowDomStreamingSupported(win);
  }

  return shadowDomStreamingSupported;
}

/**
 * @param {!Window} win
 * @return {boolean}
 */
function calcShadowDomStreamingSupported(win) {
  // API must be supported.
  if (!win.document.implementation || typeof win.document.implementation.createHTMLDocument != 'function') {
    return false;
  }

  // Firefox does not support DOM streaming.
  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=867102
  if (_services.Services.platformFor(win).isFirefox()) {
    return false;
  }

  // Assume full streaming support.
  return true;
}

/**
 * Creates the Shadow DOM writer available on this platform.
 * @param {!Window} win
 * @return {!./utils/dom-writer.DomWriter}
 */
function createShadowDomWriter(win) {
  if (isShadowDomStreamingSupported(win)) {
    return new _domWriter.DomWriterStreamer(win);
  }

  return new _domWriter.DomWriterBulk(win);
}

},{"../third_party/webcomponentsjs/ShadowCSS":43,"./css":8,"./dom":9,"./log":19,"./services":25,"./style":30,"./style-installer":29,"./types":31,"./utils/dom-writer":35,"./web-components":41}],27:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.htmlFor = htmlFor;
exports.svgFor = svgFor;
exports.htmlRefs = htmlRefs;

var _log = require("./log");

var _object = require("./utils/object.js");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var htmlContainer;
var svgContainer;

/**
 * Creates the html helper for the doc.
 *
 * @param {!Element|!Document} nodeOrDoc
 * @return {function(!Array<string>):!Element}
 */
function htmlFor(nodeOrDoc) {
  var doc = nodeOrDoc.ownerDocument || nodeOrDoc;

  if (!htmlContainer || htmlContainer.ownerDocument !== doc) {
    htmlContainer = doc.createElement('div');
  }

  return html;
}

/**
 * Creates the svg helper for the doc.
 *
 * @param {!Element|!Document} nodeOrDoc
 * @return {function(!Array<string>):!Element}
 */
function svgFor(nodeOrDoc) {
  var doc = nodeOrDoc.ownerDocument || nodeOrDoc;

  if (!svgContainer || svgContainer.ownerDocument !== svgContainer) {
    svgContainer = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
  }

  return svg;
}

/**
 * A tagged template literal helper to generate static SVG trees.
 * This must be used as a tagged template, ie
 *
 * ```
 * const circle = svg`<circle cx="60" cy="60" r="22"></circle>`;
 * ```
 *
 * Only the root element and its subtree will be returned. DO NOT use this to
 * render subtree's with dynamic content, it WILL result in an error!
 *
 * @param {!Array<string>} strings
 * @return {!Element}
 */
function svg(strings) {
  return createNode(svgContainer, strings);
}

/**
 * A tagged template literal helper to generate static DOM trees.
 * This must be used as a tagged template, ie
 *
 * ```
 * const div = html`<div><span></span></div>`;
 * ```
 *
 * Only the root element and its subtree will be returned. DO NOT use this to
 * render subtree's with dynamic content, it WILL result in an error!
 *
 * @param {!Array<string>} strings
 * @return {!Element}
 */
function html(strings) {
  return createNode(htmlContainer, strings);
}

/**
 * Helper used by html and svg string literal functions.
 * @param {!Element} container
 * @param {!Array<string>} strings
 * @return {!Element}
 */
function createNode(container, strings) {
  (0, _log.devAssert)(strings.length === 1, 'Improper html template tag usage.');
  container.
  /*OK*/
  innerHTML = strings[0];
  var el = container.firstElementChild;
  (0, _log.devAssert)(el, 'No elements in template');
  (0, _log.devAssert)(!el.nextElementSibling, 'Too many root elements in template');
  // Clear to free memory.
  container.removeChild(el);
  return el;
}

/**
 * Queries an element for all elements with a "ref" attribute, removing
 * the attribute afterwards.
 * Returns a named map of all ref elements.
 *
 * @param {!Element} root
 * @return {!Object<string, !Element>}
 */
function htmlRefs(root) {
  var elements = root.querySelectorAll('[ref]');
  var refs = (0, _object.map)();

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];
    var ref = (0, _log.devAssert)(element.getAttribute('ref'), 'Empty ref attr');
    element.removeAttribute('ref');
    (0, _log.devAssert)(refs[ref] === undefined, 'Duplicate ref');
    refs[ref] = element;
  }

  return refs;
}

},{"./log":19,"./utils/object.js":39}],28:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.dashToCamelCase = dashToCamelCase;
exports.camelCaseToDash = camelCaseToDash;
exports.dashToUnderline = dashToUnderline;
exports.endsWith = endsWith;
exports.includes = includes;
exports.expandTemplate = expandTemplate;
exports.stringHash32 = stringHash32;
exports.trimEnd = trimEnd;
exports.trimStart = trimStart;
exports.asyncStringReplace = asyncStringReplace;
exports.padStart = padStart;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param {string} _match
 * @param {string} character
 * @return {string}
 */
function toUpperCase(_match, character) {
  return character.toUpperCase();
}

/**
 * @param {string} match
 * @return {string}
 */
function prependDashAndToLowerCase(match) {
  return '-' + match.toLowerCase();
}

/**
 * @param {string} name Attribute name containing dashes.
 * @return {string} Dashes removed and successive character sent to upper case.
 * visibleForTesting
 */
function dashToCamelCase(name) {
  return name.replace(/-([a-z])/g, toUpperCase);
}

/**
 * Converts a string that is in camelCase to one that is in dash-case.
 *
 * @param {string} string The string to convert.
 * @return {string} The string in dash-case.
 */
function camelCaseToDash(string) {
  return string.replace(/(?!^)[A-Z]/g, prependDashAndToLowerCase);
}

/**
 * @param {string} name Attribute name with dashes
 * @return {string} Dashes replaced by underlines.
 */
function dashToUnderline(name) {
  return name.replace('-', '_');
}

/**
 * Polyfill for String.prototype.endsWith.
 * @param {string} string
 * @param {string} suffix
 * @return {boolean}
 */
function endsWith(string, suffix) {
  var index = string.length - suffix.length;
  return index >= 0 && string.indexOf(suffix, index) == index;
}

/**
 * Polyfill for String.prototype.includes.
 * @param {string} string
 * @param {string} substring
 * @param {number=} start
 * @return {boolean}
 */
function includes(string, substring, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + substring.length > string.length) {
    return false;
  }

  return string.indexOf(substring, start) !== -1;
}

/**
 * Expands placeholders in a given template string with values.
 *
 * Placeholders use ${key-name} syntax and are replaced with the value
 * returned from the given getter function.
 *
 * @param {string} template The template string to expand.
 * @param {function(string):*} getter Function used to retrieve a value for a
 *   placeholder. Returns values will be coerced into strings.
 * @param {number=} opt_maxIterations Number of times to expand the template.
 *   Defaults to 1, but should be set to a larger value your placeholder tokens
 *   can be expanded to other placeholder tokens. Take caution with large values
 *   as recursively expanding a string can be exponentially expensive.
 * @return {string}
 */
function expandTemplate(template, getter, opt_maxIterations) {
  var maxIterations = opt_maxIterations || 1;

  var _loop = function _loop(i) {
    var matches = 0;
    template = template.replace(/\${([^}]*)}/g, function (_a, b) {
      matches++;
      return getter(b);
    });

    if (!matches) {
      return "break";
    }
  };

  for (var i = 0; i < maxIterations; i++) {
    var _ret = _loop(i);

    if (_ret === "break") break;
  }

  return template;
}

/**
 * Hash function djb2a
 * This is intended to be a simple, fast hashing function using minimal code.
 * It does *not* have good cryptographic properties.
 * @param {string} str
 * @return {string} 32-bit unsigned hash of the string
 */
function stringHash32(str) {
  var length = str.length;
  var hash = 5381;

  for (var i = 0; i < length; i++) {
    hash = hash * 33 ^ str.charCodeAt(i);
  }

  // Convert from 32-bit signed to unsigned.
  return String(hash >>> 0);
}

/**
 * Trims a string on the end, removing whitespace characters.
 * @param {string} str  A string to trim.
 * @return {string} The string, with trailing whitespace removed.
 */
function trimEnd(str) {
  // TODO(sparhami) Does this get inlined for an ES2019 build?
  if (str.trimEnd) {
    return str.trimEnd();
  }

  return ('_' + str).trim().slice(1);
}

/**
 * Trims any leading whitespace from a string.
 * @param {string} str  A string to trim.
 * @return {string} The string, with leading whitespace removed.
 */
function trimStart(str) {
  if (str.trimStart) {
    return str.trimStart();
  }

  return (str + '_').trim().slice(0, -1);
}

/**
 * Wrapper around String.replace that handles asynchronous resolution.
 * @param {string} str
 * @param {RegExp} regex
 * @param {Function|string} replacer
 * @return {!Promise<string>}
 */
function asyncStringReplace(str, regex, replacer) {
  if (typeof replacer === 'string') {
    return Promise.resolve(str.replace(regex, replacer));
  }

  var stringBuilder = [];
  var lastIndex = 0;
  str.replace(regex, function (match) {
    // String.prototype.replace will pass 3 to n number of arguments to the
    // callback function based on how many capture groups the regex may or may
    // not contain. We know that the match will always be first, and the
    // index will always be second to last.
    var matchIndex = arguments[arguments.length - 2];
    stringBuilder.push(str.slice(lastIndex, matchIndex));
    lastIndex = matchIndex + match.length;
    // Store the promise in it's eventual string position.
    var replacementPromise = replacer.apply(null, arguments);
    stringBuilder.push(replacementPromise);
  });
  stringBuilder.push(str.slice(lastIndex));
  return Promise.all(stringBuilder).then(function (resolved) {
    return resolved.join('');
  });
}

/**
 * Pads the beginning of a string with a substring to a target length.
 * @param {string} s
 * @param {number} targetLength
 * @param {string} padString
 * @return {string}
 */
function padStart(s, targetLength, padString) {
  if (s.length >= targetLength) {
    return s;
  }

  targetLength = targetLength - s.length;
  var padding = padString;

  while (targetLength > padding.length) {
    padding += padString;
  }

  return padding.slice(0, targetLength) + s;
}

},{}],29:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.installStylesForDoc = installStylesForDoc;
exports.installCssTransformer = installCssTransformer;
exports.setBodyMadeVisibleForTesting = setBodyMadeVisibleForTesting;
exports.makeBodyVisible = makeBodyVisible;
exports.makeBodyVisibleRecovery = makeBodyVisibleRecovery;
exports.bodyAlwaysVisible = bodyAlwaysVisible;

var _commonSignals = require("./common-signals");

var _services = require("./services");

var _enums = require("./enums");

var _log = require("./log");

var _service = require("./service");

var _dom = require("./dom");

var _object = require("./utils/object");

var _style = require("./style");

var _renderDelayingServices = require("./render-delaying-services");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TRANSFORMER_PROP = '__AMP_CSS_TR';
var STYLE_MAP_PROP = '__AMP_CSS_SM';

/**
 * Adds the given css text to the given ampdoc.
 *
 * The style tags will be at the beginning of the head before all author
 * styles. One element can be the main runtime CSS. This is guaranteed
 * to always be the first stylesheet in the doc.
 *
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc The ampdoc that should get the new styles.
 * @param {string} cssText
 * @param {?function(!Element)|undefined} cb Called when the new styles are available.
 *     Not using a promise, because this is synchronous when possible.
 *     for better performance.
 * @param {boolean=} opt_isRuntimeCss If true, this style tag will be inserted
 *     as the first element in head and all style elements will be positioned
 *     after.
 * @param {string=} opt_ext
 * @return {!Element}
 */
function installStylesForDoc(ampdoc, cssText, cb, opt_isRuntimeCss, opt_ext) {
  var cssRoot = ampdoc.getHeadNode();
  var style = insertStyleElement(cssRoot, maybeTransform(cssRoot, cssText), opt_isRuntimeCss || false, opt_ext || null);

  if (cb) {
    var rootNode = ampdoc.getRootNode();

    // Styles aren't always available synchronously. E.g. if there is a
    // pending style download, it will have to finish before the new
    // style is visible.
    // For this reason we poll until the style becomes available.
    // Sync case.
    if (styleLoaded(rootNode, style)) {
      cb(style);
      return style;
    }

    // Poll until styles are available.
    var interval = setInterval(function () {
      if (styleLoaded(rootNode, style)) {
        clearInterval(interval);
        cb(style);
      }
    }, 4);
  }

  return style;
}

/**
 * Creates the properly configured style element.
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {string} cssText
 * @param {boolean} isRuntimeCss
 * @param {?string} ext
 * @return {!Element}
 */
function insertStyleElement(cssRoot, cssText, isRuntimeCss, ext) {
  var styleMap = cssRoot[STYLE_MAP_PROP];

  if (!styleMap) {
    styleMap = cssRoot[STYLE_MAP_PROP] = (0, _object.map)();
  }

  var isExtCss = !isRuntimeCss && ext && ext != 'amp-custom' && ext != 'amp-keyframes';
  var key = isRuntimeCss ? 'amp-runtime' : isExtCss ? "amp-extension=" + ext : null;

  // Check if it has already been created or discovered.
  if (key) {
    var existing = getExistingStyleElement(cssRoot, styleMap, key);

    if (existing) {
      if (existing.textContent !== cssText) {
        existing.textContent = cssText;
      }

      return existing;
    }
  }

  // Create the new style element and append to cssRoot.
  var doc = cssRoot.ownerDocument || cssRoot;
  var style = doc.createElement('style');
  style.
  /*OK*/
  textContent = cssText;
  var afterElement = null;

  // Make sure that we place style tags after the main runtime CSS. Otherwise
  // the order is random.
  if (isRuntimeCss) {
    style.setAttribute('amp-runtime', '');
  } else if (isExtCss) {
    style.setAttribute('amp-extension', ext || '');
    afterElement = (0, _log.dev)().assertElement(getExistingStyleElement(cssRoot, styleMap, 'amp-runtime'));
  } else {
    if (ext) {
      style.setAttribute(ext, '');
    }

    afterElement = cssRoot.lastChild;
  }

  (0, _dom.insertAfterOrAtStart)(cssRoot, style, afterElement);

  if (key) {
    styleMap[key] = style;
  }

  return style;
}

/**
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {!Object<string, !Element>} styleMap
 * @param {string} key
 * @return {?Element}
 */
function getExistingStyleElement(cssRoot, styleMap, key) {
  // Already cached.
  if (styleMap[key]) {
    return styleMap[key];
  }

  // Check if the style has already been added by the server layout.
  var existing = cssRoot.
  /*OK*/
  querySelector("style[" + key + "]");

  if (existing) {
    styleMap[key] = existing;
    return existing;
  }

  // Nothing found.
  return null;
}

/**
 * Applies a transformer to the CSS text if it has been registered.
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {function(string):string} transformer
 */
function installCssTransformer(cssRoot, transformer) {
  cssRoot[TRANSFORMER_PROP] = transformer;
}

/**
 * Applies a transformer to the CSS text if it has been registered.
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {string} cssText
 * @return {string}
 */
function maybeTransform(cssRoot, cssText) {
  var transformer = cssRoot[TRANSFORMER_PROP];
  return transformer ? transformer(cssText) : cssText;
}

/** @private {boolean} */
var bodyMadeVisible = false;

/**
 * @param {boolean} value
 * @visibleForTesting
 */
function setBodyMadeVisibleForTesting(value) {
  bodyMadeVisible = value;
}

/**
 * Sets the document's body opacity to 1.
 * If the body is not yet available (because our script was loaded
 * synchronously), polls until it is.
 * @param {!Document} doc The document who's body we should make visible.
 */
function makeBodyVisible(doc) {
  (0, _log.devAssert)(doc.defaultView, 'Passed in document must have a defaultView');
  var win =
  /** @type {!Window} */
  doc.defaultView;
  (0, _dom.waitForBodyOpenPromise)(doc).then(function () {
    return (0, _renderDelayingServices.waitForServices)(win);
  }).catch(function (reason) {
    (0, _log.rethrowAsync)(reason);
    return [];
  }).then(function (services) {
    bodyMadeVisible = true;
    setBodyVisibleStyles(doc);
    var ampdoc = (0, _service.getAmpdoc)(doc);
    ampdoc.signals().signal(_commonSignals.CommonSignals.RENDER_START);

    if (services.length > 0) {
      var resources = _services.Services.resourcesForDoc(doc.documentElement);

      resources.
      /*OK*/
      schedulePass(1,
      /* relayoutAll */
      true);
    }

    try {
      var perf = _services.Services.performanceFor(win);

      perf.tick(_enums.TickLabel.MAKE_BODY_VISIBLE);
      perf.flush();
    } catch (e) {}
  });
}

/**
 * Set the document's body opacity to 1. Called in error cases.
 * @param {!Document} doc The document who's body we should make visible.
 */
function makeBodyVisibleRecovery(doc) {
  (0, _log.devAssert)(doc.defaultView, 'Passed in document must have a defaultView');

  if (bodyMadeVisible) {
    return;
  }

  bodyMadeVisible = true;
  setBodyVisibleStyles(doc);
}

/**
 * Make sure that body exists, and make it visible.
 * @param {!Document} doc
 */
function setBodyVisibleStyles(doc) {
  (0, _style.setStyles)((0, _log.dev)().assertElement(doc.body), {
    opacity: 1,
    visibility: 'visible',
    'animation': 'none'
  });
}

/**
 * Indicates that the body is always visible. For instance, in case of PWA.
 * This check is on a module level variable, and could be problematic if you are
 * relying on this function across different binaries.
 * @param {!Window} unusedWin
 */
function bodyAlwaysVisible(unusedWin) {
  bodyMadeVisible = true;
}

/**
 * Checks whether a style element was registered in the DOM.
 * @param {!Document|!ShadowRoot} doc
 * @param {!Element} style
 * @return {boolean}
 */
function styleLoaded(doc, style) {
  var sheets = doc.styleSheets;

  for (var i = 0; i < sheets.length; i++) {
    var sheet = sheets[i];

    if (sheet.ownerNode == style) {
      return true;
    }
  }

  return false;
}

},{"./common-signals":6,"./dom":9,"./enums":11,"./log":19,"./render-delaying-services":22,"./service":24,"./services":25,"./style":30,"./utils/object":39}],30:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.camelCaseToTitleCase = camelCaseToTitleCase;
exports.getVendorJsPropertyName = getVendorJsPropertyName;
exports.setImportantStyles = setImportantStyles;
exports.setStyle = setStyle;
exports.getStyle = getStyle;
exports.setStyles = setStyles;
exports.assertNotDisplay = assertNotDisplay;
exports.assertDoesNotContainDisplay = assertDoesNotContainDisplay;
exports.setInitialDisplay = setInitialDisplay;
exports.toggle = toggle;
exports.px = px;
exports.deg = deg;
exports.translateX = translateX;
exports.translate = translate;
exports.scale = scale;
exports.rotate = rotate;
exports.removeAlphaFromColor = removeAlphaFromColor;
exports.computedStyle = computedStyle;
exports.resetStyles = resetStyles;
exports.propagateObjectFitStyles = propagateObjectFitStyles;

var _log = require("./log");

var _object = require("./utils/object.js");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Note: loaded by 3p system. Cannot rely on babel polyfills.

/** @type {Object<string, string>} */
var propertyNameCache;

/** @const {!Array<string>} */
var vendorPrefixes = ['Webkit', 'webkit', 'Moz', 'moz', 'ms', 'O', 'o'];

/**
 * @export
 * @param {string} camelCase camel cased string
 * @return {string} title cased string
 */
function camelCaseToTitleCase(camelCase) {
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
}

/**
  Checks the style if a prefixed version of a property exists and returns
 * it or returns an empty string.
 * @private
 * @param {!Object} style
 * @param {string} titleCase the title case version of a css property name
 * @return {string} the prefixed property name or null.
 */
function getVendorJsPropertyName_(style, titleCase) {
  for (var i = 0; i < vendorPrefixes.length; i++) {
    var propertyName = vendorPrefixes[i] + titleCase;

    if (style[propertyName] !== undefined) {
      return propertyName;
    }
  }

  return '';
}

/**
 * Returns the possibly prefixed JavaScript property name of a style property
 * (ex. WebkitTransitionDuration) given a camelCase'd version of the property
 * (ex. transitionDuration).
 * @export
 * @param {!Object} style
 * @param {string} camelCase the camel cased version of a css property name
 * @param {boolean=} opt_bypassCache bypass the memoized cache of property
 *   mapping
 * @return {string}
 */
function getVendorJsPropertyName(style, camelCase, opt_bypassCache) {
  if (isVar(camelCase)) {
    // CSS vars are returned as is.
    return camelCase;
  }

  if (!propertyNameCache) {
    propertyNameCache = (0, _object.map)();
  }

  var propertyName = propertyNameCache[camelCase];

  if (!propertyName || opt_bypassCache) {
    propertyName = camelCase;

    if (style[camelCase] === undefined) {
      var titleCase = camelCaseToTitleCase(camelCase);
      var prefixedPropertyName = getVendorJsPropertyName_(style, titleCase);

      if (style[prefixedPropertyName] !== undefined) {
        propertyName = prefixedPropertyName;
      }
    }

    if (!opt_bypassCache) {
      propertyNameCache[camelCase] = propertyName;
    }
  }

  return propertyName;
}

/**
 * Sets the CSS styles of the specified element with !important. The styles
 * are specified as a map from CSS property names to their values.
 * @param {!Element} element
 * @param {!Object<string, *>} styles
 */
function setImportantStyles(element, styles) {
  var style = element.style;

  for (var k in styles) {
    style.setProperty(getVendorJsPropertyName(style, k), styles[k].toString(), 'important');
  }
}

/**
 * Sets the CSS style of the specified element with optional units, e.g. "px".
 * @param {?Element} element
 * @param {string} property
 * @param {*} value
 * @param {string=} opt_units
 * @param {boolean=} opt_bypassCache
 */
function setStyle(element, property, value, opt_units, opt_bypassCache) {
  var propertyName = getVendorJsPropertyName(element.style, property, opt_bypassCache);

  if (!propertyName) {
    return;
  }

  var styleValue =
  /** @type {string} */
  opt_units ? value + opt_units : value;

  if (isVar(propertyName)) {
    element.style.setProperty(propertyName, styleValue);
  } else {
    element.style[propertyName] = styleValue;
  }
}

/**
 * Returns the value of the CSS style of the specified element.
 * @param {!Element} element
 * @param {string} property
 * @param {boolean=} opt_bypassCache
 * @return {*}
 */
function getStyle(element, property, opt_bypassCache) {
  var propertyName = getVendorJsPropertyName(element.style, property, opt_bypassCache);

  if (!propertyName) {
    return undefined;
  }

  if (isVar(propertyName)) {
    return element.style.getPropertyValue(propertyName);
  }

  return element.style[propertyName];
}

/**
 * Sets the CSS styles of the specified element. The styles
 * a specified as a map from CSS property names to their values.
 * @param {!Element} element
 * @param {!Object<string, *>} styles
 */
function setStyles(element, styles) {
  for (var k in styles) {
    setStyle(element, k, styles[k]);
  }
}

/**
 * Asserts that the style is not the `display` style.
 * This is the only possible way to pass a dynamic style to setStyle.
 *
 * If you wish to set `display`, use the `toggle` helper instead. This is so
 * changes to display can trigger necessary updates. See #17475.
 *
 * @param {string} style
 * @return {string}
 */
function assertNotDisplay(style) {
  if (style === 'display') {
    (0, _log.dev)().error('STYLE', '`display` style detected. You must use toggle instead.');
  }

  return style;
}

/**
 * Asserts that the styles does not contain the `display` style.
 * This is the only possible way to pass a dynamic styles object to setStyles
 * and setImportantStyles.
 *
 * If you wish to set `display`, use the `toggle` helper instead. This is so
 * changes to display can trigger necessary updates. See #17475.
 *
 * @param {!Object<string, *>} styles
 * @return {!Object<string, *>}
 */
function assertDoesNotContainDisplay(styles) {
  if ('display' in styles) {
    (0, _log.dev)().error('STYLE', '`display` style detected in styles. You must use toggle instead.');
  }

  return styles;
}

/**
 * Sets the initial display style of an element. This is a last resort. If you
 * can set the initial display using CSS, YOU MUST.
 * DO NOT USE THIS TO ARBITRARILY SET THE DISPLAY STYLE AFTER INITIAL SETUP.
 *
 * @param {!Element} el
 * @param {string} value
 */
function setInitialDisplay(el, value) {
  var style = el.style;
  (0, _log.devAssert)(value !== '' && value !== 'none', 'Initial display value must not be "none". Use toggle instead.');
  (0, _log.devAssert)(!style['display'], 'setInitialDisplay MUST NOT be used for ' + 'resetting the display style. If you are looking for display:none ' + 'toggling, use toggle instead.');
  style['display'] = value;
}

/**
 * Shows or hides the specified element.
 * @param {!Element} element
 * @param {boolean=} opt_display
 */
function toggle(element, opt_display) {
  if (opt_display === undefined) {
    opt_display = element.hasAttribute('hidden');
  }

  if (opt_display) {
    element.removeAttribute('hidden');
  } else {
    element.setAttribute('hidden', '');
  }
}

/**
 * Returns a pixel value.
 * @param {number} value
 * @return {string}
 */
function px(value) {
  return value + "px";
}

/**
 * Returns a degree value.
 * @param {number} value
 * @return {string}
 */
function deg(value) {
  return value + "deg";
}

/**
 * Returns a "translateX" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function translateX(value) {
  if (typeof value == 'string') {
    return "translateX(" + value + ")";
  }

  return "translateX(" + px(value) + ")";
}

/**
 * Returns a "translateX" for CSS "transform" property.
 * @param {number|string} x
 * @param {(number|string)=} opt_y
 * @return {string}
 */
function translate(x, opt_y) {
  if (typeof x == 'number') {
    x = px(x);
  }

  if (opt_y === undefined) {
    return "translate(" + x + ")";
  }

  if (typeof opt_y == 'number') {
    opt_y = px(opt_y);
  }

  return "translate(" + x + ", " + opt_y + ")";
}

/**
 * Returns a "scale" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function scale(value) {
  return "scale(" + value + ")";
}

/**
 * Returns a "rotate" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function rotate(value) {
  if (typeof value == 'number') {
    value = deg(value);
  }

  return "rotate(" + value + ")";
}

/**
 * Remove alpha value from a rgba color value.
 * Return the new color property with alpha equals if has the alpha value.
 * Caller needs to make sure the input color value is a valid rgba/rgb value
 * @param {string} rgbaColor
 * @return {string}
 */
function removeAlphaFromColor(rgbaColor) {
  return rgbaColor.replace(/\(([^,]+),([^,]+),([^,)]+),[^)]+\)/g, '($1,$2,$3, 1)');
}

/**
 * Gets the computed style of the element. The helper is necessary to enforce
 * the possible `null` value returned by a buggy Firefox.
 *
 * @param {!Window} win
 * @param {!Element} el
 * @return {!Object<string, string>}
 */
function computedStyle(win, el) {
  var style =
  /** @type {?CSSStyleDeclaration} */
  win.getComputedStyle(el);
  return (
    /** @type {!Object<string, string>} */
    style || (0, _object.map)()
  );
}

/**
 * Resets styles that were set dynamically (i.e. inline)
 * @param {!Element} element
 * @param {!Array<string>} properties
 */
function resetStyles(element, properties) {
  for (var i = 0; i < properties.length; i++) {
    setStyle(element, properties[i], null);
  }
}

/**
 * Propagates the object-fit/position element attributes as styles.
 * @param {!Element} fromEl ie: amp-img
 * @param {!Element} toEl ie: the img within amp-img
 */
function propagateObjectFitStyles(fromEl, toEl) {
  if (fromEl.hasAttribute('object-fit')) {
    setStyle(toEl, 'object-fit', fromEl.getAttribute('object-fit'));
  }

  if (fromEl.hasAttribute('object-position')) {
    setStyle(toEl, 'object-position', fromEl.getAttribute('object-position'));
  }
}

/**
 * @param {string} property
 * @return {boolean}
 */
function isVar(property) {
  return property.startsWith('--');
}

},{"./log":19,"./utils/object.js":39}],31:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isArray = isArray;
exports.toArray = toArray;
exports.arrayOrSingleItemToArray = arrayOrSingleItemToArray;
exports.isObject = isObject;
exports.isFiniteNumber = isFiniteNumber;
exports.isEnumValue = isEnumValue;
exports.toWin = toWin;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @const */
var toString_ = Object.prototype.toString;

/**
 * Returns the ECMA [[Class]] of a value
 * @param {*} value
 * @return {string}
 */
function toString(value) {
  return toString_.call(value);
}

/**
 * Determines if value is actually an Array.
 * @param {*} value
 * @return {boolean}
 */
function isArray(value) {
  return Array.isArray(value);
}

/**
 * Converts an array-like object to an array.
 * @param {?IArrayLike<T>|string} arrayLike
 * @return {!Array<T>}
 * @template T
 */
function toArray(arrayLike) {
  return arrayLike ? Array.prototype.slice.call(arrayLike) : [];
}

/**
 * If the specified argument is an array, it's returned as is. If it's a
 * single item, the array containing this item is created and returned.
 * @param {!Array<T>|T} arrayOrSingleItem
 * @return {!Array<T>}
 * @template T
 */
function arrayOrSingleItemToArray(arrayOrSingleItem) {
  return isArray(arrayOrSingleItem) ?
  /** @type {!Array<T>} */
  arrayOrSingleItem : [arrayOrSingleItem];
}

/**
 * Determines if value is actually an Object.
 * @param {*} value
 * @return {boolean}
 */
function isObject(value) {
  return toString(value) === '[object Object]';
}

/**
 * Determines if value is of number type and finite.
 * NaN and Infinity are not considered a finite number.
 * String numbers are not considered numbers.
 * @param {*} value
 * @return {boolean}
 */
function isFiniteNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Checks whether `s` is a valid value of `enumObj`.
 *
 * @param {!Object<T>} enumObj
 * @param {T} s
 * @return {boolean}
 * @template T
 */
function isEnumValue(enumObj, s) {
  for (var k in enumObj) {
    if (enumObj[k] === s) {
      return true;
    }
  }

  return false;
}

/**
 * Externs declare that access `defaultView` from `document` or
 * `ownerDocument` is of type `(Window|null)` but most of our parameter types
 * assume that it is never null. This is OK in practice as we ever only get
 * null on disconnected documents or old IE.
 * This helper function casts it into just a simple Window return type.
 *
 * @param {!Window|null} winOrNull
 * @return {!Window}
 */
function toWin(winOrNull) {
  return (
    /** @type {!Window} */
    winOrNull
  );
}

},{}],32:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseQueryString_ = parseQueryString_;

var _urlTryDecodeUriComponent = require("./url-try-decode-uri-component");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var regex = /(?:^[#?]?|&)([^=&]+)(?:=([^&]*))?/g;

/**
 * Parses the query string of an URL. This method returns a simple key/value
 * map. If there are duplicate keys the latest value is returned.
 *
 * DO NOT import the function from this file. Instead, import parseQueryString
 * from `src/url.js`.
 *
 * @param {string} queryString
 * @return {!JsonObject}
 */
function parseQueryString_(queryString) {
  var params =
  /** @type {!JsonObject} */
  Object.create(null);

  if (!queryString) {
    return params;
  }

  var match;

  while (match = regex.exec(queryString)) {
    var name = (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(match[1], match[1]);
    var value = match[2] ? (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(match[2].replace(/\+/g, ' '), match[2]) : '';
    params[name] = value;
  }

  return params;
}

},{"./url-try-decode-uri-component":33}],33:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.tryDecodeUriComponent_ = tryDecodeUriComponent_;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Tries to decode a URI component, falling back to opt_fallback (or an empty
 * string)
 *
 * DO NOT import the function from this file. Instead, import
 * tryDecodeUriComponent from `src/url.js`.
 *
 * @param {string} component
 * @param {string=} fallback
 * @return {string}
 */
function tryDecodeUriComponent_(component, fallback) {
  if (fallback === void 0) {
    fallback = '';
  }

  try {
    return decodeURIComponent(component);
  } catch (e) {
    return fallback;
  }
}

},{}],34:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getWinOrigin = getWinOrigin;
exports.parseUrlDeprecated = parseUrlDeprecated;
exports.parseUrlWithA = parseUrlWithA;
exports.appendEncodedParamStringToUrl = appendEncodedParamStringToUrl;
exports.addParamToUrl = addParamToUrl;
exports.addParamsToUrl = addParamsToUrl;
exports.addMissingParamsToUrl = addMissingParamsToUrl;
exports.serializeQueryString = serializeQueryString;
exports.isSecureUrlDeprecated = isSecureUrlDeprecated;
exports.assertHttpsUrl = assertHttpsUrl;
exports.assertAbsoluteHttpOrHttpsUrl = assertAbsoluteHttpOrHttpsUrl;
exports.parseQueryString = parseQueryString;
exports.removeFragment = removeFragment;
exports.getFragment = getFragment;
exports.isProxyOrigin = isProxyOrigin;
exports.getProxyServingType = getProxyServingType;
exports.isLocalhostOrigin = isLocalhostOrigin;
exports.isProtocolValid = isProtocolValid;
exports.removeAmpJsParamsFromUrl = removeAmpJsParamsFromUrl;
exports.removeSearch = removeSearch;
exports.removeParamsFromSearch = removeParamsFromSearch;
exports.getSourceUrl = getSourceUrl;
exports.getSourceOrigin = getSourceOrigin;
exports.resolveRelativeUrl = resolveRelativeUrl;
exports.resolveRelativeUrlFallback_ = resolveRelativeUrlFallback_;
exports.getCorsUrl = getCorsUrl;
exports.checkCorsUrl = checkCorsUrl;
exports.tryDecodeUriComponent = tryDecodeUriComponent;
exports.appendPathToUrl = appendPathToUrl;
exports.SOURCE_ORIGIN_PARAM = void 0;

var _lruCache = require("./utils/lru-cache");

var _object = require("./utils/object");

var _string = require("./string");

var _mode = require("./mode");

var _types = require("./types");

var _urlParseQueryString = require("./url-parse-query-string");

var _urlTryDecodeUriComponent = require("./url-try-decode-uri-component");

var _config = require("./config");

var _log = require("./log");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @type {!JsonObject}
 */
var SERVING_TYPE_PREFIX = (0, _object.dict)({
  // No viewer
  'c': true,
  // In viewer
  'v': true,
  // Ad landing page
  'a': true,
  // Ad
  'ad': true
});

/**
 * Cached a-tag to avoid memory allocation during URL parsing.
 * @type {HTMLAnchorElement}
 */
var a;

/**
 * We cached all parsed URLs. As of now there are no use cases
 * of AMP docs that would ever parse an actual large number of URLs,
 * but we often parse the same one over and over again.
 * @type {LruCache}
 */
var cache;

/** @private @const Matches amp_js_* parameters in query string. */
var AMP_JS_PARAMS_REGEX = /[?&]amp_js[^&]*/;

/** @private @const Matches amp_gsa parameters in query string. */
var AMP_GSA_PARAMS_REGEX = /[?&]amp_gsa[^&]*/;

/** @private @const Matches amp_r parameters in query string. */
var AMP_R_PARAMS_REGEX = /[?&]amp_r[^&]*/;

/** @private @const Matches amp_kit parameters in query string. */
var AMP_KIT_PARAMS_REGEX = /[?&]amp_kit[^&]*/;

/** @private @const Matches usqp parameters from goog experiment in query string. */
var GOOGLE_EXPERIMENT_PARAMS_REGEX = /[?&]usqp[^&]*/;
var INVALID_PROTOCOLS = [
/*eslint no-script-url: 0*/
'javascript:',
/*eslint no-script-url: 0*/
'data:',
/*eslint no-script-url: 0*/
'vbscript:'];

/** @const {string} */
var SOURCE_ORIGIN_PARAM = '__amp_source_origin';
exports.SOURCE_ORIGIN_PARAM = SOURCE_ORIGIN_PARAM;

/**
 * Returns the correct origin for a given window.
 * @param {!Window} win
 * @return {string} origin
 */
function getWinOrigin(win) {
  return win.origin || parseUrlDeprecated(win.location.href).origin;
}

/**
 * Returns a Location-like object for the given URL. If it is relative,
 * the URL gets resolved.
 * Consider the returned object immutable. This is enforced during
 * testing by freezing the object.
 * @param {string} url
 * @param {boolean=} opt_nocache
 * @return {!Location}
 */
function parseUrlDeprecated(url, opt_nocache) {
  if (!a) {
    a =
    /** @type {!HTMLAnchorElement} */
    self.document.createElement('a');
    cache = self.__AMP_URL_CACHE || (self.__AMP_URL_CACHE = new _lruCache.LruCache(100));
  }

  return parseUrlWithA(a, url, opt_nocache ? null : cache);
}

/**
 * Returns a Location-like object for the given URL. If it is relative,
 * the URL gets resolved.
 * Consider the returned object immutable. This is enforced during
 * testing by freezing the object.
 * @param {!HTMLAnchorElement} a
 * @param {string} url
 * @param {LruCache=} opt_cache
 * @return {!Location}
 * @restricted
 */
function parseUrlWithA(a, url, opt_cache) {
  if (opt_cache && opt_cache.has(url)) {
    return opt_cache.get(url);
  }

  a.href = url;

  // IE11 doesn't provide full URL components when parsing relative URLs.
  // Assigning to itself again does the trick #3449.
  if (!a.protocol) {
    a.href = a.href;
  }

  var info =
  /** @type {!Location} */
  {
    href: a.href,
    protocol: a.protocol,
    host: a.host,
    hostname: a.hostname,
    port: a.port == '0' ? '' : a.port,
    pathname: a.pathname,
    search: a.search,
    hash: a.hash,
    origin: null // Set below.

  };

  // Some IE11 specific polyfills.
  // 1) IE11 strips out the leading '/' in the pathname.
  if (info.pathname[0] !== '/') {
    info.pathname = '/' + info.pathname;
  }

  // 2) For URLs with implicit ports, IE11 parses to default ports while
  // other browsers leave the port field empty.
  if (info.protocol == 'http:' && info.port == 80 || info.protocol == 'https:' && info.port == 443) {
    info.port = '';
    info.host = info.hostname;
  }

  // For data URI a.origin is equal to the string 'null' which is not useful.
  // We instead return the actual origin which is the full URL.
  var origin;

  if (a.origin && a.origin != 'null') {
    origin = a.origin;
  } else if (info.protocol == 'data:' || !info.host) {
    origin = info.href;
  } else {
    origin = info.protocol + '//' + info.host;
  }

  info.origin = origin;
  // Freeze during testing to avoid accidental mutation.
  var frozen = (0, _mode.getMode)().test && Object.freeze ? Object.freeze(info) : info;

  if (opt_cache) {
    opt_cache.put(url, frozen);
  }

  return frozen;
}

/**
 * Appends the string just before the fragment part (or optionally
 * to the front of the query string) of the URL.
 * @param {string} url
 * @param {string} paramString
 * @param {boolean=} opt_addToFront
 * @return {string}
 */
function appendEncodedParamStringToUrl(url, paramString, opt_addToFront) {
  if (!paramString) {
    return url;
  }

  var mainAndFragment = url.split('#', 2);
  var mainAndQuery = mainAndFragment[0].split('?', 2);
  var newUrl = mainAndQuery[0] + (mainAndQuery[1] ? opt_addToFront ? "?" + paramString + "&" + mainAndQuery[1] : "?" + mainAndQuery[1] + "&" + paramString : "?" + paramString);
  newUrl += mainAndFragment[1] ? "#" + mainAndFragment[1] : '';
  return newUrl;
}

/**
 * Appends a query string field and value to a url. `key` and `value`
 * will be ran through `encodeURIComponent` before appending.
 * @param {string} url
 * @param {string} key
 * @param {string} value
 * @param {boolean=} opt_addToFront
 * @return {string}
 */
function addParamToUrl(url, key, value, opt_addToFront) {
  var field = encodeURIComponent(key) + "=" + encodeURIComponent(value);
  return appendEncodedParamStringToUrl(url, field, opt_addToFront);
}

/**
 * Appends query string fields and values to a url. The `params` objects'
 * `key`s and `value`s will be transformed into query string keys/values.
 * @param {string} url
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function addParamsToUrl(url, params) {
  return appendEncodedParamStringToUrl(url, serializeQueryString(params));
}

/**
 * Append query string fields and values to a url, only if the key does not
 * exist in current query string.
 * @param {string} url
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function addMissingParamsToUrl(url, params) {
  var location = parseUrlDeprecated(url);
  var existingParams = parseQueryString(location.search);
  var paramsToAdd = (0, _object.dict)({});
  var keys = Object.keys(params);

  for (var i = 0; i < keys.length; i++) {
    if (!(0, _object.hasOwn)(existingParams, keys[i])) {
      paramsToAdd[keys[i]] = params[keys[i]];
    }
  }

  return addParamsToUrl(url, paramsToAdd);
}

/**
 * Serializes the passed parameter map into a query string with both keys
 * and values encoded.
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function serializeQueryString(params) {
  var s = [];

  for (var k in params) {
    var v = params[k];

    if (v == null) {
      continue;
    } else if ((0, _types.isArray)(v)) {
      for (var i = 0; i < v.length; i++) {
        var sv =
        /** @type {string} */
        v[i];
        s.push(encodeURIComponent(k) + "=" + encodeURIComponent(sv));
      }
    } else {
      var _sv =
      /** @type {string} */
      v;
      s.push(encodeURIComponent(k) + "=" + encodeURIComponent(_sv));
    }
  }

  return s.join('&');
}

/**
 * Returns `true` if the URL is secure: either HTTPS or localhost (for testing).
 * @param {string|!Location} url
 * @return {boolean}
 */
function isSecureUrlDeprecated(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return url.protocol == 'https:' || url.hostname == 'localhost' || url.hostname == '127.0.0.1' || (0, _string.endsWith)(url.hostname, '.localhost');
}

/**
 * Asserts that a given url is HTTPS or protocol relative. It's a user-level
 * assert.
 *
 * Provides an exception for localhost.
 *
 * @param {?string|undefined} urlString
 * @param {!Element|string} elementContext Element where the url was found.
 * @param {string=} sourceName Used for error messages.
 * @return {string}
 */
function assertHttpsUrl(urlString, elementContext, sourceName) {
  if (sourceName === void 0) {
    sourceName = 'source';
  }

  (0, _log.userAssert)(urlString != null, '%s %s must be available', elementContext, sourceName);
  // (erwinm, #4560): type cast necessary until #4560 is fixed.
  var theUrlString =
  /** @type {string} */
  urlString;
  (0, _log.userAssert)(isSecureUrlDeprecated(theUrlString) || /^(\/\/)/.test(theUrlString), '%s %s must start with ' + '"https://" or "//" or be relative and served from ' + 'either https or from localhost. Invalid value: %s', elementContext, sourceName, theUrlString);
  return theUrlString;
}

/**
 * Asserts that a given url is an absolute HTTP or HTTPS URL.
 * @param {string} urlString
 * @return {string}
 */
function assertAbsoluteHttpOrHttpsUrl(urlString) {
  (0, _log.userAssert)(/^https?\:/i.test(urlString), 'URL must start with "http://" or "https://". Invalid value: %s', urlString);
  return parseUrlDeprecated(urlString).href;
}

/**
 * Parses the query string of an URL. This method returns a simple key/value
 * map. If there are duplicate keys the latest value is returned.
 *
 * This function is implemented in a separate file to avoid a circular
 * dependency.
 *
 * @param {string} queryString
 * @return {!JsonObject}
 */
function parseQueryString(queryString) {
  return (0, _urlParseQueryString.parseQueryString_)(queryString);
}

/**
 * Returns the URL without fragment. If URL doesn't contain fragment, the same
 * string is returned.
 * @param {string} url
 * @return {string}
 */
function removeFragment(url) {
  var index = url.indexOf('#');

  if (index == -1) {
    return url;
  }

  return url.substring(0, index);
}

/**
 * Returns the fragment from the URL. If the URL doesn't contain fragment,
 * the empty string is returned.
 * @param {string} url
 * @return {string}
 */
function getFragment(url) {
  var index = url.indexOf('#');

  if (index == -1) {
    return '';
  }

  return url.substring(index);
}

/**
 * Returns whether the URL has the origin of a proxy.
 * @param {string|!Location} url URL of an AMP document.
 * @return {boolean}
 */
function isProxyOrigin(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return _config.urls.cdnProxyRegex.test(url.origin);
}

/**
 * For proxy-origin URLs, returns the serving type. Otherwise, returns null.
 * E.g., 'https://amp-com.cdn.ampproject.org/a/s/amp.com/amp_document.html'
 * returns 'a'.
 * @param {string|!Location} url URL of an AMP document.
 * @return {?string}
 */
function getProxyServingType(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  if (!isProxyOrigin(url)) {
    return null;
  }

  var path = url.pathname.split('/', 2);
  return path[1];
}

/**
 * Returns whether the URL origin is localhost.
 * @param {string|!Location} url URL of an AMP document.
 * @return {boolean}
 */
function isLocalhostOrigin(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return _config.urls.localhostRegex.test(url.origin);
}

/**
 * Returns whether the URL has valid protocol.
 * Deep link protocol is valid, but not javascript etc.
 * @param {string|!Location} url
 * @return {boolean}
 */
function isProtocolValid(url) {
  if (!url) {
    return true;
  }

  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return !INVALID_PROTOCOLS.includes(url.protocol);
}

/**
 * Returns a URL without AMP JS parameters.
 * @param {string} url
 * @return {string}
 */
function removeAmpJsParamsFromUrl(url) {
  var parsed = parseUrlDeprecated(url);
  var search = removeAmpJsParamsFromSearch(parsed.search);
  return parsed.origin + parsed.pathname + search + parsed.hash;
}

/**
 * Returns a URL without a query string.
 * @param {string} url
 * @return {string}
 */
function removeSearch(url) {
  var index = url.indexOf('?');

  if (index == -1) {
    return url;
  }

  var fragment = getFragment(url);
  return url.substring(0, index) + fragment;
}

/**
 * Removes parameters that start with amp js parameter pattern and returns the
 * new search string.
 * @param {string} urlSearch
 * @return {string}
 */
function removeAmpJsParamsFromSearch(urlSearch) {
  if (!urlSearch || urlSearch == '?') {
    return '';
  }

  var search = urlSearch.replace(AMP_JS_PARAMS_REGEX, '').replace(AMP_GSA_PARAMS_REGEX, '').replace(AMP_R_PARAMS_REGEX, '').replace(AMP_KIT_PARAMS_REGEX, '').replace(GOOGLE_EXPERIMENT_PARAMS_REGEX, '').replace(/^[?&]/, '');
  // Removes first ? or &.
  return search ? '?' + search : '';
}

/**
 * Removes parameters with param name and returns the new search string.
 * @param {string} urlSearch
 * @param {string} paramName
 * @return {string}
 */
function removeParamsFromSearch(urlSearch, paramName) {
  // TODO: reuse the function in removeAmpJsParamsFromSearch. Accept paramNames
  // as an array.
  if (!urlSearch || urlSearch == '?') {
    return '';
  }

  var paramRegex = new RegExp("[?&]" + paramName + "=[^&]*", 'g');
  var search = urlSearch.replace(paramRegex, '').replace(/^[?&]/, '');
  return search ? '?' + search : '';
}

/**
 * Returns the source URL of an AMP document for documents served
 * on a proxy origin or directly.
 * @param {string|!Location} url URL of an AMP document.
 * @return {string}
 */
function getSourceUrl(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  // Not a proxy URL - return the URL itself.
  if (!isProxyOrigin(url)) {
    return url.href;
  }

  // A proxy URL.
  // Example path that is being matched here.
  // https://cdn.ampproject.org/c/s/www.origin.com/foo/
  // The /s/ is optional and signals a secure origin.
  var path = url.pathname.split('/');
  var prefix = path[1];
  (0, _log.userAssert)(SERVING_TYPE_PREFIX[prefix], 'Unknown path prefix in url %s', url.href);
  var domainOrHttpsSignal = path[2];
  var origin = domainOrHttpsSignal == 's' ? 'https://' + decodeURIComponent(path[3]) : 'http://' + decodeURIComponent(domainOrHttpsSignal);
  // Sanity test that what we found looks like a domain.
  (0, _log.userAssert)(origin.indexOf('.') > 0, 'Expected a . in origin %s', origin);
  path.splice(1, domainOrHttpsSignal == 's' ? 3 : 2);
  return origin + path.join('/') + removeAmpJsParamsFromSearch(url.search) + (url.hash || '');
}

/**
 * Returns the source origin of an AMP document for documents served
 * on a proxy origin or directly.
 * @param {string|!Location} url URL of an AMP document.
 * @return {string} The source origin of the URL.
 */
function getSourceOrigin(url) {
  return parseUrlDeprecated(getSourceUrl(url)).origin;
}

/**
 * Returns absolute URL resolved based on the relative URL and the base.
 * @param {string} relativeUrlString
 * @param {string|!Location} baseUrl
 * @return {string}
 */
function resolveRelativeUrl(relativeUrlString, baseUrl) {
  if (typeof baseUrl == 'string') {
    baseUrl = parseUrlDeprecated(baseUrl);
  }

  if (typeof URL == 'function') {
    return new URL(relativeUrlString, baseUrl.href).toString();
  }

  return resolveRelativeUrlFallback_(relativeUrlString, baseUrl);
}

/**
 * Fallback for URL resolver when URL class is not available.
 * @param {string} relativeUrlString
 * @param {string|!Location} baseUrl
 * @return {string}
 * @private @visibleForTesting
 */
function resolveRelativeUrlFallback_(relativeUrlString, baseUrl) {
  if (typeof baseUrl == 'string') {
    baseUrl = parseUrlDeprecated(baseUrl);
  }

  relativeUrlString = relativeUrlString.replace(/\\/g, '/');
  var relativeUrl = parseUrlDeprecated(relativeUrlString);

  // Absolute URL.
  if (relativeUrlString.toLowerCase().startsWith(relativeUrl.protocol)) {
    return relativeUrl.href;
  }

  // Protocol-relative URL.
  if (relativeUrlString.startsWith('//')) {
    return baseUrl.protocol + relativeUrlString;
  }

  // Absolute path.
  if (relativeUrlString.startsWith('/')) {
    return baseUrl.origin + relativeUrlString;
  }

  // Relative path.
  return baseUrl.origin + baseUrl.pathname.replace(/\/[^/]*$/, '/') + relativeUrlString;
}

/**
 * Add "__amp_source_origin" query parameter to the URL.
 * @param {!Window} win
 * @param {string} url
 * @return {string}
 */
function getCorsUrl(win, url) {
  checkCorsUrl(url);
  var sourceOrigin = getSourceOrigin(win.location.href);
  return addParamToUrl(url, SOURCE_ORIGIN_PARAM, sourceOrigin);
}

/**
 * Checks if the url has __amp_source_origin and throws if it does.
 * @param {string} url
 */
function checkCorsUrl(url) {
  var parsedUrl = parseUrlDeprecated(url);
  var query = parseQueryString(parsedUrl.search);
  (0, _log.userAssert)(!(SOURCE_ORIGIN_PARAM in query), 'Source origin is not allowed in %s', url);
}

/**
 * Tries to decode a URI component, falling back to opt_fallback (or an empty
 * string)
 *
 * @param {string} component
 * @param {string=} opt_fallback
 * @return {string}
 */
function tryDecodeUriComponent(component, opt_fallback) {
  return (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(component, opt_fallback);
}

/**
 * Adds the path to the given url.
 *
 * @param {!Location} url
 * @param {string} path
 * @return {string}
 */
function appendPathToUrl(url, path) {
  var pathname = url.pathname.replace(/\/?$/, '/') + path.replace(/^\//, '');
  return url.origin + pathname + url.search + url.hash;
}

},{"./config":7,"./log":19,"./mode":20,"./string":28,"./types":31,"./url-parse-query-string":32,"./url-try-decode-uri-component":33,"./utils/lru-cache":38,"./utils/object":39}],35:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.removeNoScriptElements = removeNoScriptElements;
exports.DomWriterBulk = exports.DomWriterStreamer = exports.DomWriter = void 0;

var _resolvedPromise3 = require("./../resolved-promise");

var _services = require("../services");

var _dom = require("../dom");

var _log = require("../log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Takes as an input a text stream, parses it and incrementally reconstructs
 * it in the new target root.
 *
 * See https://jakearchibald.com/2016/fun-hacks-faster-content/ for more
 * details.
 *
 * @interface
 * @extends {WritableStreamDefaultWriter}
 * @visibleForTesting
 */
var DomWriter = /*#__PURE__*/function () {
  function DomWriter() {
    _classCallCheck(this, DomWriter);
  }

  _createClass(DomWriter, [{
    key: "onBody",

    /**
     * Sets the callback that will be called when body has been parsed.
     *
     * For shadow use case, unlike most of other nodes, `<body>` cannot be simply
     * merged to support Shadow DOM polyfill where the use of `<body>`
     * element is not possible.
     *
     * The callback will be given the parsed document and it must return back
     * the reconstructed `<body>` node in the target DOM where all children
     * will be streamed into.
     *
     * @param {function(!Document):!Element} unusedCallback
     */
    value: function onBody(unusedCallback) {}
    /**
     * Sets the callback that will be called when new nodes have been merged
     * into the target DOM.
     * @param {function()} unusedCallback
     */

  }, {
    key: "onBodyChunk",
    value: function onBodyChunk(unusedCallback) {}
    /**
     * Sets the callback that will be called when the DOM has been fully
     * constructed.
     * @param {function()} unusedCallback
     */

  }, {
    key: "onEnd",
    value: function onEnd(unusedCallback) {}
  }]);

  return DomWriter;
}();

exports.DomWriter = DomWriter;

/**
 * Takes as an input a text stream, parses it and incrementally reconstructs
 * it in the given root.
 *
 * See https://jakearchibald.com/2016/fun-hacks-faster-content/ for more
 * details.
 *
 * @implements {DomWriter}
 * @visibleForTesting
 */
var DomWriterStreamer = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function DomWriterStreamer(win) {
    _classCallCheck(this, DomWriterStreamer);

    /** @const @private {!Document} */
    this.parser_ = win.document.implementation.createHTMLDocument('');
    this.parser_.open();

    /** @const @private */
    this.vsync_ = _services.Services.vsyncFor(win);

    /** @private @const */
    this.boundMerge_ = this.merge_.bind(this);

    /** @private {?function(!Document):!Element} */
    this.onBody_ = null;

    /** @private {?function()} */
    this.onBodyChunk_ = null;

    /** @private {?function()} */
    this.onEnd_ = null;

    /** @private {boolean} */
    this.mergeScheduled_ = false;

    /** @const @private {!Promise} */
    this.success_ = (0, _resolvedPromise3.resolvedPromise)();

    /** @private {boolean} */
    this.eof_ = false;

    /** @private {?Element} */
    this.targetBody_ = null;
  }

  /** @override */
  _createClass(DomWriterStreamer, [{
    key: "onBody",
    value: function onBody(callback) {
      this.onBody_ = callback;
    }
    /** @override */

  }, {
    key: "onBodyChunk",
    value: function onBodyChunk(callback) {
      this.onBodyChunk_ = callback;
    }
    /** @override */

  }, {
    key: "onEnd",
    value: function onEnd(callback) {
      this.onEnd_ = callback;
    }
    /** @override */

  }, {
    key: "write",
    value: function write(chunk) {
      if (this.eof_) {
        throw new Error('closed already');
      }

      if (chunk) {
        this.parser_.write(
        /** @type {string} */
        chunk);
      }

      this.schedule_();
      return this.success_;
    }
    /** @override */

  }, {
    key: "close",
    value: function close() {
      this.parser_.close();
      this.eof_ = true;
      this.schedule_();
      return this.success_;
    }
    /** @override */

  }, {
    key: "abort",
    value: function abort(unusedReason) {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "releaseLock",
    value: function releaseLock() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "schedule_",

    /** @private */
    value: function schedule_() {
      (0, _log.devAssert)(this.onBody_ && this.onBodyChunk_ && this.onEnd_);

      if (!this.mergeScheduled_) {
        this.mergeScheduled_ = true;
        this.vsync_.mutate(this.boundMerge_);
      }
    }
    /** @private */

  }, {
    key: "merge_",
    value: function merge_() {
      this.mergeScheduled_ = false;

      // Body has been newly parsed.
      if (!this.targetBody_ && this.parser_.body) {
        this.targetBody_ = this.onBody_(this.parser_);
      }

      // Merge body children.
      if (this.targetBody_) {
        var inputBody = (0, _log.dev)().assertElement(this.parser_.body);
        var targetBody = (0, _log.devAssert)(this.targetBody_);
        var transferCount = 0;
        removeNoScriptElements(inputBody);

        while (inputBody.firstChild) {
          transferCount++;
          targetBody.appendChild(inputBody.firstChild);
        }

        if (transferCount > 0) {
          this.onBodyChunk_();
        }
      }

      // EOF.
      if (this.eof_) {
        this.onEnd_();
      }
    }
  }, {
    key: "closed",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "desiredSize",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "ready",
    get: function get() {
      throw new Error('Not implemented');
    }
  }]);

  return DomWriterStreamer;
}();

exports.DomWriterStreamer = DomWriterStreamer;

/**
 * Takes as an input a text stream, aggregates it and parses it in one bulk.
 * This is a workaround against the browsers that do not support streaming DOM
 * parsing. Mainly currently Firefox.
 *
 * See https://github.com/whatwg/html/issues/2827 and
 * https://bugzilla.mozilla.org/show_bug.cgi?id=867102
 *
 * @implements {DomWriter}
 * @visibleForTesting
 */
var DomWriterBulk = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function DomWriterBulk(win) {
    _classCallCheck(this, DomWriterBulk);

    /** @private {!Array<string>} */
    this.fullHtml_ = [];

    /** @const @private */
    this.vsync_ = _services.Services.vsyncFor(win);

    /** @private {?function(!Document):!Element} */
    this.onBody_ = null;

    /** @private {?function()} */
    this.onBodyChunk_ = null;

    /** @private {?function()} */
    this.onEnd_ = null;

    /** @const @private {!Promise} */
    this.success_ = (0, _resolvedPromise3.resolvedPromise)();

    /** @private {boolean} */
    this.eof_ = false;
  }

  /** @override */
  _createClass(DomWriterBulk, [{
    key: "onBody",
    value: function onBody(callback) {
      this.onBody_ = callback;
    }
    /** @override */

  }, {
    key: "onBodyChunk",
    value: function onBodyChunk(callback) {
      this.onBodyChunk_ = callback;
    }
    /** @override */

  }, {
    key: "onEnd",
    value: function onEnd(callback) {
      this.onEnd_ = callback;
    }
    /** @override */

  }, {
    key: "write",
    value: function write(chunk) {
      (0, _log.devAssert)(this.onBody_ && this.onBodyChunk_ && this.onEnd_);

      if (this.eof_) {
        throw new Error('closed already');
      }

      if (chunk) {
        this.fullHtml_.push((0, _log.dev)().assertString(chunk));
      }

      return this.success_;
    }
    /** @override */

  }, {
    key: "close",
    value: function close() {
      var _this = this;

      (0, _log.devAssert)(this.onBody_ && this.onBodyChunk_ && this.onEnd_);
      this.eof_ = true;
      this.vsync_.mutate(function () {
        return _this.complete_();
      });
      return this.success_;
    }
    /** @override */

  }, {
    key: "abort",
    value: function abort(unusedReason) {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "releaseLock",
    value: function releaseLock() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "complete_",

    /** @private */
    value: function complete_() {
      var fullHtml = this.fullHtml_.join('');
      var doc = new DOMParser().parseFromString(fullHtml, 'text/html');

      // Merge body.
      if (doc.body) {
        var inputBody = doc.body;
        var targetBody = this.onBody_(doc);
        var transferCount = 0;
        removeNoScriptElements(inputBody);

        while (inputBody.firstChild) {
          transferCount++;
          targetBody.appendChild(inputBody.firstChild);
        }

        if (transferCount > 0) {
          this.onBodyChunk_();
        }
      }

      // EOF.
      this.onEnd_();
    }
  }, {
    key: "closed",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "desiredSize",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "ready",
    get: function get() {
      throw new Error('Not implemented');
    }
  }]);

  return DomWriterBulk;
}();

exports.DomWriterBulk = DomWriterBulk;

/**
 * Remove any noscript elements.
 *
 * According to the spec
 * (https://w3c.github.io/DOM-Parsing/#the-domparser-interface), with
 * `DOMParser().parseFromString`, contents of `noscript` get parsed as markup,
 * so we need to remove them manually. Why? ¯\_(ツ)_/¯ `createHTMLDocument()`
 * seems to behave the same way.
 *
 * @param {!Element} parent
 */
function removeNoScriptElements(parent) {
  var noscriptElements = (0, _dom.childElementsByTag)(parent, 'noscript');
  (0, _dom.iterateCursor)(noscriptElements, function (element) {
    (0, _dom.removeElement)(element);
  });
}

},{"../dom":9,"../log":19,"../services":25,"./../resolved-promise":23}],36:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.once = once;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(rsimha, #15334): Enable this rule.

/* eslint jsdoc/check-types: 0 */

/**
 * Creates a function that is evaluated only once and returns the cached result
 * subsequently.
 *
 * Please note that `once` only takes the function definition into account,
 * so it will return the same cached value even when the arguments are
 * different.
 *
 * @param {function(...):T} fn
 * @return {function(...):T}
 * @template T
 */
function once(fn) {
  var evaluated = false;
  var retValue = null;
  var callback = fn;
  return function () {
    if (!evaluated) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      retValue = callback.apply(self, args);
      evaluated = true;
      callback = null;
    }

    return retValue;
  };
}

},{}],37:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.guaranteeSrcForSrcsetUnsupportedBrowsers = guaranteeSrcForSrcsetUnsupportedBrowsers;
exports.transparentPng = transparentPng;

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Sets the img src to the first url in the srcset if srcset is defined but
 * src is not for browsers that do not support srcset.
 * @param {!Element} img
 */
function guaranteeSrcForSrcsetUnsupportedBrowsers(img) {
  // The <img> tag does not have a src and does not support srcset
  if (!img.hasAttribute('src') && 'srcset' in img == false) {
    var srcset = img.getAttribute('srcset');
    var matches = /\S+/.exec(srcset);

    if (matches == null) {
      return;
    }

    var srcseturl = matches[0];
    img.setAttribute('src', srcseturl);
  }
}

/**
 * Generates a transparent PNG of a given width/height.
 *
 * @param {!Document} doc
 * @param {number} width
 * @param {number} height
 * @return {string}
 */
function transparentPng(doc, width, height) {
  var canvas = doc.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  // Canvases are fully transparent by default, so we don't actually need to
  // draw anything.
  return canvas.toDataURL();
}

},{}],38:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.LruCache = void 0;

var _log = require("../log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} */
var TAG = 'lru-cache';

/**
 * @template T
 */
var LruCache = /*#__PURE__*/function () {
  /**
   * @param {number} capacity
   */
  function LruCache(capacity) {
    _classCallCheck(this, LruCache);

    /** @private @const {number} */
    this.capacity_ = capacity;

    /** @private {number} */
    this.size_ = 0;

    /**
     * An incrementing counter to define the last access.
     * @private {number}
     */
    this.access_ = 0;

    /** @private {!Object<(number|string), {payload: T, access: number}>} */
    this.cache_ = Object.create(null);
  }

  /**
   * Returns whether key is cached.
   *
   * @param {number|string} key
   * @return {boolean}
   */
  _createClass(LruCache, [{
    key: "has",
    value: function has(key) {
      return !!this.cache_[key];
    }
    /**
     * @param {number|string} key
     * @return {T} The cached payload.
     */

  }, {
    key: "get",
    value: function get(key) {
      var cacheable = this.cache_[key];

      if (cacheable) {
        cacheable.access = ++this.access_;
        return cacheable.payload;
      }

      return undefined;
    }
    /**
     * @param {number|string} key
     * @param {T} payload The payload to cache.
     */

  }, {
    key: "put",
    value: function put(key, payload) {
      if (!this.has(key)) {
        this.size_++;
      }

      this.cache_[key] = {
        payload: payload,
        access: this.access_
      };
      this.evict_();
    }
    /**
     * Evicts the oldest cache entry, if we've exceeded capacity.
     */

  }, {
    key: "evict_",
    value: function evict_() {
      if (this.size_ <= this.capacity_) {
        return;
      }

      (0, _log.dev)().warn(TAG, 'Trimming LRU cache');
      var cache = this.cache_;
      var oldest = this.access_ + 1;
      var oldestKey;

      for (var key in cache) {
        var access = cache[key].access;

        if (access < oldest) {
          oldest = access;
          oldestKey = key;
        }
      }

      if (oldestKey !== undefined) {
        delete cache[oldestKey];
        this.size_--;
      }
    }
  }]);

  return LruCache;
}();

exports.LruCache = LruCache;

},{"../log":19}],39:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.map = map;
exports.dict = dict;
exports.hasOwn = hasOwn;
exports.ownProperty = ownProperty;
exports.deepMerge = deepMerge;
exports.omit = omit;
exports.objectsEqualShallow = objectsEqualShallow;
exports.memo = memo;

var _types = require("../types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @const */
var hasOwn_ = Object.prototype.hasOwnProperty;

/**
 * Returns a map-like object.
 * If opt_initial is provided, copies its own properties into the
 * newly created object.
 * @param {T=} opt_initial This should typically be an object literal.
 * @return {T}
 * @template T
 */
function map(opt_initial) {
  var obj = Object.create(null);

  if (opt_initial) {
    Object.assign(obj, opt_initial);
  }

  return obj;
}

/**
 * Return an empty JsonObject or makes the passed in object literal
 * an JsonObject.
 * The JsonObject type is just a simple object that is at-dict.
 * See
 * https://github.com/google/closure-compiler/wiki/@struct-and-@dict-Annotations
 * for what a dict is type-wise.
 * The linter enforces that the argument is, in fact, at-dict like.
 * @param {!Object=} opt_initial
 * @return {!JsonObject}
 */
function dict(opt_initial) {
  // We do not copy. The linter enforces that the passed in object is a literal
  // and thus the caller cannot have a reference to it.
  return (
    /** @type {!JsonObject} */
    opt_initial || {}
  );
}

/**
 * Checks if the given key is a property in the map.
 *
 * @param {T}  obj a map like property.
 * @param {string}  key
 * @return {boolean}
 * @template T
 */
function hasOwn(obj, key) {
  return hasOwn_.call(obj, key);
}

/**
 * Returns obj[key] iff key is obj's own property (is not inherited).
 * Otherwise, returns undefined.
 *
 * @param {Object} obj
 * @param {string} key
 * @return {*}
 */
function ownProperty(obj, key) {
  if (hasOwn(obj, key)) {
    return obj[key];
  } else {
    return undefined;
  }
}

/**
 * Deep merges source into target.
 *
 * @param {!Object} target
 * @param {!Object} source
 * @param {number} depth The maximum merge depth. If exceeded, Object.assign
 *                       will be used instead.
 * @return {!Object}
 * @throws {Error} If source contains a circular reference.
 * Note: Only nested objects are deep-merged, primitives and arrays are not.
 */
function deepMerge(target, source, depth) {
  if (depth === void 0) {
    depth = 10;
  }

  // Keep track of seen objects to detect recursive references.
  var seen = [];

  /** @type {!Array<{t: !Object, s: !Object, d: number}>} */
  var queue = [];
  queue.push({
    t: target,
    s: source,
    d: 0
  });

  var _loop = function _loop() {
    var _queue$shift = queue.shift(),
        t = _queue$shift.t,
        s = _queue$shift.s,
        d = _queue$shift.d;

    if (seen.includes(s)) {
      throw new Error('Source object has a circular reference.');
    }

    seen.push(s);

    if (t === s) {
      return "continue";
    }

    if (d > depth) {
      Object.assign(t, s);
      return "continue";
    }

    Object.keys(s).forEach(function (key) {
      var newValue = s[key];

      // Perform a deep merge IFF both target and source have the same key
      // whose corresponding values are objects.
      if (hasOwn(t, key)) {
        var oldValue = t[key];

        if ((0, _types.isObject)(newValue) && (0, _types.isObject)(oldValue)) {
          queue.push({
            t: oldValue,
            s: newValue,
            d: d + 1
          });
          return;
        }
      }

      t[key] = newValue;
    });
  };

  // BFS to ensure objects don't have recursive references at shallower depths.
  while (queue.length > 0) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return target;
}

/**
 * @param {!Object} o An object to remove properties from
 * @param {!Array<string>} props A list of properties to remove from the Object
 * @return {!Object} An object with the given properties removed
 */
function omit(o, props) {
  return Object.keys(o).reduce(function (acc, key) {
    if (!props.includes(key)) {
      acc[key] = o[key];
    }

    return acc;
  }, {});
}

/**
 * @param {!Object|null|undefined} o1
 * @param {!Object|null|undefined} o2
 * @return {boolean}
 */
function objectsEqualShallow(o1, o2) {
  if (o1 == null || o2 == null) {
    // Null is only equal to null, and undefined to undefined.
    return o1 === o2;
  }

  for (var k in o1) {
    if (o1[k] !== o2[k]) {
      return false;
    }
  }

  for (var _k in o2) {
    if (o2[_k] !== o1[_k]) {
      return false;
    }
  }

  return true;
}

/**
 * @param {T} obj
 * @param {string} prop
 * @param {function(T, string):R} factory
 * @return {R}
 * @template T,R
 */
function memo(obj, prop, factory) {
  var result =
  /** @type {?R} */
  obj[prop];

  if (result === undefined) {
    result = factory(obj, prop);
    obj[prop] = result;
  }

  return result;
}

},{"../types":31}],40:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.tryResolve = tryResolve;
exports.some = some;
exports.LastAddedResolver = exports.Deferred = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a Deferred struct, which holds a pending promise and its associated
 * resolve and reject functions.
 *
 * This is preferred instead of creating a Promise instance to extract the
 * resolve/reject functions yourself:
 *
 * ```
 * // Avoid doing
 * let resolve;
 * const promise = new Promise(res => {
 *   resolve = res;
 * });
 *
 * // Good
 * const deferred = new Deferred();
 * const { promise, resolve } = deferred;
 * ```
 *
 * @template T
 */
var Deferred =
/**
 * Creates an instance of Deferred.
 */
function Deferred() {
  _classCallCheck(this, Deferred);

  var resolve, reject;

  /**
   * @const {!Promise<T>}
   */
  this.promise = new
  /*OK*/
  Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });

  /**
   * @const {function(T=)}
   */
  this.resolve = resolve;

  /**
   * @const {function(*=)}
   */
  this.reject = reject;
};

exports.Deferred = Deferred;

/**
 * Creates a promise resolved to the return value of fn.
 * If fn sync throws, it will cause the promise to reject.
 *
 * @param {function():T} fn
 * @return {!Promise<T>}
 * @template T
 */
function tryResolve(fn) {
  return new Promise(function (resolve) {
    resolve(fn());
  });
}

/**
 * Returns a promise which resolves if a threshold amount of the given promises
 * resolve, and rejects otherwise.
 * @param {!Array<!Promise>} promises The array of promises to test.
 * @param {number} count The number of promises that must resolve for the
 *     returned promise to resolve.
 * @return {!Promise} A promise that resolves if any of the given promises
 *     resolve, and which rejects otherwise.
 */
function some(promises, count) {
  if (count === void 0) {
    count = 1;
  }

  return new Promise(function (resolve, reject) {
    count = Math.max(count, 0);
    var extra = promises.length - count;

    if (extra < 0) {
      reject(new Error('not enough promises to resolve'));
    }

    if (promises.length == 0) {
      resolve([]);
    }

    var values = [];
    var reasons = [];

    var onFulfilled = function onFulfilled(value) {
      if (values.length < count) {
        values.push(value);
      }

      if (values.length == count) {
        resolve(values);
      }
    };

    var onRejected = function onRejected(reason) {
      if (reasons.length <= extra) {
        reasons.push(reason);
      }

      if (reasons.length > extra) {
        reject(reasons);
      }
    };

    for (var i = 0; i < promises.length; i++) {
      Promise.resolve(promises[i]).then(onFulfilled, onRejected);
    }
  });
}

/**
 * Resolves with the result of the last promise added.
 * @implements {IThenable}
 */
var LastAddedResolver = /*#__PURE__*/function () {
  /**
   * @param {!Array<!Promise>=} opt_promises
   */
  function LastAddedResolver(opt_promises) {
    _classCallCheck(this, LastAddedResolver);

    var resolve_, reject_;

    /** @private @const {!Promise} */
    this.promise_ = new Promise(function (resolve, reject) {
      resolve_ = resolve;
      reject_ = reject;
    });

    /** @private */
    this.resolve_ = resolve_;

    /** @private */
    this.reject_ = reject_;

    /** @private */
    this.count_ = 0;

    if (opt_promises) {
      for (var i = 0; i < opt_promises.length; i++) {
        this.add(opt_promises[i]);
      }
    }
  }

  /**
   * Add a promise to possibly be resolved.
   * @param {!Promise} promise
   * @return {!Promise}
   */
  _createClass(LastAddedResolver, [{
    key: "add",
    value: function add(promise) {
      var _this = this;

      var countAtAdd = ++this.count_;
      Promise.resolve(promise).then(function (result) {
        if (_this.count_ === countAtAdd) {
          _this.resolve_(result);
        }
      }, function (error) {
        // Don't follow behavior of Promise.all and Promise.race error so that
        // this will only reject when most recently added promise fails.
        if (_this.count_ === countAtAdd) {
          _this.reject_(error);
        }
      });
      return this.promise_;
    }
    /** @override */

  }, {
    key: "then",
    value: function then(opt_resolve, opt_reject) {
      return this.promise_.then(opt_resolve, opt_reject);
    }
  }]);

  return LastAddedResolver;
}();

exports.LastAddedResolver = LastAddedResolver;

},{}],41:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.setShadowDomSupportedVersionForTesting = setShadowDomSupportedVersionForTesting;
exports.setShadowCssSupportedForTesting = setShadowCssSupportedForTesting;
exports.isShadowDomSupported = isShadowDomSupported;
exports.isShadowCssSupported = isShadowCssSupported;
exports.getShadowDomSupportedVersion = getShadowDomSupportedVersion;
exports.ShadowDomVersion = void 0;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Possible versions of Shadow DOM spec
 * @const
 * @enum {string}
 */
var ShadowDomVersion = {
  NONE: 'none',
  V0: 'v0',
  V1: 'v1'
};
exports.ShadowDomVersion = ShadowDomVersion;

/**
 * @type {ShadowDomVersion|undefined}
 * @visibleForTesting
 */
var shadowDomSupportedVersion;

/**
 * @type {boolean|undefined}
 * @visibleForTesting
 */
var shadowCssSupported;

/**
 * @param {ShadowDomVersion|undefined} val
 * @visibleForTesting
 */
function setShadowDomSupportedVersionForTesting(val) {
  shadowDomSupportedVersion = val;
}

/**
 * @param {boolean|undefined} val
 * @visibleForTesting
 */
function setShadowCssSupportedForTesting(val) {
  shadowCssSupported = val;
}

/**
 * Returns `true` if the Shadow DOM is supported.
 * @return {boolean}
 */
function isShadowDomSupported() {
  return getShadowDomSupportedVersion() != ShadowDomVersion.NONE;
}

/**
 * Returns `true` if Shadow CSS encapsulation is supported.
 * @return {boolean}
 */
function isShadowCssSupported() {
  if (shadowCssSupported === undefined) {
    shadowCssSupported = isShadowDomSupported() && (isNative(Element.prototype.attachShadow) || isNative(Element.prototype.createShadowRoot));
  }

  return shadowCssSupported;
}

/**
 * Returns `true` if the passed function is native to the browser, and is not
 * polyfilled
 * @param {Function|undefined} func A function that is attatched to a JS
 * object.
 * @return {boolean}
 */
function isNative(func) {
  return !!func && func.toString().indexOf('[native code]') != -1;
}

/**
 * Returns the supported version of Shadow DOM spec.
 * @param {?typeof Element=} opt_elementClass optional for testing
 * @return {ShadowDomVersion}
 */
function getShadowDomSupportedVersion(opt_elementClass) {
  if (shadowDomSupportedVersion === undefined) {
    shadowDomSupportedVersion = getShadowDomVersion(opt_elementClass || Element);
  }

  return shadowDomSupportedVersion;
}

/**
 * Returns shadow dom version.
 *
 * @param {?typeof Element=} element
 * @return {ShadowDomVersion}
 */
function getShadowDomVersion(element) {
  if (!!element.prototype.attachShadow) {
    return ShadowDomVersion.V1;
  } else if (!!element.prototype.createShadowRoot) {
    return ShadowDomVersion.V0;
  }

  return ShadowDomVersion.NONE;
}

},{}],42:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.cssEscape = cssEscape;

/*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license */

/**
 * This regex consists of 4 matching capture groups and one (non-matching) fallback:
 *
 * - (\0), catch the null terminator character so it may be replaced by UTF
 *   Replacement Char
 * - ^(-)$, catch a solitary dash char, so that it may be backslash escaped.
 *   This is a separate capture group so that the legal-chars (group 4) doesn't
 *   capture it first, since that group doesn't need to escape its dash.
 * - ([\x01-\x1f\x7f]|^-?[0-9]), catch a UTF control char, or any leading
 *   number (with an optional leading dash). The control or the number (but not
 *   the leading dash) must be hex-escaped,.
 * - ([\x80-\uffff0-9a-zA-Z_-]+), catch legal-chars, with the exception of a
 *   solitary dash, which will already have matched in group 1.
 * - [^], finally, a catch-all that allows us to backslash escape the char.
 *
 * Together, this matches everything necessary for CSS.escape.
 */
var regex = /(\0)|^(-)$|([\x01-\x1f\x7f]|^-?[0-9])|([\x80-\uffff0-9a-zA-Z_-]+)|[^]/g;

function escaper(match, nil, dash, hexEscape, chars) {
  // Chars is the legal-chars (group 4) capture
  if (chars) {
    return chars;
  }

  // Nil is the null terminator (group 1) capture
  if (nil) {
    return "\uFFFD";
  }

  // Both UTF control chars, and leading numbers (with optional leading dash)
  // (group 3) must be backslash escaped with a trailing space.  Funnily, the
  // leading dash must not be escaped, but the number. :shrug:
  if (hexEscape) {
    return match.slice(0, -1) + '\\' + match.slice(-1).charCodeAt(0).toString(16) + ' ';
  }

  // Finally, the solitary dash and the catch-all chars require backslash
  // escaping.
  return '\\' + match;
}

/**
 * https://drafts.csswg.org/cssom/#serialize-an-identifier
 * @param {string} value
 * @return {string}
 */
function cssEscape(value) {
  return String(value).replace(regex, escaper);
}

},{}],43:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ShadowCSS = void 0;

/**
* @license
* Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
* Use of this source code is governed by a BSD-style
* license that can be found in the LICENSE file or at
* https://developers.google.com/open-source/licenses/bsd */

/*
  This is a limited shim for ShadowDOM css styling.
  https://dvcs.w3.org/hg/webcomponents/raw-file/tip/spec/shadow/index.html#styles

  The intention here is to support only the styling features which can be
  relatively simply implemented. The goal is to allow users to avoid the
  most obvious pitfalls and do so without compromising performance significantly.
  For ShadowDOM styling that's not covered here, a set of best practices
  can be provided that should allow users to accomplish more complex styling.

  The following is a list of specific ShadowDOM styling features and a brief
  discussion of the approach used to shim.

  Shimmed features:

  * :host, :host-context: ShadowDOM allows styling of the shadowRoot's host
  element using the :host rule. To shim this feature, the :host styles are
  reformatted and prefixed with a given scope name and promoted to a
  document level stylesheet.
  For example, given a scope name of .foo, a rule like this:

    :host {
        background: red;
      }
    }

  becomes:

    .foo {
      background: red;
    }

  * encapsultion: Styles defined within ShadowDOM, apply only to
  dom inside the ShadowDOM. Polymer uses one of two techniques to imlement
  this feature.

  By default, rules are prefixed with the host element tag name
  as a descendant selector. This ensures styling does not leak out of the 'top'
  of the element's ShadowDOM. For example,

  div {
      font-weight: bold;
    }

  becomes:

  x-foo div {
      font-weight: bold;
    }

  becomes:


  Alternatively, if WebComponents.ShadowCSS.strictStyling is set to true then
  selectors are scoped by adding an attribute selector suffix to each
  simple selector that contains the host element tag name. Each element
  in the element's ShadowDOM template is also given the scope attribute.
  Thus, these rules match only elements that have the scope attribute.
  For example, given a scope name of x-foo, a rule like this:

    div {
      font-weight: bold;
    }

  becomes:

    div[x-foo] {
      font-weight: bold;
    }

  Note that elements that are dynamically added to a scope must have the scope
  selector added to them manually.

  * upper/lower bound encapsulation: Styles which are defined outside a
  shadowRoot should not cross the ShadowDOM boundary and should not apply
  inside a shadowRoot.

  This styling behavior is not emulated. Some possible ways to do this that
  were rejected due to complexity and/or performance concerns include: (1) reset
  every possible property for every possible selector for a given scope name;
  (2) re-implement css in javascript.

  As an alternative, users should make sure to use selectors
  specific to the scope in which they are working.

  * ::distributed: This behavior is not emulated. It's often not necessary
  to style the contents of a specific insertion point and instead, descendants
  of the host element can be styled selectively. Users can also create an
  extra node around an insertion point and style that node's contents
  via descendent selectors. For example, with a shadowRoot like this:

    <style>
      ::content(div) {
        background: red;
      }
    </style>
    <content></content>

  could become:

    <style>
      / *@polyfill .content-container div * /
      ::content(div) {
        background: red;
      }
    </style>
    <div class="content-container">
      <content></content>
    </div>

  Note the use of @polyfill in the comment above a ShadowDOM specific style
  declaration. This is a directive to the styling shim to use the selector
  in comments in lieu of the next selector when running under polyfill.
*/
var ShadowCSS = {
  strictStyling: false,
  // change a selector like 'div' to 'name div'

  /** @this {ShadowCSS} */
  scopeRules: function scopeRules(cssRules, scopeSelector, opt_transformer) {
    var cssText = '';

    if (cssRules) {
      Array.prototype.forEach.call(cssRules, function (rule) {
        if (rule.selectorText && rule.style && rule.style.cssText !== undefined) {
          cssText += this.scopeSelector(rule.selectorText, scopeSelector, this.strictStyling, opt_transformer) + ' {\n\t';
          cssText += this.propertiesFromRule(rule) + '\n}\n\n';
        } else if (rule.type === CSSRule.MEDIA_RULE) {
          cssText += '@media ' + rule.media.mediaText + ' {\n';
          cssText += this.scopeRules(rule.cssRules, scopeSelector);
          cssText += '\n}\n\n';
        } else {
          // KEYFRAMES_RULE in IE throws when we query cssText
          // when it contains a -webkit- property.
          // if this happens, we fallback to constructing the rule
          // from the CSSRuleSet
          // https://connect.microsoft.com/IE/feedbackdetail/view/955703/accessing-csstext-of-a-keyframe-rule-that-contains-a-webkit-property-via-cssom-generates-exception
          try {
            if (rule.cssText) {
              cssText += rule.cssText + '\n\n';
            }
          } catch (x) {
            if (rule.type === CSSRule.KEYFRAMES_RULE && rule.cssRules) {
              cssText += this.ieSafeCssTextFromKeyFrameRule(rule);
            }
          }
        }
      }, this);
    }

    return cssText;
  },

  /** @this {ShadowCSS} */
  ieSafeCssTextFromKeyFrameRule: function ieSafeCssTextFromKeyFrameRule(rule) {
    var cssText = '@keyframes ' + rule.name + ' {';
    Array.prototype.forEach.call(rule.cssRules, function (rule) {
      cssText += ' ' + rule.keyText + ' {' + rule.style.cssText + '}';
    });
    cssText += ' }';
    return cssText;
  },

  /** @this {ShadowCSS} */
  scopeSelector: function scopeSelector(selector, _scopeSelector, strict, opt_transformer) {
    var r = [],
        parts = selector.split(',');
    parts.forEach(function (p) {
      p = p.trim();

      if (opt_transformer) {
        p = opt_transformer(p);
      }

      if (this.selectorNeedsScoping(p, _scopeSelector)) {
        p = strict && !p.match(polyfillHostNoCombinator) ? this.applyStrictSelectorScope(p, _scopeSelector) : this.applySelectorScope(p, _scopeSelector);
      }

      r.push(p);
    }, this);
    return r.join(', ');
  },

  /** @this {ShadowCSS} */
  selectorNeedsScoping: function selectorNeedsScoping(selector, scopeSelector) {
    if (Array.isArray(scopeSelector)) {
      return true;
    }

    var re = this.makeScopeMatcher(scopeSelector);
    return !selector.match(re);
  },

  /** @this {ShadowCSS} */
  makeScopeMatcher: function makeScopeMatcher(scopeSelector) {
    scopeSelector = scopeSelector.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
    return new RegExp('^(' + scopeSelector + ')' + selectorReSuffix, 'm');
  },

  /** @this {ShadowCSS} */
  applySelectorScope: function applySelectorScope(selector, selectorScope) {
    return Array.isArray(selectorScope) ? this.applySelectorScopeList(selector, selectorScope) : this.applySimpleSelectorScope(selector, selectorScope);
  },
  // apply an array of selectors

  /** @this {ShadowCSS} */
  applySelectorScopeList: function applySelectorScopeList(selector, scopeSelectorList) {
    var r = [];

    for (var i = 0, s; s = scopeSelectorList[i]; i++) {
      r.push(this.applySimpleSelectorScope(selector, s));
    }

    return r.join(', ');
  },
  // scope via name and [is=name]

  /** @this {ShadowCSS} */
  applySimpleSelectorScope: function applySimpleSelectorScope(selector, scopeSelector) {
    if (selector.match(polyfillHostRe)) {
      selector = selector.replace(polyfillHostNoCombinator, scopeSelector);
      return selector.replace(polyfillHostRe, scopeSelector + ' ');
    } else {
      return scopeSelector + ' ' + selector;
    }
  },
  // return a selector with [name] suffix on each simple selector
  // e.g. .foo.bar > .zot becomes .foo[name].bar[name] > .zot[name]

  /** @this {ShadowCSS} */
  applyStrictSelectorScope: function applyStrictSelectorScope(selector, scopeSelector) {
    scopeSelector = scopeSelector.replace(/\[is=([^\]]*)\]/g, '$1');
    var splits = [' ', '>', '+', '~'],
        scoped = selector,
        attrName = '[' + scopeSelector + ']';
    splits.forEach(function (sep) {
      var parts = scoped.split(sep);
      scoped = parts.map(function (p) {
        // remove :host since it should be unnecessary
        var t = p.trim().replace(polyfillHostRe, '');

        if (t && splits.indexOf(t) < 0 && t.indexOf(attrName) < 0) {
          p = t.replace(/([^:]*)(:*)(.*)/, '$1' + attrName + '$2$3');
        }

        return p;
      }).join(sep);
    });
    return scoped;
  },

  /** @this {ShadowCSS} */
  propertiesFromRule: function propertiesFromRule(rule) {
    var cssText = rule.style.cssText;

    // TODO(sorvell): Safari cssom incorrectly removes quotes from the content
    // property. (https://bugs.webkit.org/show_bug.cgi?id=118045)
    // don't replace attr rules
    if (rule.style.content && !rule.style.content.match(/['"]+|attr/)) {
      cssText = cssText.replace(/content:[^;]*;/g, 'content: \'' + rule.style.content + '\';');
    }

    // TODO(sorvell): we can workaround this issue here, but we need a list
    // of troublesome properties to fix https://github.com/Polymer/platform/issues/53
    //
    // inherit rules can be omitted from cssText
    // TODO(sorvell): remove when Blink bug is fixed:
    // https://code.google.com/p/chromium/issues/detail?id=358273
    var style = rule.style;

    for (var i in style) {
      if (style[i] === 'initial') {
        cssText += i + ': initial; ';
      }
    }

    return cssText;
  }
};
exports.ShadowCSS = ShadowCSS;
var selectorRe = /([^{]*)({[\s\S]*?})/gim,
    cssCommentRe = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//gim,
    // TODO(sorvell): remove either content or comment
cssCommentNextSelectorRe = /\/\*\s*@polyfill ([^*]*\*+([^/*][^*]*\*+)*\/)([^{]*?){/gim,
    cssContentNextSelectorRe = /polyfill-next-selector[^}]*content\:[\s]*?['"](.*?)['"][;\s]*}([^{]*?){/gim,
    // TODO(sorvell): remove either content or comment
cssCommentRuleRe = /\/\*\s@polyfill-rule([^*]*\*+([^/*][^*]*\*+)*)\//gim,
    cssContentRuleRe = /(polyfill-rule)[^}]*(content\:[\s]*['"](.*?)['"])[;\s]*[^}]*}/gim,
    // TODO(sorvell): remove either content or comment
cssCommentUnscopedRuleRe = /\/\*\s@polyfill-unscoped-rule([^*]*\*+([^/*][^*]*\*+)*)\//gim,
    cssContentUnscopedRuleRe = /(polyfill-unscoped-rule)[^}]*(content\:[\s]*['"](.*?)['"])[;\s]*[^}]*}/gim,
    cssPseudoRe = /::(x-[^\s{,(]*)/gim,
    cssPartRe = /::part\(([^)]*)\)/gim,
    // note: :host pre-processed to -shadowcsshost.
polyfillHost = '-shadowcsshost',
    // note: :host-context pre-processed to -shadowcsshostcontext.
polyfillHostContext = '-shadowcsscontext',
    parenSuffix = ')(?:\\((' + '(?:\\([^)(]*\\)|[^)(]*)+?' + ')\\))?([^,{]*)';
var cssColonHostRe = new RegExp('(' + polyfillHost + parenSuffix, 'gim'),
    cssColonHostContextRe = new RegExp('(' + polyfillHostContext + parenSuffix, 'gim'),
    selectorReSuffix = '([>\\s~+\[.,{:][\\s\\S]*)?$',
    colonHostRe = /\:host/gim,
    colonHostContextRe = /\:host-context/gim,

/* host name without combinator */
polyfillHostNoCombinator = polyfillHost + '-no-combinator',
    polyfillHostRe = new RegExp(polyfillHost, 'gim'),
    polyfillHostContextRe = new RegExp(polyfillHostContext, 'gim'),
    shadowDOMSelectorsRe = [/>>>/g, /::shadow/g, /::content/g, // Deprecated selectors
/\/deep\//g, // former >>>
/\/shadow\//g, // former ::shadow
/\/shadow-deep\//g, // former /deep/
/\^\^/g, // former /shadow/
/\^(?!=)/g // former /shadow-deep/
];

},{}],44:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Renderer = exports.Matrix = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// (c) Yasuhiro Fujii <y-fujii at mimosa-pudica.net>, under MIT License.
// Refactored and trimmed off for AMP project needs.
var SHADERS = {
  fragSourceCommon: "\n    #ifdef GL_FRAGMENT_PRECISION_HIGH\n      precision highp   float;\n    #else\n      precision mediump float;\n    #endif\n\n    const   float     pi = 3.14159265359;\n    uniform float     uPxSize;\n    uniform mat3      uRot;\n    uniform sampler2D uTex;\n    varying vec2      vPos;\n\n    vec4 sample(float dx, float dy) {\n      vec3 q = vec3(vPos + uPxSize * vec2(dx, dy), -1.0);\n      vec3 dir = normalize(uRot * q);\n      float u = (-0.5 / pi) * atan(dir[1], dir[0]) + 0.5;\n      float v = (1.0 / pi) * acos(dir[2]);\n      return texture2D(uTex, vec2(u, v));\n    }\n  ",
  fragSourceFast: "\n    void main() {\n      gl_FragColor = sample(0.0, 0.0);\n    }\n  ",
  fragSourceSlow: "\n    vec4 sampleSq(float dx, float dy) {\n      vec4 s = sample(dx, dy);\n      return vec4(s.xyz * s.xyz, s.w);\n    }\n\n    void main() {\n      // (2, 3) halton vector sequences.\n      vec4 acc = (1.0 / 16.0) * (\n        (((sampleSq(1.0 / 2.0 - 0.5,  1.0 / 3.0 - 0.5) +\n           sampleSq(1.0 / 4.0 - 0.5,  2.0 / 3.0 - 0.5)) +\n          (sampleSq(3.0 / 4.0 - 0.5,  1.0 / 9.0 - 0.5) +\n           sampleSq(1.0 / 8.0 - 0.5,  4.0 / 9.0 - 0.5))) +\n         ((sampleSq(5.0 / 8.0 - 0.5,  7.0 / 9.0 - 0.5) +\n           sampleSq(3.0 / 8.0 - 0.5,  2.0 / 9.0 - 0.5)) +\n          (sampleSq(7.0 / 8.0 - 0.5,  5.0 / 9.0 - 0.5) +\n           sampleSq(1.0 / 16.0 - 0.5,  8.0 / 9.0 - 0.5)))) +\n        (((sampleSq(9.0 / 16.0 - 0.5,  1.0 / 27.0 - 0.5) +\n           sampleSq(5.0 / 16.0 - 0.5, 10.0 / 27.0 - 0.5)) +\n          (sampleSq(13.0 / 16.0 - 0.5, 19.0 / 27.0 - 0.5) +\n           sampleSq(3.0 / 16.0 - 0.5,  4.0 / 27.0 - 0.5))) +\n         ((sampleSq(11.0 / 16.0 - 0.5, 13.0 / 27.0 - 0.5) +\n           sampleSq(7.0 / 16.0 - 0.5, 22.0 / 27.0 - 0.5)) +\n          (sampleSq(15.0 / 16.0 - 0.5,  7.0 / 27.0 - 0.5) +\n           sampleSq(1.0 / 32.0 - 0.5, 16.0 / 27.0 - 0.5))))\n     );\n      gl_FragColor = vec4(sqrt(acc.xyz), acc.w);\n    }\n  ",
  vertSource: "\n    uniform   vec2 uScale;\n    attribute vec2 aPos;\n    varying   vec2 vPos;\n\n    void main() {\n      gl_Position = vec4(aPos, 0.0, 1.0);\n      vPos = uScale * aPos;\n    }\n  "
};

var Matrix = /*#__PURE__*/function () {
  function Matrix() {
    _classCallCheck(this, Matrix);
  }

  _createClass(Matrix, null, [{
    key: "mul",
    value: function mul(n, x, y) {
      console.assert(x.length == n * n && y.length == n * n);
      var z = new Float32Array(n * n);

      for (var i = 0; i < n; ++i) {
        for (var j = 0; j < n; ++j) {
          var sum = 0.0;

          for (var k = 0; k < n; ++k) {
            sum += x[i * n + k] * y[k * n + j];
          }

          z[i * n + j] = sum;
        }
      }

      return z;
    }
  }, {
    key: "identity",
    value: function identity(n) {
      var z = new Float32Array(n * n);
      z.fill(0.0);

      for (var i = 0; i < n; ++i) {
        z[i * n + i] = 1.0;
      }

      return z;
    }
  }, {
    key: "rotation",
    value: function rotation(n, i, j, arg) {
      console.assert(i < n && j < n);
      var z = Matrix.identity(n);
      var cos = Math.cos(arg);
      var sin = Math.sin(arg);
      z[i * n + i] = +cos;
      z[i * n + j] = -sin;
      z[j * n + i] = +sin;
      z[j * n + j] = +cos;
      return z;
    }
  }]);

  return Matrix;
}();

exports.Matrix = Matrix;
;

var Renderer = /*#__PURE__*/function () {
  function Renderer(canvas) {
    _classCallCheck(this, Renderer);

    var params = {
      alpha: true,
      depth: false,
      stencil: false,
      antialias: false,
      premultipliedAlpha: true
    };
    this.gl = canvas.getContext('webgl', params) || canvas.getContext('experimental-webgl', params);
    this.canvas = canvas;
    this.rotation = null;
    this.scale = 1;
    this.orientation = null;
    this.vertShader = null;
    this.fragShaderFast = null;
    this.fragShaderSlow = null;
    this.progFast = null;
    this.progSlow = null;
    this.vbo = null;
    this.tex = null;
  }

  _createClass(Renderer, [{
    key: "init",
    value: function init() {
      var gl = this.gl;
      this.vertShader = gl.createShader(gl.VERTEX_SHADER);
      this.fragShaderFast = gl.createShader(gl.FRAGMENT_SHADER);
      this.fragShaderSlow = gl.createShader(gl.FRAGMENT_SHADER);
      this.progFast = gl.createProgram();
      this.progSlow = gl.createProgram();
      this.compile_(this.vertShader, SHADERS.vertSource);
      gl.attachShader(this.progFast, this.vertShader);
      gl.attachShader(this.progFast, this.fragShaderFast);
      gl.attachShader(this.progSlow, this.vertShader);
      gl.attachShader(this.progSlow, this.fragShaderSlow);
      this.setMapping();
      this.setCamera(Matrix.identity(3), 1.0);
      this.vbo = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, this.vbo);
      var vertices = new Float32Array([-1.0, -1.0, +1.0, -1.0, -1.0, +1.0, +1.0, +1.0]);
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
      this.tex = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, this.tex);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.bindBuffer(gl.ARRAY_BUFFER, null);
      this.resize();
    }
  }, {
    key: "setImage",
    value: function setImage(img) {
      var gl = this.gl;
      gl.bindTexture(gl.TEXTURE_2D, this.tex);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
      gl.bindTexture(gl.TEXTURE_2D, null);
    }
  }, {
    key: "setImageOrientation",
    value: function setImageOrientation(heading, pitch, roll) {
      if (heading === void 0) {
        heading = 0;
      }

      if (pitch === void 0) {
        pitch = 0;
      }

      if (roll === void 0) {
        roll = 0;
      }

      var RAD = Math.PI / 180;
      this.orientation = this.euler_(RAD * heading, RAD * pitch, RAD * roll);
    }
  }, {
    key: "setMapping",
    value: function setMapping(code) {
      if (code === void 0) {
        code = '';
      }

      this.compile_(this.fragShaderFast, SHADERS.fragSourceCommon + SHADERS.fragSourceFast + code);
      this.compile_(this.fragShaderSlow, SHADERS.fragSourceCommon + SHADERS.fragSourceSlow + code);
      this.link_(this.progFast);
      this.link_(this.progSlow);
    }
  }, {
    key: "setCamera",
    value: function setCamera(rot, scale) {
      this.rotation = rot;
      this.scale = scale;
    }
  }, {
    key: "resize",
    value: function resize() {
      var rect = this.canvas.getBoundingClientRect();
      this.canvas.width = rect.width * devicePixelRatio;
      this.canvas.height = rect.height * devicePixelRatio;
      this.gl.viewport(0.0, 0.0, this.canvas.width, this.canvas.height);
    }
  }, {
    key: "render",
    value: function render(fast) {
      var gl = this.gl;
      gl.disable(gl.BLEND);
      var prog = fast ? this.progFast : this.progSlow;
      gl.useProgram(prog);
      var f = this.scale / Math.sqrt(gl.drawingBufferWidth * gl.drawingBufferHeight);
      var sx = f * gl.drawingBufferWidth;
      var sy = f * gl.drawingBufferHeight;
      gl.uniformMatrix3fv(gl.getUniformLocation(prog, 'uRot'), false, this.rotation);
      gl.uniform2f(gl.getUniformLocation(prog, 'uScale'), sx, sy);
      gl.uniform1f(gl.getUniformLocation(prog, 'uPxSize'), 2.0 * f);

      if (!this.orientation) {
        this.orientation = Matrix.identity(3);
      }

      gl.uniformMatrix3fv(gl.getUniformLocation(prog, 'uRot'), false, Matrix.mul(3, this.rotation, this.orientation));
      gl.enableVertexAttribArray(0);
      gl.bindBuffer(gl.ARRAY_BUFFER, this.vbo);
      gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, this.tex);
      gl.uniform1i(gl.getUniformLocation(prog, 'uTex'), 0);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.bindBuffer(gl.ARRAY_BUFFER, null);
      gl.useProgram(null);
    }
    /** @private */

  }, {
    key: "compile_",
    value: function compile_(shader, src) {
      var gl = this.gl;
      gl.shaderSource(shader, src);
      gl.compileShader(shader);
      var log = gl.getShaderInfoLog(shader);

      if (log.length > 0) {
        console.log(log);
      }
    }
    /** @private */

  }, {
    key: "link_",
    value: function link_(prog) {
      var gl = this.gl;
      gl.linkProgram(prog);
      var log = gl.getProgramInfoLog(prog);

      if (log.length > 0) {
        console.log(log);
      }
    }
    /** @private */

  }, {
    key: "euler_",
    value: function euler_(heading, pitch, roll) {
      var te = Matrix.identity(3);
      var x = -roll,
          y = -pitch,
          z = -heading;
      var a = Math.cos(x),
          b = Math.sin(x);
      var c = Math.cos(y),
          d = Math.sin(y);
      var e = Math.cos(z),
          f = Math.sin(z);
      var ae = a * e,
          af = a * f,
          be = b * e,
          bf = b * f;
      te[0] = c * e;
      te[3] = -c * f;
      te[6] = d;
      te[1] = af + be * d;
      te[4] = ae - bf * d;
      te[7] = -b * c;
      te[2] = bf - ae * d;
      te[5] = be + af * d;
      te[8] = a * c;
      return te;
    }
  }]);

  return Renderer;
}();

exports.Renderer = Renderer;

},{}]},{},[2])

